import "intersection-observer";
import { _ as e, B as n, C as a, P as i, a as c, b as d, c as m, R as g, t as f, d as b, e as E, f as C, g as A, u as B, h as Y, i as W, A as j, j as V, E as X, k as U, l as q, m as Z, n as _, q as $, o as ee, p as te, r as ne, T as re, s as ae, v as oe, I as ie, w as le, L as ce, F as se, x as de, y as ue } from "./react-bricks-40993057.esm.js";
export { F as File, I as Image, L as Link, D as PageViewer, P as Plain, G as Preview, z as ReactBricks, R as ReactBricksContext, w as Repeater, s as RichText, v as RichTextExt, T as Text, o as blockPluginConstructor, l as cleanPage, N as fetchPage, O as fetchPages, Q as fetchTags, S as getPagePlainText, p as markPluginConstructor, r as plugins, t as types, x as useAdminContext, k as usePage, H as usePagePublic, h as usePageValues, u as usePages, J as usePagesPublic, M as useReactBricksContext, K as useTagsPublic, y as useVisualEdit } from "./react-bricks-40993057.esm.js";
import me from "is-hotkey";
import * as pe from "react";
import ge, { useMemo as fe, useContext as be, useEffect as he, useCallback as xe, useRef as ve, useState as ye, Fragment as we } from "react";
import { Transforms as ke, Text as Ee, createEditor as Ce, Range as Ae, Editor as Ne, Element as Se } from "slate";
import { withHistory as Ie } from "slate-history";
import { withReact as Le, Slate as ze, Editable as Be, useSlate as Pe, ReactEditor as De } from "slate-react";
import Te from "@tippyjs/react";
import { FaBold as Re, FaItalic as Me, FaCode as Oe, FaHighlighter as Fe, FaLink as Ye, FaQuoteRight as We, FaListOl as je, FaListUl as Ve } from "react-icons/fa";
import { MdLooksOne as Xe, MdLooksTwo as Ue, MdLooks3 as He, MdLooks4 as Je, MdLooks5 as Ke, MdLooks6 as Qe, MdDesktopMac as qe, MdTabletMac as Ze, MdSmartphone as Ge } from "react-icons/md";
import _e from "classnames";
import { useDropzone as $e } from "react-dropzone";
import et from "react-modal";
import { useMutation as tt, useQueryClient as nt, useQuery as rt } from "react-query";
import at from "axios";
import ot from "rb-cogo-toast";
import it from "date-fns/isBefore";
import lt from "date-fns/isAfter";
import ct from "date-fns/format";
import { FiSearch as st, FiChevronDown as dt, FiChevronRight as ut, FiCheck as mt, FiX as pt, FiLock as gt, FiUnlock as ft, FiEyeOff as bt, FiCalendar as ht, FiAlertTriangle as xt, FiMinimize2 as vt, FiMenu as yt, FiEye as wt, FiMoon as kt, FiShare2 as Et, FiMaximize2 as Ct, FiSettings as At, FiPlus as Nt, FiCopy as St, FiChevronUp as It, FiArrowUp as Lt, FiArrowDown as zt, FiTrash2 as Bt, FiGrid as Pt, FiBox as Dt, FiFile as Tt, FiShoppingCart as Rt, FiUsers as Mt, FiCpu as Ot, FiGlobe as Ft, FiClock as Yt, FiUmbrella as Wt, FiPower as jt, FiInfo as Vt } from "react-icons/fi";
import { VscNewFile as Xt } from "react-icons/vsc";
import { v4 as Ut } from "uuid";
export { v4 as uuid } from "uuid";
import Ht from "lodash.debounce";
import Jt from "rc-switch";
import Kt from "copy-to-clipboard";
import Qt from "react-copy-to-clipboard";
import { ErrorBoundary as qt } from "react-error-boundary";
import Zt from "react-dom";
import { AiOutlineDelete as Gt } from "react-icons/ai";
import _t from "color";
import $t from "date-fns/getDay";
import en from "date-fns/locale/en-GB";
import tn from "date-fns/compareAsc";
import nn from "date-fns/parse";
import rn from "date-fns/startOfWeek";
import { dateFnsLocalizer as an, Calendar as on } from "react-big-calendar";

var ln = pe.createContext({
  isAdmin: !1,
  currentPage: {
    pageId: ""
  },
  setCurrentPage: function setCurrentPage() {},
  previewMode: !1,
  setPreviewMode: function setPreviewMode() {},
  sidebarCollapsed: !1,
  setSidebarCollapsed: function setSidebarCollapsed() {},
  getStyles: function getStyles() {
    return [];
  },
  getStylesheets: function getStylesheets() {
    return [];
  }
}),
    cn = function cn(t) {
  var n = t.normalizeNode;
  return t.normalizeNode = function (r) {
    var a = e(r, 2),
        o = a[0],
        i = a[1];
    return 0 === i.length && t.children.length > 1 && ke.mergeNodes(t), n([o, i]);
  }, t;
},
    sn = function sn(e, t, n) {
  if (Ee.isText(e)) {
    var r = un(e.text);
    return t.filter(function (e) {
      return "Mark" === e.type;
    }).reduce(function (t, n) {
      return e[n.name] ? n.renderLeaf({
        children: t
      }) : t;
    }, r);
  }

  var a = t.filter(function (e) {
    return "List" === e.type;
  }).find(function (t) {
    return e.type === t.name;
  });

  if (a) {
    var o = dn(e, t);
    return a.renderElement({
      children: o.map(function (e, t) {
        return pe.createElement(pe.Fragment, {
          key: t
        }, a.renderItemElement({
          children: e
        }));
      }),
      element: {
        url: e.url
      }
    });
  }

  var i = dn(e, t, n),
      l = t.filter(function (e) {
    return "Block" === e.type;
  }).find(function (t) {
    return e.type === t.name;
  });
  return l ? l.renderElement({
    children: i,
    element: {
      url: e.url
    }
  }) : n ? n({
    children: i,
    element: {
      type: "",
      children: []
    },
    attributes: {
      ref: null
    }
  }) : i;
},
    dn = function dn(e, t, n) {
  var r;
  return null === (r = e.children) || void 0 === r ? void 0 : r.map(function (e, r) {
    return pe.createElement(pe.Fragment, {
      key: r
    }, sn(e, t, n));
  });
},
    un = function un(e) {
  var t = null == e ? void 0 : e.replace(/\n/g, "<|BR|>\n<|BR|>").split("<|BR|>");
  if (t) return 1 === t.length ? e : pe.createElement(pe.Fragment, null, t.map(function (e, t, n) {
    return "\n" === e && n.length === t + 1 || "\n" === e && n.length === t + 2 && "" === n[n.length - 1] ? pe.createElement(pe.Fragment, {
      key: t
    }, pe.createElement("br", null), " ") : "\n" === e ? pe.createElement("br", null) : pe.createElement(pe.Fragment, {
      key: t
    }, e);
  }));
},
    mn = [{
  type: "paragraph",
  children: [{
    text: "New text"
  }]
}],
    pn = "undefined" != typeof window && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform),
    gn = function gn(e) {
  var t = e.rtRef,
      n = e.plugins,
      r = e.blockRef,
      a = Pe(),
      o = a.selection;
  if (!o || !De.isFocused(a) || Ae.isCollapsed(o) || "" === Ne.string(a, o)) return null;
  var i = document.getElementById("rb-admin-frame"),
      l = i && i.contentWindow && i.contentWindow.document.getElementById("rb-content-frame"),
      c = l && l.contentWindow ? l.contentWindow.getSelection() : null;
  if (!c) return null;
  if (0 === (null == c ? void 0 : c.rangeCount)) return null;
  var s = c ? c.getRangeAt(0) : null,
      d = s ? s.getBoundingClientRect() : null;
  if (!d) return null;
  var u = t.current && t.current.getBoundingClientRect(),
      m = r.current && r.current.getBoundingClientRect(),
      p = 38 * n.length,
      g = m.width,
      f = u.x - m.x,
      b = d.left - u.left + (d.width - p) / 2;
  return b = (b = b < 3 - f ? 3 - f : b) + p + f + 3 > g ? g - f - p - 3 : b, pe.createElement("div", null, pe.createElement("style", null, "\n.toolbar {\n  display: flex;\n  background-color: #1a202c;\n  overflow: hidden;\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n}\n\n.toolbar button {\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n  overflow: visible;\n  -webkit-appearance: button;\n  padding: 0;\n  line-height: inherit;\n  color: inherit;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n}\n.toolbar button:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n.toolbar button {\n  padding: 0.75rem;\n}"), pe.createElement("div", {
    className: "toolbar",
    style: {
      position: "absolute",
      zIndex: 100,
      top: d.top - u.top - 42,
      left: b
    }
  }, n.map(function (e) {
    if (!e.button) return null;
    var r = {};
    e.button.isActive(a) ? (r.color = "#f6e05e", r.backgroundColor = "black") : r.color = "white";
    var o = e.hotKey ? pn ? e.hotKey.replace("mod", "cmd") : e.hotKey.replace("mod", "ctrl") : "";
    return pe.createElement(Te, {
      key: e.name,
      appendTo: t.current,
      content: "".concat(e.label).concat(e.hotKey ? " (".concat(o, ")") : "")
    }, pe.createElement("button", {
      style: r,
      onMouseDown: function onMouseDown(t) {
        t.preventDefault(), e.toggle(a, n);
      }
    }, e.button.icon));
  })));
},
    fn = function fn(e) {
  var t = e.renderBlock,
      r = e.placeholder,
      a = e.renderPlaceholder,
      o = e.propName,
      l = e.plugins,
      s = void 0 === l ? [] : l,
      u = e.multiline,
      p = void 0 === u || u,
      g = e.softLineBreak,
      f = void 0 === g || g,
      b = ve(null),
      h = Ie(Le(Ce()));
  s.forEach(function (e) {
    if (e.isInline) {
      var t = h.isInline;

      h.isInline = function (n) {
        return n.type === e.name || t(n);
      };
    }

    e.enhanceEditor && (h = e.enhanceEditor(h));
  }), p || (h = cn(h));
  var x = fe(function () {
    return h;
  }, []),
      v = be(ln),
      y = v.isAdmin,
      w = v.previewMode,
      k = be(n),
      E = k.values,
      C = k.onChange,
      A = k.contentRef,
      N = w || !y,
      S = E[o],
      I = xe(function (e) {
    var t = e.children,
        n = e.attributes;
    if (!a) return null;
    n.style;
    var r = d(n, ["style"]);
    return pe.cloneElement(a({
      children: t
    }), r);
  }, [E]),
      L = xe(function (e) {
    var n = e.element,
        r = e.children,
        a = e.attributes,
        o = s.find(function (e) {
      return e.renderElement && n.type === e.name;
    });
    if (o && o.renderElement) return o.renderElement({
      element: n,
      children: r,
      attributes: a
    });
    var i = s.find(function (e) {
      return e.renderItemElement && n.type === e.itemName;
    });
    return i && i.renderItemElement ? i.renderItemElement({
      element: n,
      children: r,
      attributes: a
    }) : pe.cloneElement(t({
      children: r,
      attributes: a,
      element: n
    }), a);
  }, [E]),
      z = xe(function (e) {
    var t = e.attributes,
        n = e.children,
        r = e.leaf,
        a = e.text;
    return s.filter(function (e) {
      return "Mark" === e.type;
    }).forEach(function (e) {
      r[e.name] && e.renderLeaf && (n = e.renderLeaf({
        attributes: t,
        children: n,
        leaf: r,
        text: a
      }));
    }), pe.createElement("span", c({}, t), n);
  }, [E]);

  if (N) {
    var B = S;
    return S ? ("string" == typeof S && (B = i.deserialize(S)), pe.createElement(pe.Fragment, null, B.map(function (e, n) {
      return pe.createElement(pe.Fragment, {
        key: n
      }, sn(e, s, t));
    }))) : null;
  }

  var P = S;
  S ? "string" == typeof S && (P = i.deserialize(S)) : P = i.deserialize("New text");
  var D = {};
  return a && (D = {
    renderPlaceholder: I
  }), pe.createElement("div", {
    ref: b,
    style: {
      position: "relative"
    }
  }, pe.createElement(ze, {
    editor: x,
    value: P,
    onChange: function onChange(e) {
      E[o] !== e && C(o, e);
    }
  }, pe.createElement(gn, {
    rtRef: b,
    blockRef: A,
    plugins: s
  }), pe.createElement(Be, c({
    placeholder: r,
    renderElement: L,
    renderLeaf: z,
    readOnly: N,
    onKeyDown: function onKeyDown(e) {
      var t, n;
      if (f && me("shift+enter", e)) return e.preventDefault(), void x.insertText("\n");

      try {
        for (var r = m(s), a = r.next(); !a.done; a = r.next()) {
          var o = a.value;
          o.hotKey && me(o.hotKey, e) && o.toggle(x, s);
        }
      } catch (e) {
        t = {
          error: e
        };
      } finally {
        try {
          a && !a.done && (n = r.return) && n.call(r);
        } finally {
          if (t) throw t.error;
        }
      }
    }
  }, D))));
},
    bn = function bn(e, t) {
  var n = Ne.marks(e);
  return !!n && !0 === n[t];
},
    hn = function hn(e) {
  var t = {
    type: "Mark",
    name: e.name,
    label: e.label || e.name[0].toUpperCase() + e.name.slice(1),
    hotKey: e.hotKey,
    renderLeaf: e.render,
    toggle: function toggle(t) {
      !function (e, t) {
        var n,
            r = bn(e, t);
        ke.setNodes(e, ((n = {})[t] = !r || null, n), {
          match: Ee.isText,
          split: !0
        });
      }(t, e.name);
    }
  };
  return e.icon && (t.button = {
    isActive: function isActive(t) {
      return bn(t, e.name);
    },
    icon: e.icon
  }), t;
},
    xn = hn({
  name: "bold",
  hotKey: "mod+b",
  render: function render(e) {
    return pe.createElement("strong", null, e.children);
  },
  icon: pe.createElement(Re, null)
}),
    vn = hn({
  name: "italic",
  hotKey: "mod+i",
  render: function render(e) {
    return pe.createElement("em", null, e.children);
  },
  icon: pe.createElement(Me, null)
}),
    yn = hn({
  name: "code",
  hotKey: "mod+`",
  render: function render(e) {
    return pe.createElement("code", {
      style: {
        margin: "0 1px",
        display: "inline-block",
        padding: "3px 6px",
        fontSize: "0.875rem",
        lineHeight: 1.25,
        maxWidth: "100%",
        fontFamily: 'Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
        borderRadius: "3px",
        backgroundColor: "#F5F7F9"
      }
    }, e.children);
  },
  icon: pe.createElement(Oe, null)
}),
    wn = hn({
  name: "highlight",
  hotKey: "mod+h",
  render: function render(e) {
    return pe.createElement("mark", {
      style: {
        paddingLeft: 4,
        paddingRight: 4,
        borderRadius: 2,
        backgroundColor: "#ff0",
        color: "#0f0f05"
      }
    }, e.children);
  },
  icon: pe.createElement(Fe, null)
}),
    kn = /^((((?:\w+:)?\/\/)(\S+))|(mailto:(\S+@)(\S+))|(tel:(\S+)))$/,
    En = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/,
    Cn = /^[^\s\.]+\.\S{2,}$/,
    An = /^((mailto:(\S+@)(\S+))|(tel:(\S+)))$/;

function Nn(e) {
  if ("string" != typeof e) return !1;
  var t = e.match(kn);
  if (!t) return !1;
  var n = t[1];
  return !!n && !!(En.test(n) || Cn.test(n) || An.test(n));
}

var Sn,
    In = function In(e) {
  var t = e.href,
      n = e.children,
      r = e.target,
      a = e.className,
      o = d(e, ["href", "children", "target", "className"]),
      i = be(g).renderLocalLink,
      l = be(ln),
      s = l.isAdmin,
      u = l.previewMode,
      m = !s || u,
      p = m ? {
    href: t
  } : {};
  return /^\/(?!\/)/.test(t) ? i && m ? i(c({
    href: t,
    target: r,
    children: n,
    className: a
  }, o)) : (i || console.warn("Local path found in Link, but no renderLocalLink function was provided. Rendering <a> as fallback"), pe.createElement("a", c({}, p, {
    target: r,
    className: a
  }, o), n)) : pe.createElement("a", c({}, p, {
    target: r,
    className: a
  }, o), n);
},
    Ln = function Ln(e, t) {
  e.selection && Pn(e, t);
},
    zn = function zn(e) {
  var t = Ne.nodes(e, {
    match: function match(e) {
      return !Ne.isEditor(e) && Se.isElement(e) && "link" === e.type;
    }
  }).next().value;
  return !!t && !!t[0];
},
    Bn = function Bn(e) {
  ke.unwrapNodes(e, {
    match: function match(e) {
      return !Ne.isEditor(e) && Se.isElement(e) && "link" === e.type;
    }
  });
},
    Pn = function Pn(e, t) {
  zn(e) && Bn(e);
  var n = e.selection,
      r = n && Ae.isCollapsed(n),
      a = {
    type: "link",
    url: t,
    children: r ? [{
      text: t
    }] : []
  };
  r ? ke.insertNodes(e, a) : (ke.wrapNodes(e, a, {
    split: !0
  }), ke.collapse(e, {
    edge: "end"
  }));
},
    Dn = {
  type: "Block",
  name: "link",
  label: "Link",
  isInline: !0,
  renderElement: function renderElement(e) {
    var t = e.attributes,
        n = e.children,
        r = e.element;
    return pe.createElement(In, c({}, t, {
      href: r.url
    }), n);
  },
  toggle: function toggle(e) {
    if (zn(e)) {
      var t = function (e) {
        var t = Ne.nodes(e, {
          match: function match(e) {
            return !Ne.isEditor(e) && Se.isElement(e) && "link" === e.type;
          }
        }).next().value;
        return t && t[0] || null;
      }(e);

      "" === (n = window.prompt("Enter the URL of the link:", (null == t ? void 0 : t.url) || "")) ? Bn(e) : n && Ln(e, n);
    } else {
      var n,
          r = function (e) {
        return e && e.selection ? Ne.string(e, e.selection) : "";
      }(e),
          a = r && Nn(r) ? r : "";

      (n = window.prompt("Enter the URL of the link:", a)) && Ln(e, n);
    }
  },
  button: {
    isActive: function isActive(e) {
      return zn(e);
    },
    icon: pe.createElement(Ye, null)
  },
  enhanceEditor: function enhanceEditor(e) {
    var t = e.insertText,
        n = e.insertData;
    return e.insertText = function (n) {
      n && Nn(n) ? Pn(e, n) : t(n);
    }, e.insertData = function (t) {
      var r = t.getData("text/plain");
      r && Nn(r) ? Pn(e, r) : n(t);
    }, e;
  }
},
    Tn = function Tn(e, t) {
  var n = Ne.nodes(e, {
    match: function match(e) {
      return !Ne.isEditor(e) && Se.isElement(e) && e.type === t;
    }
  }).next().value;
  return !!n && !!n[0];
},
    Rn = function Rn(e) {
  var t = {
    type: e.itemName ? "List" : "Block",
    name: e.name,
    isInline: e.isInline,
    itemName: e.itemName,
    label: e.label || e.name[0].toUpperCase() + e.name.slice(1),
    hotKey: e.hotKey,
    renderElement: e.render,
    renderItemElement: e.renderItem,
    toggle: function toggle(t, n) {
      !function (e, t, n, r) {
        var a = Tn(e, n),
            o = !!r;
        ke.unwrapNodes(e, {
          match: function match(e) {
            var n = !Ne.isEditor(e) && Se.isElement(e) ? e.type : "";
            return !!n && t.includes(n);
          },
          split: !0
        });
        var i = {
          type: a ? "paragraph" : r || n
        };

        if (ke.setNodes(e, i), !a && o) {
          var l = {
            type: n,
            children: []
          };
          ke.wrapNodes(e, l);
        }
      }(t, n.filter(function (e) {
        return "List" === e.type;
      }).map(function (e) {
        return e.name;
      }), e.name, e.itemName);
    }
  };
  return e.icon && (t.button = {
    isActive: function isActive(t) {
      return Tn(t, e.name);
    },
    icon: e.icon
  }), t;
},
    Mn = Rn({
  name: "h1",
  hotKey: "mod+shift+1",
  render: function render(e) {
    return pe.createElement("h1", null, e.children);
  },
  icon: pe.createElement(Xe, null)
}),
    On = Rn({
  name: "h2",
  hotKey: "mod+shift+2",
  render: function render(e) {
    return pe.createElement("h2", null, e.children);
  },
  icon: pe.createElement(Ue, null)
}),
    Fn = Rn({
  name: "h3",
  hotKey: "mod+shift+3",
  render: function render(e) {
    return pe.createElement("h3", null, e.children);
  },
  icon: pe.createElement(He, null)
}),
    Yn = Rn({
  name: "h4",
  hotKey: "mod+shift+4",
  render: function render(e) {
    return pe.createElement("h4", null, e.children);
  },
  icon: pe.createElement(Je, null)
}),
    Wn = Rn({
  name: "h5",
  hotKey: "mod+shift+5",
  render: function render(e) {
    return pe.createElement("h5", null, e.children);
  },
  icon: pe.createElement(Ke, null)
}),
    jn = Rn({
  name: "h6",
  hotKey: "mod+shift+6",
  render: function render(e) {
    return pe.createElement("h6", null, e.children);
  },
  icon: pe.createElement(Qe, null)
}),
    Vn = Rn({
  name: "quote",
  render: function render(e) {
    return pe.createElement("blockquote", null, e.children);
  },
  icon: pe.createElement(We, null)
}),
    Xn = Rn({
  name: "ol",
  label: "Number list",
  itemName: "li",
  render: function render(e) {
    return pe.createElement("ol", {
      className: "list-decimal"
    }, e.children);
  },
  renderItem: function renderItem(e) {
    return pe.createElement("li", null, e.children);
  },
  icon: pe.createElement(je, null)
}),
    Un = Rn({
  name: "ul",
  label: "Bullet list",
  itemName: "li",
  render: function render(e) {
    return pe.createElement("ul", {
      className: "list-disc"
    }, e.children);
  },
  renderItem: function renderItem(e) {
    return pe.createElement("li", null, e.children);
  },
  icon: pe.createElement(Ve, null)
}),
    Hn = Object.freeze({
  __proto__: null,
  bold: xn,
  italic: vn,
  code: yn,
  highlight: wn,
  link: Dn,
  heading1: Mn,
  heading2: On,
  heading3: Fn,
  heading4: Yn,
  heading5: Wn,
  heading6: jn,
  quote: Vn,
  orderedList: Xn,
  unorderedList: Un
}),
    Jn = ((Sn = {})[f.RichTextFeatures.Bold] = {
  newPlugin: xn,
  renderLeaf: "renderBold"
}, Sn[f.RichTextFeatures.Italic] = {
  newPlugin: vn,
  renderLeaf: "renderItalic"
}, Sn[f.RichTextFeatures.Highlight] = {
  newPlugin: wn,
  renderLeaf: "renderHighlight"
}, Sn[f.RichTextFeatures.Code] = {
  newPlugin: yn,
  renderLeaf: "renderCode"
}, Sn[f.RichTextFeatures.Link] = {
  newPlugin: Dn,
  renderLink: "renderLink"
}, Sn[f.RichTextFeatures.UnorderedList] = {
  newPlugin: Un,
  renderElement: "renderUL",
  renderItemElement: "renderLI"
}, Sn[f.RichTextFeatures.OrderedList] = {
  newPlugin: Xn,
  renderElement: "renderOL",
  renderItemElement: "renderLI"
}, Sn[f.RichTextFeatures.Heading1] = {
  newPlugin: Mn,
  renderElement: "renderH1"
}, Sn[f.RichTextFeatures.Heading2] = {
  newPlugin: On,
  renderElement: "renderH2"
}, Sn[f.RichTextFeatures.Heading3] = {
  newPlugin: Fn,
  renderElement: "renderH3"
}, Sn[f.RichTextFeatures.Heading4] = {
  newPlugin: Yn,
  renderElement: "renderH4"
}, Sn[f.RichTextFeatures.Heading5] = {
  newPlugin: Wn,
  renderElement: "renderH5"
}, Sn[f.RichTextFeatures.Heading6] = {
  newPlugin: jn,
  renderElement: "renderH6"
}, Sn[f.RichTextFeatures.Quote] = {
  newPlugin: Vn,
  renderElement: "renderQuote"
}, Sn),
    Kn = function Kn() {
  return ge.createElement("svg", {
    viewBox: "0 0 120 30",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "aria-label": "Loader",
    "data-testid": "three-dots-svg"
  }, ge.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }, ge.createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), ge.createElement("animate", {
    attributeName: "fill-opacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), ge.createElement("circle", {
    cx: "60",
    cy: "15",
    r: "15",
    attributeName: "fill-opacity",
    from: "1",
    to: "0.3"
  }, ge.createElement("animate", {
    attributeName: "r",
    from: "9",
    to: "9",
    begin: "0s",
    dur: "0.8s",
    values: "9;15;9",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), ge.createElement("animate", {
    attributeName: "fill-opacity",
    from: "0.5",
    to: "0.5",
    begin: "0s",
    dur: "0.8s",
    values: ".5;1;.5",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), ge.createElement("circle", {
    cx: "105",
    cy: "15",
    r: "15"
  }, ge.createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), ge.createElement("animate", {
    attributeName: "fill-opacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
},
    Qn = function Qn() {
  return tt(function (e) {
    return b(void 0, void 0, void 0, function () {
      return E(this, function (t) {
        switch (t.label) {
          case 0:
            return [4, at.post("/admin/images", e).then(function (e) {
              return e.data;
            })];

          case 1:
            return [2, t.sent()];
        }
      });
    });
  }, {
    onSuccess: function onSuccess() {},
    onError: function onError() {
      ot.error("An error occurred while uploading the image");
    }
  });
},
    qn = function qn(e) {
  var t = e.width,
      n = e.height,
      r = e.aspectRatio,
      a = e.ref,
      o = 1,
      i = 1;

  if (a) {
    var l = a;
    o = l.naturalWidth / l.width, i = l.naturalHeight / l.height;
  }

  var c = "height";
  if (!r) return {
    unit: "px",
    x: 0 / o,
    y: 0 / i,
    width: t / o,
    height: n / i
  };

  if (t / n <= r && (c = "width"), "height" === c) {
    var s = n * r;
    return {
      unit: "px",
      width: s / o,
      height: n / i,
      aspect: r,
      x: (t - s) / 2 / o,
      y: 0 / i
    };
  }

  var d = t / r;
  return {
    unit: "px",
    width: t / o,
    height: d / i,
    aspect: r,
    x: 0 / o,
    y: (n - d) / 2 / i
  };
},
    Zn = {
  content: {
    top: "40px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translateX(-50%)",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    padding: 0,
    border: "none",
    minWidth: 400
  },
  overlay: {
    backgroundColor: "hsla(216, 10%, 60%, 0.7)",
    zIndex: 100
  }
},
    Gn = ge.forwardRef(function (e, t) {
  var n = e.id,
      r = e.type,
      a = void 0 === r ? "text" : r,
      o = e.name,
      i = e.value,
      l = e.onChange,
      c = e.checked,
      s = void 0 === c ? void 0 : c,
      d = e.required,
      u = void 0 !== d && d,
      m = e.placeholder,
      p = void 0 === m ? "" : m,
      g = e.autoFocus,
      f = void 0 !== g && g,
      b = e.className,
      h = e.style,
      x = e.textSize,
      v = void 0 === x ? "sm" : x,
      y = e.radiusSize,
      w = void 0 === y ? "md" : y,
      k = e.disabled,
      E = void 0 !== k && k;
  return ge.createElement("input", {
    ref: t,
    id: n,
    type: a,
    name: o,
    value: i,
    onChange: l,
    checked: s,
    required: u,
    placeholder: p,
    autoFocus: f,
    disabled: E,
    style: h,
    className: _e("border-gray-300 focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50", "xs" === v ? "text-xs" : "text-sm", "full" === w || "radio" === a ? "rounded-full" : "checkbox" === a ? "rounded-sm" : "rounded-md", {
      "block w-full": "radio" !== a && "checkbox" !== a
    }, {
      "mr-2 text-blue-500 focus:ring-offset-0": "radio" === a || "checkbox" === a
    }, {
      "cursor-not-allowed": E
    }, b)
  });
}),
    _n = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  unit: "px"
};

function $n(e, t, n) {
  return Math.min(Math.max(e, t), n);
}

function er(e) {
  return e && e.width && !isNaN(e.width) && e.height && !isNaN(e.height);
}

function tr(e, t, n) {
  if (!e.aspect || isNaN(e.aspect)) return console.warn("`crop.aspect` should be a number in order to make an aspect crop", e), c(c({}, _n), e);
  var r = {
    unit: "px",
    x: e.x || 0,
    y: e.y || 0,
    width: e.width || 0,
    height: e.height || 0,
    aspect: e.aspect
  };
  return e.width && (r.height = r.width / e.aspect), e.height && (r.width = r.height * e.aspect), r.y + r.height > n && (r.height = n - r.y, r.width = r.height * e.aspect), r.x + r.width > t && (r.width = t - r.x, r.height = r.width / e.aspect), r;
}

function nr(e, t, n) {
  return "%" === e.unit ? c(c({}, _n), e) : {
    unit: "%",
    aspect: e.aspect,
    x: e.x ? e.x / t * 100 : 0,
    y: e.y ? e.y / n * 100 : 0,
    width: e.width ? e.width / t * 100 : 0,
    height: e.height ? e.height / n * 100 : 0
  };
}

function rr(e, t, n) {
  return e.unit ? "px" === e.unit ? c(c({}, _n), e) : {
    unit: "px",
    aspect: e.aspect,
    x: e.x ? e.x * t / 100 : 0,
    y: e.y ? e.y * n / 100 : 0,
    width: e.width ? e.width * t / 100 : 0,
    height: e.height ? e.height * n / 100 : 0
  } : c(c(c({}, _n), e), {
    unit: "px"
  });
}

var ar,
    or = {
  capture: !0,
  passive: !1
},
    ir = function (e) {
  function t() {
    var n = null !== e && e.apply(this, arguments) || this;
    return n.keysDown = new Set(), n.docMoveBound = !1, n.mouseDownOnCrop = !1, n.dragStarted = !1, n.evData = {
      clientStartX: 0,
      clientStartY: 0,
      cropStartWidth: 0,
      cropStartHeight: 0,
      cropStartX: 0,
      cropStartY: 0,
      xDiff: 0,
      yDiff: 0,
      xInversed: !1,
      yInversed: !1,
      xCrossOver: !1,
      yCrossOver: !1,
      lastYCrossover: !1,
      startXCrossOver: !1,
      startYCrossOver: !1,
      isResize: !0,
      ord: "nw"
    }, n.componentRef = pe.createRef(), n.mediaWrapperRef = pe.createRef(), n.imageRef = pe.createRef(), n.cropSelectRef = pe.createRef(), n.state = {
      cropIsActive: !1,
      newCropIsBeingDrawn: !1
    }, n.onCropPointerDown = function (e) {
      var t = n.props,
          r = t.crop,
          a = t.disabled,
          o = n.mediaDimensions,
          i = rr(r, o.width, o.height);

      if (!a) {
        e.cancelable && e.preventDefault(), n.bindDocMove(), n.componentRef.current.focus({
          preventScroll: !0
        });
        var l = e.target.dataset.ord,
            c = "nw" === l || "w" === l || "sw" === l,
            s = "nw" === l || "n" === l || "ne" === l;
        n.evData = {
          clientStartX: e.clientX,
          clientStartY: e.clientY,
          cropStartWidth: i.width,
          cropStartHeight: i.height,
          cropStartX: c ? i.x + i.width : i.x,
          cropStartY: s ? i.y + i.height : i.y,
          xDiff: 0,
          yDiff: 0,
          xInversed: c,
          yInversed: s,
          xCrossOver: c,
          yCrossOver: s,
          lastYCrossover: s,
          startXCrossOver: c,
          startYCrossOver: s,
          isResize: Boolean(l),
          ord: l || "ne"
        }, n.mouseDownOnCrop = !0, n.setState({
          cropIsActive: !0
        });
      }
    }, n.onComponentPointerDown = function (e) {
      var t = n.props,
          r = t.crop,
          a = t.disabled,
          o = t.locked,
          i = t.keepSelection,
          l = t.onChange,
          c = t.zoom,
          s = void 0 === c ? 1 : c,
          d = t.spin,
          u = void 0 === d ? 0 : d,
          m = n.mediaWrapperRef.current.firstChild;

      if (e.target === m && m.contains(e.target) && !(a || o || i && er(r))) {
        e.cancelable && e.preventDefault(), n.bindDocMove(), n.componentRef.current.focus({
          preventScroll: !0
        });
        var p = n.mediaWrapperRef.current.getBoundingClientRect(),
            g = 0,
            f = 0,
            b = (e.clientX - p.left) / s,
            h = (e.clientY - p.top) / s,
            x = u,
            v = Math.abs(x * Math.PI / 180);
        x > -45 && x <= 45 || Math.abs(x) > 135 && Math.abs(x) <= 180 ? (g = b * Math.cos(v), f = h * Math.cos(v)) : x > 45 && x <= 135 ? (g = h * Math.sin(v), f = b * Math.sin(v) * -1) : x > -135 && x <= -45 && (g = h * Math.sin(v) * -1, f = b * Math.sin(v));
        var y = {
          unit: "px",
          aspect: r ? r.aspect : void 0,
          x: g,
          y: f,
          width: 0,
          height: 0
        };
        n.evData = {
          clientStartX: e.clientX,
          clientStartY: e.clientY,
          cropStartWidth: y.width,
          cropStartHeight: y.height,
          cropStartX: y.x,
          cropStartY: y.y,
          xDiff: 0,
          yDiff: 0,
          xInversed: !1,
          yInversed: !1,
          xCrossOver: !1,
          yCrossOver: !1,
          lastYCrossover: !1,
          startXCrossOver: !1,
          startYCrossOver: !1,
          isResize: !0,
          ord: "nw"
        }, n.mouseDownOnCrop = !0;
        var w = n.mediaDimensions,
            k = w.width,
            E = w.height;
        l(rr(y, k, E), nr(y, k, E)), n.setState({
          cropIsActive: !0,
          newCropIsBeingDrawn: !0
        });
      }
    }, n.onDocPointerMove = function (e) {
      var t = n.props,
          r = t.crop,
          a = t.disabled,
          o = t.onChange,
          i = t.onDragStart,
          l = t.zoom,
          c = void 0 === l ? 1 : l,
          s = t.spin,
          d = void 0 === s ? 0 : s;

      if (!a && n.mouseDownOnCrop) {
        e.cancelable && e.preventDefault(), n.dragStarted || (n.dragStarted = !0, i && i(e));
        var u,
            m = n.evData,
            p = (e.clientX - m.clientStartX) / c,
            g = (e.clientY - m.clientStartY) / c,
            f = d,
            b = Math.abs(f * Math.PI / 180);

        if (f > -45 && f <= 45 || Math.abs(f) > 135 && Math.abs(f) <= 180 ? (m.xDiff = p * Math.cos(b), m.yDiff = g * Math.cos(b)) : f > 45 && f <= 135 ? (m.xDiff = g * Math.sin(b), m.yDiff = p * Math.sin(b) * -1) : f > -135 && f <= -45 && (m.xDiff = g * Math.sin(b) * -1, m.yDiff = p * Math.sin(b)), (u = m.isResize ? n.resizeCrop() : n.dragCrop()) !== r) {
          var h = n.mediaDimensions,
              x = h.width,
              v = h.height;
          o(rr(u, x, v), nr(u, x, v));
        }
      }
    }, n.onComponentKeyDown = function (e) {
      var r = n.props,
          a = r.crop,
          o = r.disabled,
          i = r.onChange,
          l = r.onComplete;

      if (!o) {
        n.keysDown.add(e.key);
        var c = !1;

        if (er(a)) {
          var s = n.makeNewCrop(),
              d = (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) ? t.nudgeStepLarge : e.shiftKey ? t.nudgeStepMedium : t.nudgeStep;

          if (n.keysDown.has("ArrowLeft") && (s.x -= d, c = !0), n.keysDown.has("ArrowRight") && (s.x += d, c = !0), n.keysDown.has("ArrowUp") && (s.y -= d, c = !0), n.keysDown.has("ArrowDown") && (s.y += d, c = !0), c) {
            e.cancelable && e.preventDefault();
            var u = n.mediaDimensions,
                m = u.width,
                p = u.height;
            s.x = $n(s.x, 0, m - s.width), s.y = $n(s.y, 0, p - s.height);
            var g = rr(s, m, p),
                f = nr(s, m, p);
            i(g, f), l && l(g, f);
          }
        }
      }
    }, n.onComponentKeyUp = function (e) {
      n.keysDown.delete(e.key);
    }, n.onDocPointerDone = function (e) {
      var t = n.props,
          r = t.crop,
          a = t.disabled,
          o = t.onComplete,
          i = t.onDragEnd;

      if (n.unbindDocMove(), !a && n.mouseDownOnCrop) {
        n.mouseDownOnCrop = !1, n.dragStarted = !1;
        var l = n.mediaDimensions,
            c = l.width,
            s = l.height;
        i && i(e), o && o(rr(r, c, s), nr(r, c, s)), n.setState({
          cropIsActive: !1,
          newCropIsBeingDrawn: !1
        });
      }
    }, n.onMediaLoaded = function () {
      var e = n.props,
          t = e.onComplete,
          r = e.onChange,
          a = n.createNewCrop(),
          o = a.pixelCrop,
          i = a.percentCrop;
      r(o, i), t && t(o, i);
    }, n.onImageLoad = function (e) {
      var t = n.props,
          r = t.onComplete,
          a = t.onChange,
          o = t.onImageLoaded;

      if (!1 !== (!o || o(e.currentTarget))) {
        var i = n.createNewCrop(),
            l = i.pixelCrop,
            c = i.percentCrop;
        a(l, c), r && r(l, c);
      }
    }, n;
  }

  return C(t, e), t.prototype.componentDidMount = function () {
    this.componentRef.current && this.componentRef.current.addEventListener("medialoaded", this.onMediaLoaded);
  }, t.prototype.componentWillUnmount = function () {
    this.componentRef.current && this.componentRef.current.removeEventListener("medialoaded", this.onMediaLoaded);
  }, t.prototype.componentDidUpdate = function (e) {
    var t = this.props,
        n = t.crop,
        r = t.onChange,
        a = t.onComplete;

    if (this.imageRef.current && n && e.crop !== n && n.aspect && (n.width && !n.height || !n.width && n.height)) {
      var o = this.imageRef.current,
          i = o.width,
          l = o.height,
          c = tr(this.makeNewCrop(), i, l),
          s = rr(c, i, l),
          d = nr(c, i, l);
      r(s, d), a && a(s, d);
    }
  }, t.prototype.bindDocMove = function () {
    var e, t, n;

    if (!this.docMoveBound) {
      var r = document.getElementById("rb-admin-frame");
      null === (e = r.contentWindow) || void 0 === e || e.document.addEventListener("pointermove", this.onDocPointerMove, or), null === (t = r.contentWindow) || void 0 === t || t.document.addEventListener("pointerup", this.onDocPointerDone, or), null === (n = r.contentWindow) || void 0 === n || n.document.addEventListener("pointercancel", this.onDocPointerDone, or), this.docMoveBound = !0;
    }
  }, t.prototype.unbindDocMove = function () {
    var e, t, n;

    if (this.docMoveBound) {
      var r = document.getElementById("rb-admin-frame");
      null === (e = r.contentWindow) || void 0 === e || e.document.removeEventListener("pointermove", this.onDocPointerMove, or), null === (t = r.contentWindow) || void 0 === t || t.document.removeEventListener("pointerup", this.onDocPointerDone, or), null === (n = r.contentWindow) || void 0 === n || n.document.removeEventListener("pointercancel", this.onDocPointerDone, or), this.docMoveBound = !1;
    }
  }, t.prototype.createNewCrop = function () {
    var e = this.mediaDimensions,
        t = e.width,
        n = e.height,
        r = function (e, t, n) {
      return !e.aspect || e.width && e.height ? e : tr(e, t, n);
    }(this.makeNewCrop(), t, n);

    return {
      pixelCrop: rr(r, t, n),
      percentCrop: nr(r, t, n)
    };
  }, Object.defineProperty(t.prototype, "mediaDimensions", {
    get: function get() {
      var e = 0,
          t = 0;
      return this.mediaWrapperRef.current && (e = this.mediaWrapperRef.current.clientWidth, t = this.mediaWrapperRef.current.clientHeight), {
        width: e,
        height: t
      };
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.getCropStyle = function () {
    var e = this.makeNewCrop(this.props.crop ? this.props.crop.unit : "px");
    return {
      top: "".concat(e.y).concat(e.unit),
      left: "".concat(e.x).concat(e.unit),
      width: "".concat(e.width).concat(e.unit),
      height: "".concat(e.height).concat(e.unit)
    };
  }, t.prototype.getNewSize = function () {
    var e,
        t = this.props,
        n = t.crop,
        r = t.minWidth,
        a = void 0 === r ? 0 : r,
        o = t.maxWidth,
        i = t.minHeight,
        l = void 0 === i ? 0 : i,
        c = t.maxHeight,
        s = this.evData,
        d = this.mediaDimensions,
        u = d.width,
        m = d.height,
        p = s.cropStartWidth + s.xDiff;
    return s.xCrossOver && (p = Math.abs(p)), p = $n(p, a, o || u), e = n.aspect ? p / n.aspect : s.cropStartHeight + s.yDiff, s.yCrossOver && (e = Math.min(Math.abs(e), s.cropStartY)), e = $n(e, l, c || m), n.aspect && (p = $n(e * n.aspect, 0, u)), {
      width: p,
      height: e
    };
  }, t.prototype.dragCrop = function () {
    var e = this.makeNewCrop(),
        t = this.evData,
        n = this.mediaDimensions,
        r = n.width,
        a = n.height;
    return e.x = $n(t.cropStartX + t.xDiff, 0, r - e.width), e.y = $n(t.cropStartY + t.yDiff, 0, a - e.height), e;
  }, t.prototype.resizeCrop = function () {
    var e = this.evData,
        n = this.props,
        r = n.crop,
        a = n.minWidth,
        o = void 0 === a ? 0 : a,
        i = n.minHeight,
        l = void 0 === i ? 0 : i,
        c = this.makeNewCrop(),
        s = e.ord;
    e.xInversed && (e.xDiff -= 2 * e.cropStartWidth), e.yInversed && (e.yDiff -= 2 * e.cropStartHeight);
    var d = this.getNewSize(),
        u = e.cropStartX,
        m = e.cropStartY;
    e.xCrossOver && (u = c.x + (c.width - d.width)), e.yCrossOver && (m = !1 === e.lastYCrossover ? c.y - d.height : c.y + (c.height - d.height));

    var p = this.mediaDimensions,
        g = p.width,
        f = p.height,
        b = function (e, t, n, r) {
      var a = rr(t, n, r),
          o = rr(e, n, r);
      if (!a.aspect) return a.x < 0 ? (a.x = 0, a.width += a.x) : a.x + a.width > n && (a.width = n - a.x), a.y + a.height > r && (a.height = r - a.y), a;
      var i = !1;
      a.x < 0 ? (a.x = 0, a.width += a.x, a.height = a.width / a.aspect, i = !0) : a.x + a.width > n && (a.width = n - a.x, a.height = a.width / a.aspect, i = !0), i && o.y > a.y && (a.y = a.y + (a.height - a.height));
      var l = !1;
      return a.y + a.height > r && (a.height = r - a.y, a.width = a.height * a.aspect, l = !0), l && o.x > a.x && (a.x = a.x + (a.width - a.width)), a;
    }(this.props.crop, {
      unit: c.unit,
      x: u,
      y: m,
      width: d.width,
      height: d.height,
      aspect: c.aspect
    }, g, f);

    return c.aspect || t.xyOrds.indexOf(s) > -1 ? (c.x = b.x, c.y = b.y, c.width = b.width, c.height = b.height) : t.xOrds.indexOf(s) > -1 ? (c.x = b.x, c.width = b.width) : t.yOrds.indexOf(s) > -1 && (c.y = b.y, c.height = b.height), e.lastYCrossover = e.yCrossOver, this.crossOverCheck(), c.width < o || c.height < l ? r : c;
  }, t.prototype.getRotatedCursor = function (e, t) {
    if (t > -135 && t <= -45 || t > 45 && t <= 135) switch (e) {
      case "nw":
        return {
          cursor: "ne-resize"
        };

      case "n":
        return {
          cursor: "w-resize"
        };

      case "ne":
        return {
          cursor: "nw-resize"
        };

      case "e":
        return {
          cursor: "s-resize"
        };

      case "se":
        return {
          cursor: "sw-resize"
        };

      case "s":
        return {
          cursor: "e-resize"
        };

      case "sw":
        return {
          cursor: "se-resize"
        };

      case "w":
        return {
          cursor: "n-resize"
        };
    }
  }, t.prototype.createCropSelection = function () {
    var e = this.props,
        t = e.disabled,
        n = e.locked,
        r = e.renderSelectionAddon,
        a = e.ruleOfThirds,
        o = e.crop,
        i = e.spin,
        l = void 0 === i ? 0 : i,
        c = this.getCropStyle();
    return pe.createElement("div", {
      style: c,
      className: "ReactCrop__crop-selection",
      onPointerDown: this.onCropPointerDown
    }, !t && !n && pe.createElement("div", {
      className: "ReactCrop__drag-elements"
    }, pe.createElement("div", {
      className: "ReactCrop__drag-bar ord-n",
      "data-ord": "n"
    }), pe.createElement("div", {
      className: "ReactCrop__drag-bar ord-e",
      "data-ord": "e"
    }), pe.createElement("div", {
      className: "ReactCrop__drag-bar ord-s",
      "data-ord": "s"
    }), pe.createElement("div", {
      className: "ReactCrop__drag-bar ord-w",
      "data-ord": "w"
    }), pe.createElement("div", {
      className: "ReactCrop__drag-handle ord-nw",
      "data-ord": "nw",
      style: this.getRotatedCursor("nw", l)
    }), pe.createElement("div", {
      className: "ReactCrop__drag-handle ord-n",
      "data-ord": "n",
      style: this.getRotatedCursor("n", l)
    }), pe.createElement("div", {
      className: "ReactCrop__drag-handle ord-ne",
      "data-ord": "ne",
      style: this.getRotatedCursor("ne", l)
    }), pe.createElement("div", {
      className: "ReactCrop__drag-handle ord-e",
      "data-ord": "e",
      style: this.getRotatedCursor("e", l)
    }), pe.createElement("div", {
      className: "ReactCrop__drag-handle ord-se",
      "data-ord": "se",
      style: this.getRotatedCursor("se", l)
    }), pe.createElement("div", {
      className: "ReactCrop__drag-handle ord-s",
      "data-ord": "s",
      style: this.getRotatedCursor("s", l)
    }), pe.createElement("div", {
      className: "ReactCrop__drag-handle ord-sw",
      "data-ord": "sw",
      style: this.getRotatedCursor("sw", l)
    }), pe.createElement("div", {
      className: "ReactCrop__drag-handle ord-w",
      "data-ord": "w",
      style: this.getRotatedCursor("w", l)
    })), r && er(o) && pe.createElement("div", {
      className: "ReactCrop__selection-addon",
      onMouseDown: function onMouseDown(e) {
        return e.stopPropagation();
      }
    }, r(this.state)), a && pe.createElement(pe.Fragment, null, pe.createElement("div", {
      className: "ReactCrop__rule-of-thirds-hz"
    }), pe.createElement("div", {
      className: "ReactCrop__rule-of-thirds-vt"
    })));
  }, t.prototype.makeNewCrop = function (e) {
    void 0 === e && (e = "px");
    var t = c(c({}, _n), this.props.crop || {}),
        n = this.mediaDimensions,
        r = n.width,
        a = n.height;
    return "px" === e ? rr(t, r, a) : nr(t, r, a);
  }, t.prototype.crossOverCheck = function () {
    var e = this.evData,
        t = this.props,
        n = t.minWidth,
        r = t.minHeight;
    !n && (!e.xCrossOver && -Math.abs(e.cropStartWidth) - e.xDiff >= 0 || e.xCrossOver && -Math.abs(e.cropStartWidth) - e.xDiff <= 0) && (e.xCrossOver = !e.xCrossOver), !r && (!e.yCrossOver && -Math.abs(e.cropStartHeight) - e.yDiff >= 0 || e.yCrossOver && -Math.abs(e.cropStartHeight) - e.yDiff <= 0) && (e.yCrossOver = !e.yCrossOver);
  }, t.prototype.render = function () {
    var e = this.props,
        t = e.children,
        n = e.circularCrop,
        r = e.className,
        a = e.crossorigin,
        o = e.crop,
        i = e.disabled,
        l = e.imageStyle,
        s = e.locked,
        d = e.imageAlt,
        u = e.onImageError,
        m = e.renderComponent,
        p = e.scale,
        g = void 0 === p ? 1 : p,
        f = e.src,
        b = e.style,
        h = e.rotate,
        x = void 0 === h ? 0 : h,
        v = e.ruleOfThirds,
        y = this.state,
        w = y.cropIsActive,
        k = y.newCropIsBeingDrawn,
        E = er(o) && this.componentRef ? this.createCropSelection() : null,
        C = _e("ReactCrop", r, {
      "ReactCrop--active": w,
      "ReactCrop--disabled": i,
      "ReactCrop--locked": s,
      "ReactCrop--new-crop": k,
      "ReactCrop--fixed-aspect": o && o.aspect,
      "ReactCrop--circular-crop": o && n,
      "ReactCrop--rule-of-thirds": o && v,
      "ReactCrop--invisible-crop": !this.dragStarted && o && !o.width && !o.height
    });

    return pe.createElement("div", {
      ref: this.componentRef,
      className: C,
      onPointerDown: this.onComponentPointerDown,
      tabIndex: 0,
      onKeyDown: this.onComponentKeyDown,
      onKeyUp: this.onComponentKeyUp
    }, pe.createElement("div", {
      ref: this.mediaWrapperRef,
      style: c({
        transform: "scale(".concat(g, ") rotate(").concat(x, "deg)")
      }, b)
    }, m || pe.createElement("img", {
      ref: this.imageRef,
      crossOrigin: a,
      className: "ReactCrop__image",
      style: l,
      src: f,
      onLoad: this.onImageLoad,
      onError: u,
      alt: d
    })), t, E);
  }, t.xOrds = ["e", "w"], t.yOrds = ["n", "s"], t.xyOrds = ["nw", "ne", "se", "sw"], t.nudgeStep = 1, t.nudgeStepMedium = 10, t.nudgeStepLarge = 100, t;
}(pe.PureComponent),
    lr = function lr() {
  var e,
      t = document.getElementById("rb-admin-frame"),
      n = null === (e = null == t ? void 0 : t.contentWindow) || void 0 === e ? void 0 : e.document;
  return n.host = {
    parentNode: {}
  }, n.body;
},
    cr = function cr(e) {
  var t = e.className,
      n = e.style,
      r = void 0 === n ? {} : n,
      a = e.onClick,
      o = void 0 === a ? function () {
    return null;
  } : a;
  return ge.createElement("svg", {
    viewBox: "0 0 200 200",
    preserveAspectRatio: "none",
    version: "1.1",
    className: t,
    style: r,
    onClick: function onClick() {
      return o();
    }
  }, ge.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, ge.createElement("g", {
    id: "Placeholder"
  }, ge.createElement("g", {
    id: "Group"
  }, ge.createElement("rect", {
    id: "Rectangle",
    fill: "#DADADA",
    x: "0",
    y: "0",
    width: "200",
    height: "200"
  }), ge.createElement("path", {
    d: "M26.6531727,14.9193918 L172.487307,14.9193918 C178.982793,14.9193918 184.221088,20.1576869 184.221088,26.6531727 L184.221088,104.389471 L150.486468,61.8545154 C146.505363,56.6162204 138.543155,56.6162204 134.562051,61.8545154 L85.3220772,124.085461 L64.7879606,101.665558 C60.5973246,97.0558581 53.2637115,97.0558581 49.0730755,101.665558 L14.9193918,138.752687 L14.9193918,26.6531727 C14.9193918,20.1576869 20.1576869,14.9193918 26.6531727,14.9193918 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), ge.createElement("circle", {
    id: "Oval",
    fill: "#DADADA",
    fillRule: "nonzero",
    cx: "51.3779253",
    cy: "51.3779253",
    r: "16.7625441"
  })))));
},
    sr = function sr(t) {
  var n = t.source,
      r = t.alt,
      a = t.maxWidth,
      o = t.aspectRatio,
      i = t.onChange,
      l = t.setModalOpen,
      s = t.modalOpen,
      u = be(ln).currentPage,
      m = n && n.alt || r,
      p = e(ye(), 2),
      g = p[0],
      f = p[1],
      h = qn({
    width: n && n.width ? n.width : 0,
    height: n && n.height ? n.height : 0,
    aspectRatio: o,
    ref: g
  }),
      x = e(ye(!1), 2),
      v = x[0],
      y = x[1],
      w = e(ye(""), 2),
      k = w[0],
      C = w[1],
      A = e(ye(!1), 2),
      N = A[0],
      S = A[1],
      I = e(ye(!1), 2),
      L = I[0],
      z = I[1],
      B = e(ye({
    imageUrl: n ? n.src : "",
    alt: n ? n.alt : r,
    seoName: n ? n.seoName : "",
    crop: h
  }), 2),
      P = B[0],
      D = B[1],
      T = Qn(),
      R = function R(e) {
    D(c(c({}, P), e));
  },
      M = $e({
    accept: "image/*",
    maxSize: 3145728,
    onDropAccepted: function onDropAccepted(e) {
      var t;
      S("image/svg+xml" === (null === (t = e[0]) || void 0 === t ? void 0 : t.type)), C("");
      var n = new FileReader();
      n.addEventListener("load", function () {
        R({
          imageUrl: n.result,
          image: e[0]
        }), z(!0);
      }), n.readAsDataURL(e[0]);
    },
    onDropRejected: function onDropRejected(e) {
      var t = "".concat((e[0].file.size / 1048576).toFixed(1), " MB");
      C("Image exceeds max file size of ".concat(3, " MB (").concat(t, ")"));
    }
  }),
      O = M.getRootProps,
      F = M.getInputProps;

  return he(function () {
    R({
      crop: qn({
        width: (null == g ? void 0 : g.naturalWidth) || (n && n.width ? n.width : 0),
        height: (null == g ? void 0 : g.naturalHeight) || (n && n.height ? n.height : 0),
        aspectRatio: o,
        ref: g
      })
    });
  }, [n, g]), pe.createElement(et, {
    isOpen: s,
    onRequestClose: function onRequestClose() {
      z(!1), l(!1), D({
        imageUrl: "",
        alt: "",
        seoName: "",
        crop: h
      });
    },
    style: Zn,
    parentSelector: function parentSelector() {
      return lr();
    }
  }, pe.createElement("style", null, '\n.react-bricks-image-modal {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;\n  font-size: 16px;\n\n  display: flex;\n  line-height: 1.5;\n}\n.react-bricks-image-modal .image-upload-remove {\n  box-sizing: border-box;\n}\n.react-bricks-image-modal .image-upload {\n  box-sizing: border-box;\n  padding: 32px 30px 0;\n  width: 300px;\n}\n.react-bricks-image-modal .image-upload .image {\n  position: relative;\n  margin-bottom: 8px;\n  width: 240px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n.react-bricks-image-modal .image-upload .image img,\n.react-bricks-image-modal .image-upload .image svg {\n  width: 100%;\n}\n.react-bricks-image-modal .image-upload .error {\n  text-align: center;\n  font-size: 14px;\n  margin-top: 24px;\n  color: #e53e3e;\n}\n.react-bricks-image-modal .image-upload .overlay-container {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n  transition: opacity 300ms;\n  background-color: rgba(252,242,248,0.75);\n  border-radius: 4px;\n}\n.react-bricks-image-modal .image-upload .overlay-container:hover {\n  opacity: 1;\n}\n.react-bricks-image-modal .image-upload .overlay-container .upload {\n  box-sizing: border-box;\n  background-color: rgba(255, 255, 255, 0.8);\n  padding: 1rem;\n  border-radius: 9999px;\n  cursor: pointer;\n  //border: 1px solid #edf2f7;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05),\n    0 2px 4px -1px rgba(0, 0, 0, 0.02);\n}\n.react-bricks-image-modal .image-upload .overlay-container:focus {\n  outline: none;\n}\n.react-bricks-image-modal .image-upload .overlay-container .upload svg {\n  width: 45px;\n  fill: #f65a8e; /*#d9367f;*/\n}\n.react-bricks-image-modal .image-upload .loading {\n  box-sizing: border-box;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n  opacity: 0.75;\n  z-index: 50;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.react-bricks-image-modal .image-upload .tip {\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  color: #718096;\n  margin-bottom: 10px;\n}\n.react-bricks-image-modal .image-upload-remove .image-remove {\n  padding: 20px 32px 30px;\n  font-size: 14px;\n  line-height: 1;\n  text-align: center;\n}\n.react-bricks-image-modal .image-upload-remove .image-remove a {\n  color: #c53030;\n}\n.react-bricks-image-modal .image-upload-remove .image-remove a:hover {\n  color: #9b2c2c;\n  text-decoration: underline;\n}\n.react-bricks-image-modal .image-edit {\n  background-color: #edf2f7;\n  padding: 30px 32px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.react-bricks-image-modal .image-edit .form-field {\n  margin-bottom: 24px;\n}\n.react-bricks-image-modal .image-edit label {\n  box-sizing: border-box;\n  display: block;\n  margin-bottom: 4px;\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #718096;\n}\n.react-bricks-image-modal .image-edit input {\n  box-sizing: border-box;\n  width: 100%;\n  background-color: #fff;\n  font-size: 14px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n.react-bricks-image-modal .image-edit button.btn {\n  cursor: pointer;\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  background-color: #4299e1; /*f65a8e*/\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  margin-top: 20px;\n}\n.btn-cancel{\n  cursor: pointer;\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  background-color: #9CA3AF;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  margin-top: 20px;\n}\n.react-bricks-image-modal .image-edit button.btn:hover {\n  background-color: #3182ce; /*b43179*/\n  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%), 0 4px 6px -2px rgb(0 0 0 / 5%);\n}\n'), pe.createElement("div", {
    className: "react-bricks-image-modal"
  }, pe.createElement("div", {
    className: "image-upload-remove"
  }, pe.createElement("div", {
    className: "image-upload"
  }, pe.createElement("div", {
    className: "tip"
  }, "Click the image to change"), pe.createElement("div", {
    className: "image"
  }, P.imageUrl ? L && !N ? pe.createElement(ir, {
    className: "w-full",
    src: P.imageUrl,
    crop: P.crop,
    onChange: function onChange(e) {
      e.unit;
      var t = d(e, ["unit"]);
      R({
        crop: t
      });
    },
    onImageLoaded: function onImageLoaded(e) {
      return f(e);
    }
  }) : pe.createElement("img", {
    src: P.imageUrl || "",
    alt: m,
    style: {
      cursor: "default"
    }
  }) : pe.createElement(cr, null), !L && pe.createElement("div", c({
    className: "overlay-container"
  }, O()), pe.createElement("div", {
    className: "upload"
  }, pe.createElement("svg", {
    viewBox: "0 0 312.602 312.602"
  }, pe.createElement("path", {
    d: "M251.52,137.244c-3.966,0-7.889,0.38-11.738,1.134c-1.756-47.268-40.758-85.181-88.448-85.181c-43.856,0-80.964,32.449-87.474,75.106C28.501,129.167,0,158.201,0,193.764c0,36.106,29.374,65.48,65.48,65.48h54.782c4.143,0,7.5-3.357,7.5-7.5c0-4.143-3.357-7.5-7.5-7.5H65.48c-27.835,0-50.48-22.645-50.48-50.48c0-27.835,22.646-50.48,50.48-50.48c1.367,0,2.813,0.067,4.419,0.206l7.6,0.658l0.529-7.61c2.661-38.322,34.861-68.341,73.306-68.341c40.533,0,73.51,32.977,73.51,73.51c0,1.863-0.089,3.855-0.272,6.088l-0.983,11.968l11.186-4.367c5.356-2.091,10.99-3.151,16.747-3.151c25.409,0,46.081,20.672,46.081,46.081c0,25.408-20.672,46.08-46.081,46.08c-0.668,0-20.608-0.04-40.467-0.08c-19.714-0.04-39.347-0.08-39.999-0.08c-4.668,0-7.108-2.248-7.254-6.681v-80.959l8.139,9.667c2.667,3.17,7.399,3.576,10.567,0.907c3.169-2.667,3.575-7.398,0.907-10.567l-18.037-21.427c-2.272-2.699-5.537-4.247-8.958-4.247c-3.421,0-6.686,1.548-8.957,4.247l-18.037,21.427c-2.668,3.169-2.262,7.9,0.907,10.567c1.407,1.185,3.121,1.763,4.826,1.763c2.137,0,4.258-0.908,5.741-2.67l7.901-9.386v80.751c0,8.686,5.927,21.607,22.254,21.607c0.652,0,20.27,0.04,39.968,0.079c19.874,0.041,39.829,0.081,40.498,0.081c33.681,0,61.081-27.4,61.081-61.08C312.602,164.644,285.201,137.244,251.52,137.244z"
  })), pe.createElement("input", c({}, F())))), v && pe.createElement("div", {
    className: "loading text-pink-500 flex justify-center items-center"
  }, pe.createElement("div", {
    className: "w-24"
  }, pe.createElement(Kn, null)))), !!k && pe.createElement("div", {
    className: "error"
  }, k)), pe.createElement("div", {
    className: "image-remove"
  }, pe.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault(), R({
        imageUrl: "",
        alt: "",
        seoName: "",
        image: void 0
      }), z(!1);
    }
  }, "Remove image"))), pe.createElement("div", {
    className: "image-edit"
  }, pe.createElement("div", null, pe.createElement("div", {
    className: "form-field"
  }, pe.createElement("label", null, "Alternate text"), pe.createElement(Gn, {
    name: "alt",
    value: P.alt || "",
    onChange: function onChange(e) {
      return R({
        alt: e.target.value
      });
    }
  })), pe.createElement("div", {
    className: "form-field"
  }, pe.createElement("label", null, "SEO-friendly name"), pe.createElement(Gn, {
    name: "seoName",
    value: P.seoName || "",
    onChange: function onChange(e) {
      var t = e.target.value;
      /^[A-Za-z0-9\-_]*$/.test(t) && R({
        seoName: e.target.value
      });
    }
  }))), pe.createElement("div", {
    className: "flex space-x-4"
  }, pe.createElement("button", {
    type: "button",
    className: "btn-cancel",
    onClick: function onClick() {
      z(!1), l(!1), D({
        imageUrl: "",
        alt: "",
        seoName: "",
        crop: h
      });
    }
  }, "Cancel"), pe.createElement("button", {
    type: "button",
    className: "btn",
    onClick: function onClick(e) {
      return b(void 0, void 0, void 0, function () {
        var e, t, r, o, s, m, p, f, b, x;
        return E(this, function (v) {
          switch (v.label) {
            case 0:
              return e = new FormData(), P.image && e.append("file", P.image), u && -1 === u.pageId.indexOf("playground") && e.append("pageId", u.pageId), a && e.append("maxWidth", a + ""), t = P.crop, r = t.x, o = t.y, s = t.width, m = t.height, 0 === r && 0 === o && Math.round(s) === (null == g ? void 0 : g.width) && Math.round(m) === (null == g ? void 0 : g.height) || g && (p = g.naturalWidth / g.width, f = g.naturalHeight / g.height, P.crop.height = Math.round(P.crop.height * f), P.crop.y = Math.round(P.crop.y * f), P.crop.width = Math.round(P.crop.width * p), P.crop.x = Math.round(P.crop.x * p), b = P.crop, x = d(b, ["aspect", "unit"]), e.append("crop", JSON.stringify(x))), P.imageUrl ? [3, 1] : (i(null), [3, 4]);

            case 1:
              return P.image ? [3, 2] : (i(c(c({}, n), {
                alt: P.alt,
                seoName: P.seoName
              })), [3, 4]);

            case 2:
              return y(!0), [4, T.mutateAsync(e).then(function (e) {
                return i(c(c({}, n), {
                  src: e.src,
                  placeholderSrc: e.placeholderSrc,
                  srcSet: e.srcSet,
                  width: e.width,
                  height: e.height,
                  alt: P.alt,
                  seoName: P.seoName
                })), z(!1), y(!1), D({
                  imageUrl: "",
                  alt: "",
                  seoName: "",
                  crop: h
                }), e;
              })];

            case 3:
              v.sent(), v.label = 4;

            case 4:
              return l(!1), [2];
          }
        });
      });
    }
  }, "Done")))));
},
    dr = function dr(t) {
  var n = t.source,
      r = t.alt,
      a = t.maxWidth,
      o = t.aspectRatio,
      i = t.onChange,
      l = t.containerClassName,
      s = t.containerStyle,
      d = void 0 === s ? {} : s,
      u = t.imageClassName,
      m = t.imageStyle,
      p = void 0 === m ? {} : m,
      g = t.noWrapper,
      f = void 0 !== g && g,
      b = n && n.alt || r,
      h = e(ye(!1), 2),
      x = h[0],
      v = h[1];
  return f ? ge.createElement(ge.Fragment, null, (null == n ? void 0 : n.src) ? ge.createElement("img", {
    src: n.src,
    alt: b,
    onClick: function onClick() {
      return v(!0);
    },
    className: u,
    style: c({
      cursor: "pointer"
    }, p)
  }) : ge.createElement(cr, {
    onClick: function onClick() {
      return v(!0);
    },
    className: u,
    style: c({
      cursor: "pointer"
    }, p)
  }), x && ge.createElement(sr, {
    source: n,
    alt: r,
    maxWidth: a,
    aspectRatio: o,
    onChange: i,
    setModalOpen: v,
    modalOpen: x
  })) : ge.createElement(ge.Fragment, null, ge.createElement("div", {
    className: _e("react-bricks-image", l),
    onClick: function onClick() {
      return v(!0);
    },
    style: c({
      cursor: "pointer"
    }, d)
  }, (null == n ? void 0 : n.src) ? ge.createElement("img", {
    src: n.src,
    alt: b,
    className: _e("cursor-pointer", u),
    style: p
  }) : ge.createElement(cr, {
    className: _e("cursor-pointer", u),
    style: c({
      aspectRatio: o + ""
    }, p)
  })), x && ge.createElement(sr, {
    source: n,
    alt: r,
    maxWidth: a,
    aspectRatio: o,
    onChange: i,
    setModalOpen: v,
    modalOpen: x
  }));
},
    ur = require("react-progressive-graceful-image").default,
    mr = function mr(e, t) {
  if (!t) return e;
  var n = e.lastIndexOf(".");
  return e.substring(0, n) + "/" + t + e.substring(n);
},
    pr = function pr(t) {
  t.propName;
  var n = t.source,
      r = t.alt,
      a = t.noLazyLoad,
      o = void 0 !== a && a,
      i = t.containerClassName,
      l = t.containerStyle,
      s = void 0 === l ? {} : l,
      u = t.imageClassName,
      m = t.imageStyle,
      p = void 0 === m ? {} : m,
      g = d(t, ["propName", "source", "alt", "noLazyLoad", "containerClassName", "containerStyle", "imageClassName", "imageStyle"]),
      f = (null == n ? void 0 : n.alt) || r;
  if (!n) return null;
  var b,
      h,
      x = mr(n.src, n.seoName),
      v = mr(n.placeholderSrc || "", n.seoName),
      y = (b = n.srcSet, h = n.seoName, b ? h ? b.split(",").map(function (t) {
    var n = e(t.trim().split(" "), 2),
        r = n[0],
        a = n[1];
    return r && a ? "".concat(mr(r, h), " ").concat(a) : mr(t, h);
  }).join(", ") : b : "");
  return o ? pe.createElement("div", {
    className: i,
    style: s
  }, pe.createElement("img", c({
    src: x,
    srcSet: y,
    alt: f,
    className: u,
    style: s
  }, g))) : pe.createElement("div", {
    className: i,
    style: s
  }, pe.createElement(ur, {
    src: x,
    srcSetData: {
      srcSet: y
    },
    placeholder: ""
  }, function (e, t, n) {
    return t ? pe.createElement("img", {
      src: v,
      alt: f,
      className: u,
      style: c({
        filter: "blur(8px)"
      }, p)
    }) : pe.createElement("img", c({
      src: e,
      srcSet: n.srcSet,
      alt: f,
      className: u,
      style: p
    }, g));
  }));
},
    gr = function gr(t) {
  var n,
      r = t.setModalOpen,
      a = t.file,
      o = t.modalOpen,
      i = t.onChange,
      l = t.allowedExtensions,
      s = be(ln).currentPage,
      d = e(ye({
    name: a ? a.name : "",
    size: a ? a.size : 0,
    url: a ? a.url : ""
  }), 2),
      u = d[0],
      m = d[1],
      p = e(ye(!!(null == a ? void 0 : a.size)), 2),
      g = p[0],
      f = p[1],
      h = {};
  l && l.length > 0 && (h = {
    accept: l
  });
  var x = $e(c(c({}, h), {
    onDropRejected: function onDropRejected(e) {
      e[0].errors.map(function (e) {
        var t = e.message;
        throw new Error(t);
      });
    },
    onDropAccepted: function onDropAccepted(e) {
      f(!0), m(c(c({}, u), {
        file: e[0],
        name: "",
        size: e[0].size / 1e3
      }));
    }
  })),
      v = x.getRootProps,
      y = x.getInputProps,
      w = tt(function (e) {
    return b(void 0, void 0, void 0, function () {
      return E(this, function (t) {
        switch (t.label) {
          case 0:
            return [4, at.post("/admin/files", e).then(function (e) {
              return e.data;
            })];

          case 1:
            return [2, t.sent()];
        }
      });
    });
  }, {
    onSuccess: function onSuccess() {},
    onError: function onError() {
      ot.error("An error occurred while uploading the file");
    }
  });
  return ge.createElement(et, {
    isOpen: o,
    style: Zn,
    onRequestClose: function onRequestClose() {
      return r(!1);
    },
    parentSelector: function parentSelector() {
      return lr();
    }
  }, ge.createElement("style", null, '\n  .react-bricks-file-modal{\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;\n    font-size: 16px;\n    display: flex;\n    line-height: 1.5;\n  }\n  .react-bricks-file-modal .file-data {\n    box-sizing: border-box;\n\n    background-color: #edf2f7;\n    padding: 30px 32px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    color: #718096;\n  }\n  .react-bricks-file-modal .file-upload {\n    box-sizing: border-box;\n\n    background-color: #fff;\n    padding: 30px 32px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    color: #718096;\n    width: 100%\n  }\n\n  .react-bricks-file-modal .file-upload .file-data {\n    padding: 20px 32px 30px;\n    font-size: 14px;\n    line-height: 1;\n    text-align: center;\n  }\n\n  .react-bricks-file-modal .file-upload .file-remove a {\n    color: #c53030;\n  }\n  .react-bricks-file-modal .file-upload .file-remove a:hover {\n    color: #9b2c2c;\n    text-decoration: underline;\n  }\n\n  .react-bricks-file-modal .file-upload .file-download a {\n    color: #4299e1;\n  }\n  .react-bricks-file-modal .file-upload .file-download a:hover {\n    color: #2b689b;\n    text-decoration: underline;\n  }\n\n  .react-bricks-file-modal .file-upload .form-field {\n    margin-bottom: 24px;\n  }\n\n  .react-bricks-file-modal .file-upload .dropzone {\n    background-color: #fff;\n    padding: 20px 32px 30px;\n    border: 2px dashed #e2e8f0;\n    border-radius: 4px;\n    color: #718096;\n    font-size: 16px;\n  }\n\n  .react-bricks-file-modal .file-upload label {\n    box-sizing: border-box;\n    display: block;\n    margin-bottom: 4px;\n    font-size: 12px;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: #718096;\n  }\n  \n  .react-bricks-file-modal .file-upload input {\n    box-sizing: border-box;\n    width: 100%;\n    background-color: #fff;\n    font-size: 14px;\n    padding: 8px 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 4px;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n  }\n  \n  .react-bricks-file-modal .file-upload button.btn {\n    cursor: pointer;\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    background-color: #4299e1; /*f65a8e*/\n    color: #fff;\n    font-size: 14px;\n    font-weight: 600;\n    border: none;\n    border-radius: 4px;\n    padding: 8px 16px;\n    margin-top: 20px;\n  }\n\n  .btn-cancel{\n    cursor: pointer;\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    background-color: #9CA3AF;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 600;\n    border: none;\n    border-radius: 4px;\n    padding: 8px 16px;\n    margin-top: 20px;\n  }\n  .react-bricks-file-modal .file-upload button.btn:hover {\n    background-color: #3182ce; /*b43179*/\n    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%), 0 4px 6px -2px rgb(0 0 0 / 5%);\n  }\n'), ge.createElement("div", {
    className: "react-bricks-file-modal"
  }, ge.createElement("div", {
    className: "file-upload"
  }, g ? ge.createElement("div", {
    className: "form-field"
  }, ge.createElement("div", null, "File:", " ", void 0 !== u.file ? null === (n = u.file) || void 0 === n ? void 0 : n.name : null == a ? void 0 : a.name), ge.createElement("div", null, "Size:", " ", u.size >= 1e3 ? "".concat((u.size / 1e3).toFixed(1), " MB") : "".concat(u.size.toFixed(0), " Kb")), u.url && ge.createElement("div", {
    className: "file-download"
  }, ge.createElement("a", {
    href: u.url
  }, "Download file")), ge.createElement("div", {
    className: "file-remove"
  }, ge.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      !function (e) {
        e.preventDefault(), f(!1), m({
          name: "",
          file: void 0,
          size: 0,
          url: ""
        });
      }(e), i({
        name: "",
        size: 0,
        url: ""
      });
    }
  }, "Remove file"))) : ge.createElement("div", c({
    className: "form-field dropzone"
  }, v()), "Click or Drag & Drop to upload a file", ge.createElement("input", c({}, y()))), ge.createElement("div", {
    className: "form-field"
  }, ge.createElement("label", null, "File Name"), ge.createElement(Gn, {
    name: "name",
    value: null == u ? void 0 : u.name,
    onChange: function onChange(e) {
      return m(c(c({}, u), {
        name: e.target.value
      }));
    }
  })), ge.createElement("div", {
    className: "flex space-x-4"
  }, ge.createElement("button", {
    type: "button",
    className: "btn-cancel",
    onClick: function onClick() {
      r(!1), m({
        name: "",
        size: 0,
        url: ""
      });
    }
  }, "Cancel"), ge.createElement("button", {
    type: "button",
    className: "btn",
    onClick: function onClick(e) {
      return b(void 0, void 0, void 0, function () {
        var e, t;
        return E(this, function (n) {
          switch (n.label) {
            case 0:
              return e = new FormData(), u.file && e.append("file", u.file), s && -1 === s.pageId.indexOf("playground") && e.append("pageId", s.pageId), u.name && e.append("name", u.name), u.file ? [3, 1] : (0 === u.size ? i(null) : i(c({}, u)), [3, 3]);

            case 1:
              return [4, w.mutateAsync(e)];

            case 2:
              t = n.sent(), i(c(c({}, a), {
                name: t.name,
                size: t.size,
                url: t.url
              })), n.label = 3;

            case 3:
              return r(!1), [2];
          }
        });
      });
    }
  }, "Done")))));
},
    fr = function fr() {
  return ge.createElement("svg", {
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    "aria-label": "Loader",
    "data-testid": "puff-svg"
  }, ge.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: "2"
  }, ge.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "1"
  }, ge.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), ge.createElement("animate", {
    attributeName: "strokeOpacity",
    begin: "0s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  })), ge.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "1"
  }, ge.createElement("animate", {
    attributeName: "r",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), ge.createElement("animate", {
    attributeName: "strokeOpacity",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  }))));
},
    br = function br(e) {
  var t = ot.error(e, {
    hideAfter: 10,
    onClick: function onClick() {
      null == t || t();
    }
  }).hide;
},
    hr = function hr(e) {
  var t = e.topic,
      n = e.getLimitExceededError,
      r = e.conflictError,
      a = void 0 === r ? "Conflict error" : r,
      o = e.genericError;
  return function (e) {
    if (403 === e.status) {
      var r = e.data.message,
          i = void 0;

      try {
        if (!((i = JSON.parse(r)) && i.error && i.topic && i.plan && i.limit && "plan_limit_exceeded" === i.error && i.topic === t)) throw new Error("Incomplete error message");
        var l = i.plan,
            c = i.limit;
        br(n(l, c));
      } catch (e) {
        br("Forbidden operation");
      }
    } else 409 === e.status ? br(a) : br(o);
  };
},
    xr = function xr(e) {
  var t = e.className;
  return pe.createElement("svg", {
    className: t,
    viewBox: "0 0 450 100"
  }, pe.createElement("g", {
    id: "layer1",
    transform: "translate(0,-197)"
  }, pe.createElement("g", {
    transform: "matrix(6.6679482,0,0,6.6679482,-210.3068,-1556.9577)",
    id: "g2125"
  }, pe.createElement("path", {
    style: {
      fill: "#23192d",
      stroke: "none",
      strokeWidth: 4.32088709
    },
    d: "M 846.20898 126.58203 C 834.22573 126.58203 823.27838 129.29152 813.36914 134.70703 C 803.57512 140.12254 795.85494 147.5535 790.20898 157.00195 C 784.56302 166.45024 781.74023 176.99322 781.74023 188.63086 C 781.74023 200.38359 784.50636 211.04193 790.03711 220.60547 C 795.56784 230.16918 803.17277 237.7155 812.85156 243.24609 C 822.53034 248.66177 833.30383 251.37109 845.17188 251.37109 C 853.92886 251.37109 862.62775 249.41183 871.26953 245.49414 C 880.02653 241.57645 887.63146 236.27657 894.08398 229.59375 L 878.00977 212.13672 C 873.63126 216.51526 868.61861 220.02965 862.97266 222.67969 C 857.44193 225.21464 851.97021 226.48242 846.55469 226.48242 C 839.7565 226.48242 833.53267 224.81016 827.88672 221.46875 C 822.24075 218.01192 817.80633 213.40369 814.58008 207.64258 C 811.35381 201.76622 809.74023 195.31391 809.74023 188.28516 C 809.74023 181.25657 811.35381 174.86088 814.58008 169.09961 C 817.80633 163.3385 822.24075 158.78884 827.88672 155.44727 C 833.53267 152.10586 839.7565 150.43359 846.55469 150.43359 C 852.20066 150.43359 857.78763 151.87531 863.31836 154.75586 C 868.96433 157.52133 873.86172 161.3795 878.00977 166.33398 L 893.91016 146.80469 C 887.91852 140.58256 880.65935 135.6852 872.13281 132.11328 C 863.60626 128.42611 854.96598 126.58203 846.20898 126.58203 z M 1598.3184 127.10156 C 1589.7918 127.10156 1582.3021 128.42613 1575.8496 131.07617 C 1569.3971 133.72638 1564.3844 137.52972 1560.8125 142.48438 C 1557.2406 147.43903 1555.4551 153.14128 1555.4551 159.59375 C 1555.4551 166.9681 1557.1839 172.90285 1560.6406 177.39648 C 1564.2126 181.89028 1568.5337 185.28931 1573.6035 187.59375 C 1578.6734 189.89819 1585.241 192.25999 1593.3066 194.67969 C 1599.8744 196.6387 1605.0589 198.4242 1608.8613 200.03711 C 1612.7789 201.65035 1616.0041 203.84017 1618.5391 206.60547 C 1621.074 209.37077 1622.3418 212.88515 1622.3418 217.14844 C 1622.3418 222.56395 1619.98 226.88501 1615.2559 230.11133 C 1610.6469 233.22239 1604.3098 234.77734 1596.2441 234.77734 C 1589.4459 234.77734 1582.4173 233.28097 1575.1582 230.28516 C 1568.0143 227.17409 1561.562 222.79446 1555.8008 217.14844 L 1548.3691 231.49414 C 1554.476 237.25542 1561.7352 241.86365 1570.1465 245.32031 C 1578.5578 248.77698 1587.1981 250.50586 1596.0703 250.50586 C 1604.8273 250.50586 1612.5475 249.12272 1619.2305 246.35742 C 1626.0287 243.47687 1631.2718 239.44493 1634.959 234.25977 C 1638.7614 229.07477 1640.6621 223.02482 1640.6621 216.11133 C 1640.6621 208.62189 1638.8766 202.63052 1635.3047 198.13672 C 1631.7328 193.52783 1627.4116 190.07202 1622.3418 187.76758 C 1617.272 185.46314 1610.6477 183.04277 1602.4668 180.50781 C 1595.8991 178.43287 1590.7711 176.64737 1587.084 175.15039 C 1583.3968 173.53715 1580.2849 171.40395 1577.75 168.75391 C 1575.2151 165.98844 1573.9473 162.47422 1573.9473 158.21094 C 1573.9473 153.4868 1576.0219 149.80043 1580.1699 147.15039 C 1584.4332 144.38492 1590.0788 143.00195 1597.1074 143.00195 C 1602.1773 143.00195 1607.7095 143.92399 1613.7012 145.76758 C 1619.808 147.49591 1625.6841 150.14683 1631.3301 153.71875 L 1638.2422 138.85352 C 1632.8267 135.2816 1626.6048 132.45887 1619.5762 130.38477 C 1612.6627 128.19558 1605.5774 127.10156 1598.3184 127.10156 z M 1370.1328 127.44727 C 1358.4952 127.44727 1347.837 130.1548 1338.1582 135.57031 C 1328.4794 140.98582 1320.8159 148.41678 1315.1699 157.86523 C 1309.6392 167.19826 1306.875 177.51265 1306.875 188.80469 C 1306.875 200.21181 1309.6392 210.63765 1315.1699 220.08594 C 1320.7007 229.53422 1328.2489 237.02392 1337.8125 242.55469 C 1347.3761 247.9702 1357.919 250.67969 1369.4414 250.67969 C 1377.7375 250.67969 1385.9168 249.00742 1393.9824 245.66602 C 1402.0481 242.20935 1409.1353 237.48593 1415.2422 231.49414 L 1405.2168 220.60547 C 1400.4926 225.09927 1395.0776 228.67206 1388.9707 231.32227 C 1382.8639 233.85705 1376.642 235.12305 1370.3047 235.12305 C 1361.7781 235.12305 1353.9427 233.05037 1346.7988 228.90234 C 1339.655 224.75431 1334.0094 219.10673 1329.8613 211.96289 C 1325.7133 204.81905 1323.6387 197.04218 1323.6387 188.63086 C 1323.6387 180.10429 1325.7133 172.32741 1329.8613 165.29883 C 1334.0094 158.15482 1339.655 152.50741 1346.7988 148.35938 C 1353.9427 144.21134 1361.7781 142.13867 1370.3047 142.13867 C 1376.7572 142.13867 1383.0377 143.52164 1389.1445 146.28711 C 1395.2514 148.93715 1400.6078 152.68013 1405.2168 157.51953 L 1415.0684 145.59375 C 1409.3072 139.83264 1402.4524 135.39817 1394.502 132.28711 C 1386.6667 129.06079 1378.5441 127.44727 1370.1328 127.44727 z M 421.75586 128.48438 L 421.75586 249.46875 L 449.06445 249.46875 L 449.06445 214.90234 L 474.29883 214.90234 L 476.89062 214.90234 L 496.07617 249.46875 L 527.01367 249.46875 L 501.26172 209.54492 C 508.63602 206.08809 514.22301 201.07554 518.02539 194.50781 C 521.94301 187.82483 523.90234 179.81545 523.90234 170.48242 C 523.90234 157.11645 519.58123 146.80402 510.93945 139.54492 C 502.29767 132.17057 490.08446 128.48438 474.29883 128.48438 L 421.75586 128.48438 z M 546.99414 128.48438 L 546.99414 249.46875 L 641.01758 249.46875 L 641.01758 226.82812 L 574.30273 226.82812 L 574.30273 200.03711 L 632.54883 200.03711 L 632.54883 177.39648 L 574.30273 177.39648 L 574.30273 151.125 L 639.11719 151.125 L 639.11719 128.48438 L 546.99414 128.48438 z M 701.1582 128.48438 L 648.61719 249.46875 L 676.78906 249.46875 L 686.29492 225.96289 L 742.29297 225.96289 L 751.79883 249.46875 L 781.00781 249.46875 L 729.33008 128.48438 L 701.1582 128.48438 z M 898.29297 128.48438 L 898.29297 151.64453 L 935.10742 151.64453 L 935.10742 249.46875 L 962.41602 249.46875 L 962.41602 151.64453 L 999.40234 151.64453 L 999.40234 128.48438 L 898.29297 128.48438 z M 1018.166 128.48438 L 1018.166 249.46875 L 1070.709 249.46875 C 1084.4206 249.46875 1095.1355 246.58745 1102.8555 240.82617 C 1110.6907 234.94981 1114.6074 226.82719 1114.6074 216.45703 C 1114.6074 208.27623 1112.189 201.47801 1107.3496 196.0625 C 1102.6255 190.53106 1096.0578 187.13204 1087.6465 185.86523 C 1094.4447 184.25216 1099.8011 181.08368 1103.7188 176.35938 C 1107.6364 171.51998 1109.5957 165.6438 1109.5957 158.73047 C 1109.5957 149.28219 1106.0247 141.90784 1098.8809 136.60742 C 1091.8522 131.19191 1082.1727 128.48438 1069.8438 128.48438 L 1018.166 128.48438 z M 1141.3789 128.48438 L 1141.3789 249.46875 L 1157.9707 249.46875 L 1157.9707 211.79102 L 1188.7363 211.79102 C 1190.4647 211.79102 1192.7112 211.67549 1195.4766 211.44531 L 1219.5 249.46875 L 1238.5117 249.46875 L 1210.3398 208.50586 C 1218.8664 205.51005 1225.3774 200.67127 1229.8711 193.98828 C 1234.48 187.3053 1236.7832 179.06749 1236.7832 169.27344 C 1236.7832 156.25323 1232.5793 146.22797 1224.168 139.19922 C 1215.8719 132.05538 1204.0611 128.48438 1188.7363 128.48438 L 1141.3789 128.48438 z M 1266.2793 128.48438 L 1266.2793 249.46875 L 1282.8711 249.46875 L 1282.8711 128.48438 L 1266.2793 128.48438 z M 1438.4395 128.48438 L 1438.4395 249.46875 L 1455.0312 249.46875 L 1455.0312 217.83984 L 1477.3281 193.64258 L 1519.8457 249.46875 L 1539.8945 249.46875 L 1488.9082 180.67969 L 1536.7832 128.48438 L 1516.9062 128.48438 L 1455.0312 196.4082 L 1455.0312 128.48438 L 1438.4395 128.48438 z M 1157.9707 143.52148 L 1188.7363 143.52148 C 1199.1065 143.52148 1207.0572 145.76809 1212.5879 150.26172 C 1218.1186 154.64026 1220.8828 161.14919 1220.8828 169.79102 C 1220.8828 178.66319 1218.1186 185.40479 1212.5879 190.01367 C 1207.0572 194.50747 1199.1065 196.75391 1188.7363 196.75391 L 1157.9707 196.75391 L 1157.9707 143.52148 z M 1034.7578 143.69336 L 1068.9805 143.69336 C 1076.47 143.57827 1082.2308 145.07643 1086.2637 148.1875 C 1090.4117 151.2984 1092.4844 155.73482 1092.4844 161.49609 C 1092.4844 167.37246 1090.4117 171.92407 1086.2637 175.15039 C 1082.2308 178.26146 1076.47 179.81641 1068.9805 179.81641 L 1034.7578 179.81641 L 1034.7578 143.69336 z M 449.06445 151.125 L 474.29883 151.125 C 481.90359 151.125 487.72303 152.85371 491.75586 156.31055 C 495.90391 159.65196 497.97656 164.66467 497.97656 171.34766 C 497.97656 178.1459 495.90391 183.33042 491.75586 186.90234 C 487.72303 190.35901 481.90359 192.08789 474.29883 192.08789 L 449.06445 192.08789 L 449.06445 151.125 z M 714.4668 157.00195 L 733.47852 204.01367 L 695.2832 204.01367 L 714.4668 157.00195 z M 1034.7578 194.85352 L 1068.9805 194.85352 C 1077.9679 194.85352 1084.9966 196.58045 1090.0664 200.03711 C 1095.1362 203.49377 1097.6699 208.27594 1097.6699 214.38281 C 1097.6699 220.7202 1095.1362 225.67613 1090.0664 229.24805 C 1084.9966 232.70706 1077.9679 234.37737 1068.9805 234.25977 L 1034.7578 234.25977 L 1034.7578 194.85352 z ",
    transform: "matrix(0.03967987,0,0,0.03967987,31.539957,263.04309)",
    id: "path2217"
  }), pe.createElement("g", {
    transform: "matrix(0.45707395,0,0,0.45707395,-5.476545,228.6835)",
    id: "g2123"
  }, pe.createElement("path", {
    style: {
      color: "#000000",
      fill: "#b43278",
      strokeWidth: 6.3499999,
      strokeLinecap: "round"
    },
    d: "m 89.441569,80.202363 c -4.314359,-0.08215 -4.314359,6.431634 0,6.349484 h 2.601907 c 4.314357,0.08215 4.314357,-6.431634 0,-6.349484 z m 13.696321,8.201051 c -4.293622,-0.06072 -4.293622,6.410722 0,6.35 h 2.60191 c 4.29362,0.06072 4.29362,-6.410724 0,-6.35 z m -13.712341,8.201565 c -4.293532,-0.06063 -4.293532,6.410631 0,6.350001 h 2.601907 c 4.293531,0.0606 4.293531,-6.410625 0,-6.350001 z",
    id: "path2119"
  }), pe.createElement("path", {
    style: {
      color: "#000000",
      fill: "#f65a8e",
      stroke: "none",
      strokeWidth: 6.3499999,
      strokeLinecap: "round"
    },
    d: "m 99.752893,80.202362 c -4.314356,-0.08215 -4.314356,6.431635 0,6.349484 h 5.970697 c 4.31436,0.08215 4.31436,-6.431634 0,-6.349484 z m -10.327018,8.201052 c -4.293624,-0.06072 -4.293624,6.410722 0,6.35 h 5.970696 c 4.293624,0.06072 4.293624,-6.410725 0,-6.35 z m 10.34252,8.201564 c -4.293528,-0.06063 -4.293528,6.410632 0,6.350002 h 5.971215 c 4.29353,0.0606 4.29353,-6.410626 0,-6.350002 z",
    id: "path2121"
  })))));
},
    vr = function vr(t, n) {
  return n.getDefaultContent ? n.getDefaultContent().reduce(function (n, r) {
    var a = t[r],
        o = (null == a ? void 0 : a.schema.getDefaultProps) ? null == a ? void 0 : a.schema.getDefaultProps() : {};
    return o ? A(A([], e(n), !1), [{
      id: Ut(),
      type: r,
      props: o
    }], !1) : n;
  }, []) : [];
},
    yr = function yr() {
  return ge.createElement("div", {
    className: "flex items-center justify-between px-2 mb-2"
  }, ge.createElement("div", {
    className: "text-sm font-semibold italic"
  }, "Create a new page!"), ge.createElement("div", {
    style: {
      width: 40
    }
  }, ge.createElement("svg", {
    viewBox: "0 0 100 50"
  }, ge.createElement("path", {
    d: "M5,30 Q84,37 75,5",
    stroke: "#f65a8e",
    fill: "transparent",
    strokeWidth: "5",
    strokeLinecap: "round"
  }), ge.createElement("path", {
    d: "M75,5 65,15",
    stroke: "#f65a8e",
    fill: "transparent",
    strokeWidth: "5",
    strokeLinecap: "round"
  }), ge.createElement("path", {
    d: "M75,5 84,15",
    stroke: "#f65a8e",
    fill: "transparent",
    strokeWidth: "5",
    strokeLinecap: "round"
  }))));
},
    wr = function wr(e, t) {
  return e ? e.filter(function (e) {
    return e.type === t;
  }) : [];
},
    kr = function kr() {
  var t = be(g),
      n = t.pageTypes,
      r = t.bricks,
      a = be(ln),
      o = a.currentPage,
      i = a.setCurrentPage,
      l = a.previewMode,
      s = a.sidebarCollapsed,
      d = B(),
      u = d.data,
      m = d.error,
      p = d.isLoading,
      h = d.isFetching,
      x = function () {
    var e = nt();
    return tt(function (e) {
      var t = e.type,
          n = e.name,
          r = e.content,
          a = e.status,
          o = e.isLocked,
          i = e.language;
      return b(void 0, void 0, void 0, function () {
        return E(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, at.post("/admin/pages", {
                id: Ut(),
                type: t,
                name: n,
                content: JSON.stringify(r),
                status: a,
                isLocked: o,
                language: i
              }).then(function (e) {
                return e.data;
              })];

            case 1:
              return [2, e.sent()];
          }
        });
      });
    }, {
      onSuccess: function onSuccess() {
        e.invalidateQueries("pages"), ot.success("New page created", {
          position: "bottom-right"
        });
      },
      onError: hr({
        topic: "page",
        getLimitExceededError: function getLimitExceededError(e, t) {
          return "The ".concat(e, " plan has a limit of ").concat(t, " pages.");
        },
        conflictError: "A page with the same name already exists",
        genericError: "An error occurred while adding the new page"
      })
    });
  }(),
      v = e(ye(""), 2),
      y = v[0],
      w = v[1],
      k = e(ye(""), 2),
      C = k[0],
      A = k[1],
      N = e(ye([]), 2),
      S = N[0],
      I = N[1],
      L = e(ye(""), 2),
      z = L[0],
      P = L[1];

  he(function () {
    var e = n.map(function (e, t) {
      return c(c({}, e), {
        isOpen: !t
      });
    });
    I(e);
  }, [n]);

  var D = function D() {
    w(""), A("");
  },
      T = function T(e) {
    return b(void 0, void 0, void 0, function () {
      var t, a, o;
      return E(this, function (l) {
        switch (l.label) {
          case 0:
            return e.preventDefault(), (t = n.find(function (e) {
              return e.name === y;
            })) && C ? (a = {
              id: Ut(),
              type: y,
              name: C,
              status: t.defaultStatus || f.PageStatus.Draft,
              isLocked: !!t.defaultLocked,
              content: vr(r, t)
            }, [4, x.mutateAsync(a)]) : [3, 2];

          case 1:
            (o = l.sent()) && i({
              pageId: o.id,
              language: o.language
            }), l.label = 2;

          case 2:
            return w(""), A(""), [2];
        }
      });
    });
  },
      R = function R(e) {
    return e.isOpen || z;
  };

  return m ? null : pe.createElement("div", {
    style: {
      width: l || s ? 0 : 192,
      transition: "width 300ms"
    }
  }, !l && !s && pe.createElement("div", {
    className: "fixed top-0 pt-10 pb-12 w-48 h-full overflow-y-auto scrolling-touch"
  }, pe.createElement("nav", {
    className: "overflow-y-auto"
  }, pe.createElement("div", {
    className: "relative px-2 mt-4 mb-4"
  }, pe.createElement(Gn, {
    value: z,
    onChange: function onChange(e) {
      P(e.target.value);
    },
    className: "py-2 pr-5 pl-3",
    textSize: "xs",
    radiusSize: "full",
    placeholder: "Search page"
  }), pe.createElement(st, {
    className: "absolute text-gray-400",
    style: {
      top: 8,
      right: 15
    }
  })), S.map(function (e, t) {
    return pe.createElement("div", {
      className: "mb-3",
      key: e.name
    }, pe.createElement("div", {
      className: "flex flex-row justify-between items-center pl-2 border-b border-gray-300 pb-1 mb-2"
    }, pe.createElement("h3", {
      className: "flex items-center text-xs cursor-pointer leading-none font-semibold uppercase tracking-widest text-gray-500",
      onClick: (r = e.name, function () {
        I(S.map(function (e) {
          return e.name === r ? c(c({}, e), {
            isOpen: !e.isOpen
          }) : e;
        }));
      })
    }, R(e) ? pe.createElement(dt, {
      className: "text-sm mr-1"
    }) : pe.createElement(ut, {
      className: "text-sm mr-1"
    }), e.pluralName, u && wr(u, e.name).length > 0 && pe.createElement("div", {
      className: "ml-2 rounded-full bg-gray-200 flex justify-center items-center border border-gray-300",
      style: {
        fontSize: 9,
        width: 15,
        height: 15,
        flexShrink: 0
      }
    }, wr(u, e.name).length)), p || h ? pe.createElement("div", {
      className: "px-2 w-8 text-pink-500"
    }, pe.createElement(fr, null)) : pe.createElement(Te, {
      content: "Add new ".concat(e.name)
    }, pe.createElement("button", {
      type: "button",
      onClick: (n = e.name, function () {
        w(n), A("");
      }),
      title: "Add new ".concat(e.name),
      className: "text-gray-700 hover:text-black px-2"
    }, pe.createElement(Xt, {
      className: "text-base"
    })))), R(e) && u && u.length < 3 && y !== e.name && 0 === t && pe.createElement(yr, null), y === e.name && pe.createElement("form", {
      onSubmit: T,
      className: "flex flex-row justify-between items-center px-2 mb-3"
    }, pe.createElement(Gn, {
      autoFocus: !0,
      className: "h-6",
      textSize: "xs",
      style: {
        width: 132
      },
      value: C,
      onChange: function onChange(e) {
        return A(e.target.value);
      }
    }), pe.createElement("div", {
      className: "mx-1"
    }, pe.createElement("button", {
      type: "submit",
      className: "text-sm text-green-500 hover:text-green-600 mr-1"
    }, pe.createElement(mt, null)), pe.createElement("button", {
      type: "button",
      onClick: D,
      className: "text-sm text-gray-400 hover:text-red-500"
    }, pe.createElement(pt, null)))), pe.createElement("ul", null, u && R(e) && wr(u, e.name).filter(function (e) {
      return e.name.toLowerCase().indexOf(z.toLowerCase()) > -1;
    }).map(function (e) {
      return pe.createElement("li", {
        key: e.id,
        onClick: function onClick() {
          return i({
            pageId: e.id
          });
        },
        style: e.id === o.pageId ? {
          boxShadow: "0 0 5px rgba(74,85,104,0.08)"
        } : {},
        className: _e("text-sm px-2 py-1 flex flex-row justify-between items-center cursor-pointer", e.id === o.pageId ? "bg-white border-t border-b border-gray-300 font-semibold text-black hover:text-black" : e.status === f.PageStatus.Draft ? "hover:bg-white text-gray-400 hover:text-gray-900" : "hover:bg-white text-gray-700 hover:text-gray-900")
      }, pe.createElement("div", {
        className: "flex flex-row justify-start items-center flex-1"
      }, pe.createElement("div", {
        className: "mr-2"
      }, e.isLocked ? pe.createElement(gt, {
        className: "text-pink-400"
      }) : pe.createElement(ft, {
        className: "text-gray-400"
      })), pe.createElement("div", null, e.name)), e.status === f.PageStatus.Draft && pe.createElement(pe.Fragment, null, !e.scheduledForPublishingOn && pe.createElement(Te, {
        className: "text-xs",
        content: "Draft"
      }, pe.createElement("span", null, pe.createElement(bt, {
        className: "text-gray-400 ml-2"
      }))), e.scheduledForPublishingOn && lt(new Date(e.scheduledForPublishingOn), new Date()) && pe.createElement(Te, {
        className: "text-xs",
        content: "Scheduled for publishing on ".concat(ct(new Date(e.scheduledForPublishingOn), "MMMM do"))
      }, pe.createElement("span", null, pe.createElement(ht, {
        className: "text-gray-400 ml-2"
      }))), e.scheduledForPublishingOn && it(new Date(e.scheduledForPublishingOn), new Date()) && pe.createElement(Te, {
        className: "text-xs",
        content: "This page should be published soon."
      }, pe.createElement("span", null, pe.createElement(xt, {
        className: "text-gray-400 ml-2"
      })))));
    })));
    var n, r;
  }))), pe.createElement("div", {
    className: "fixed bg-gray-100 bottom-0 left-0 py-1 pl-2 text-xs flex flex-row justify-start items-center",
    style: {
      width: 180
    }
  }, pe.createElement("div", {
    className: "w-24"
  }, pe.createElement(xr, null)), pe.createElement("div", {
    className: "font-bold italic text-blue-500"
  }, "v3")));
},
    Er = function Er(e, t, n) {
  if ("function" != typeof e) return !0;
  var r = e(t, n);
  return !(!r || "string" == typeof r);
},
    Cr = function Cr(e, t) {
  return !t.schema.sideEditProps || t.schema.sideEditProps.reduce(function (t, n) {
    return n.groupName ? t && (r = e.props, !(a = n.props) || a.reduce(function (e, t) {
      return e && Er(t.validate, r[t.name], r);
    }, !0)) : t && Er(n.validate, e.props[n.name], e.props);
    var r, a;
  }, !0);
},
    Ar = function Ar(e, t, n) {
  return !t.schema.repeaterItems || !t.schema.repeaterItems.map(function (t) {
    var r = e.props[t.name],
        a = n[t.itemType];
    return !r || r.length < 1 || r.reduce(function (e, t) {
      return e && !!Cr(t, a);
    }, !0);
  }).some(function (e) {
    return !1 === e;
  });
};

!function (e) {
  e.Default = "DEFAULT", e.Primary = "PRIMARY", e.Danger = "DANGER";
}(ar || (ar = {}));

var Nr = function Nr(e) {
  var t,
      n = e.onClick,
      r = e.type,
      a = void 0 === r ? ar.Default : r,
      o = e.active,
      i = void 0 !== o && o,
      l = e.tooltip,
      c = void 0 === l ? "" : l,
      s = e.className,
      d = void 0 === s ? "" : s,
      u = e.children,
      m = ge.createElement("button", {
    className: _e("focus:outline-none text-sm leading-none", {
      "block p-2 hover:text-gray-900 hover:bg-white border border-transparent hover:border-gray-300 rounded transition-colors duration-150": a === ar.Default
    }, {
      "text-gray-600": a === ar.Default && !i
    }, {
      "text-gray-900 bg-white border-gray-300": a === ar.Default && i
    }, (t = {}, t[d] = !!d, t)),
    onClick: n
  }, u);
  return c ? ge.createElement(Te, {
    content: c
  }, m) : m;
},
    Sr = "undefined" != typeof window && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform),
    Ir = function Ir(e) {
  var t = e.page,
      n = e.sidebarOpen,
      r = e.setSidebarOpen,
      a = e.devicePreview,
      o = e.setDevicePreview,
      i = e.handleSave,
      l = e.saveStatus,
      c = e.isPlayground,
      s = void 0 !== c && c,
      d = e.autoSave,
      u = e.setAutoSave,
      m = be(g),
      p = m.bricks,
      h = m.isDarkColorMode,
      x = m.toggleColorMode,
      v = m.responsiveBreakpoints,
      y = m.enableAutoSave,
      w = m.disableSaveIfInvalidProps,
      k = m.enablePreview,
      C = m.editorPath,
      A = m.previewPath,
      N = be(ln),
      S = N.previewMode,
      I = N.setPreviewMode,
      L = N.sidebarCollapsed,
      z = N.setSidebarCollapsed,
      B = function (e, t) {
    return void 0 === t && (t = 432e4), tt(function (e) {
      var n = e.pageId,
          r = e.language;
      return b(void 0, void 0, void 0, function () {
        return E(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, at.post("/admin/pages/".concat(n, "/translations/").concat(r, "/create_preview_token"), {
                lifetime: t
              }).then(function (e) {
                return e.data;
              })];

            case 1:
              return [2, e.sent()];
          }
        });
      });
    }, {
      onSuccess: function onSuccess(t) {
        Kt("".concat(e, "?p=").concat(encodeURIComponent(t.token))), ot.success("Link copied to clipboard. It will expire in ".concat(72, " hours."), {
          position: "bottom-right",
          hideAfter: 4
        });
      },
      onError: function onError() {
        ot.error("An error occurred while generating a preview token", {
          position: "top-center"
        });
      }
    });
  }(window.location.href.replace(C, A)),
      P = t.content.reduce(function (e, t) {
    var n = p[t.type];
    return n ? e && Cr(t, n) && Ar(t, n, p) : e;
  }, !0);

  return S ? pe.createElement("div", {
    className: "fixed z-20 py-2 flex flex-row justify-center items-center bg-gray-100",
    style: {
      top: 40,
      left: 0,
      right: 0
    }
  }, pe.createElement(Nr, {
    className: "flex",
    onClick: function onClick() {
      return I(!1);
    }
  }, pe.createElement(vt, {
    className: "mr-1"
  }), "Exit preview")) : pe.createElement("div", {
    className: "fixed z-20 bg-gray-100",
    style: {
      top: 40,
      left: L ? 0 : 192,
      right: 0,
      transition: "all 300ms"
    }
  }, pe.createElement("div", {
    className: "w-full flex flex-row items-center pt-2 pb-1"
  }, pe.createElement("div", {
    className: "flex flex-1 justify-between"
  }, pe.createElement("div", {
    className: "flex flex-row justify-start items-center min-w-0"
  }, pe.createElement(Nr, {
    onClick: function onClick() {
      z(!L);
    },
    tooltip: L ? "Open menù" : "Close menù",
    className: "mr-2"
  }, pe.createElement(yt, null)), pe.createElement("h2", {
    className: "text-lg font-semibold text-gray-900 truncate mr-2 capitalize"
  }, t.name), !s && pe.createElement(pe.Fragment, null, pe.createElement("div", {
    className: "mr-2"
  }, t.status === f.PageStatus.Published ? pe.createElement("div", {
    className: "flex text-xs font-semibold leading-none py-1 px-2 rounded bg-green-200 text-green-800"
  }, pe.createElement(wt, {
    className: "mr-1"
  }), "Published") : pe.createElement("div", {
    className: "flex text-xs font-semibold leading-none py-1 px-2 rounded bg-gray-300 text-gray-700"
  }, pe.createElement(bt, {
    className: "mr-1"
  }), "Draft")), pe.createElement("div", {
    className: "mr-2"
  }, !0 === t.isLocked ? pe.createElement("div", {
    className: "flex text-xs font-semibold leading-none py-1 px-2 rounded bg-pink-200 text-pink-700"
  }, pe.createElement(gt, {
    className: "mr-1"
  }), "Locked") : pe.createElement("div", {
    className: "flex text-xs font-semibold leading-none py-1 px-2 rounded bg-gray-300 text-gray-700"
  }, pe.createElement(ft, {
    className: "mr-1"
  }), "Unlocked")))), pe.createElement("div", {
    className: "flex items-center"
  }, x && pe.createElement(Nr, {
    onClick: x,
    tooltip: "".concat(h ? "Light" : "Dark", " color mode"),
    className: "mr-1",
    active: h
  }, pe.createElement(kt, null)), v.map(function (e) {
    return pe.createElement(Nr, {
      key: e.width,
      onClick: function onClick() {
        return o(e);
      },
      tooltip: e.label,
      active: a.width === e.width,
      className: "mr-1"
    }, e.type === f.DeviceType.Desktop ? pe.createElement(qe, null) : e.type === f.DeviceType.Tablet ? pe.createElement(Ze, null) : pe.createElement(Ge, null));
  }), k && pe.createElement(Nr, {
    onClick: function onClick() {
      return B.mutate({
        pageId: t.id,
        language: t.language
      });
    },
    tooltip: "Get preview link"
  }, pe.createElement(Et, null)), pe.createElement(Nr, {
    onClick: function onClick() {
      return I(!0);
    },
    tooltip: "Full-screen preview"
  }, pe.createElement(Ct, null)))), pe.createElement("div", {
    className: "flex flex-row justify-end items-center px-3 space-x-4",
    style: {
      width: 275
    }
  }, !s && pe.createElement(pe.Fragment, null, y && pe.createElement("div", null, pe.createElement(Jt, {
    checked: d,
    onChange: function onChange(e) {
      return u(e);
    }
  }), pe.createElement("span", {
    className: _e("text-xs ml-1", d ? "text-green-500 font-semibold" : "text-gray-600")
  }, "Autosave")), pe.createElement(Te, {
    content: P ? "Save (".concat(Sr ? "cmd" : "ctrl", "+s)") : "Warning: at least one block has validation errors"
  }, pe.createElement("div", null, pe.createElement("button", {
    className: "px-6 py-2 bg-blue-500 hover:bg-blue-600 hover:shadow-lg text-sm leading-none text-white font-semibold rounded disabled:opacity-75 disabled:cursor-not-allowed",
    onClick: i,
    disabled: w && !P || "loading" === l
  }, "Save")))), pe.createElement(Nr, {
    onClick: function onClick() {
      return r(!n);
    },
    active: n,
    tooltip: n ? "Close sidebar" : "Open sidebar"
  }, pe.createElement(At, null)))));
},
    Lr = function Lr(t) {
  var n = t.children,
      r = t.styles,
      a = t.stylesheets,
      o = t.head,
      i = d(t, ["children", "styles", "stylesheets", "head"]),
      l = e(ye(null), 2),
      s = l[0],
      u = l[1],
      m = e(ye(null), 2),
      p = m[0],
      g = m[1],
      f = e(ye(!1), 2),
      b = f[0],
      h = f[1],
      x = ve(null);
  he(function () {
    if (b) {
      var e = x.current.contentDocument.head;

      if (e.innerHTML = "", r && r.forEach(function (t) {
        return e.appendChild(t.cloneNode(!0));
      }), a && a.forEach(function (t) {
        return e.appendChild(t.cloneNode(!0));
      }), u(e), !p) {
        var t = x.current.contentDocument.body;
        g(t);
      }
    }
  }, [r, a, b]);
  return ge.createElement("iframe", c({
    ref: x,
    srcDoc: "<!DOCTYPE html>",
    title: "content"
  }, i, {
    onLoad: function onLoad(e) {
      e.defaultPrevented || e.target.contentDocument && h(!0);
    }
  }), s && Zt.createPortal(o, s), p && Zt.createPortal(n, p));
},
    zr = function zr(t) {
  var r = t.contentLength,
      o = t.contentRef,
      i = t.block,
      l = t.index,
      s = t.locked,
      d = t.setAddAfterBlockId,
      u = t.handleChange,
      m = t.handleAddBlockAfter,
      p = t.handleAddBlockBefore,
      b = t.handleRemoveBlock,
      h = t.handleSort,
      x = t.handleAddItem,
      v = t.handleDuplicate,
      y = be(g).bricks,
      w = be(ln).previewMode,
      k = be(a),
      E = k.focused,
      C = k.setFocused,
      A = e(Y(), 1)[0],
      N = function N(e) {
    var t = y[e.type];

    if (t) {
      var r = e.props;
      return t.schema.mapExternalDataToProps && "function" == typeof t.schema.mapExternalDataToProps && A.externalData && "object" == typeof A.externalData && (r = t.schema.mapExternalDataToProps(A.externalData, e.props)), pe.createElement(n.Provider, {
        value: {
          values: r,
          onChange: u(e.id),
          blockId: e.id,
          parentId: e.id,
          parentType: e.type,
          contentRef: o,
          handleChange: u,
          handleAddItem: x
        }
      }, pe.createElement(t, c({}, r)));
    }
  },
      S = {};

  if (i.id !== E.blockId || w || (S.border = "2px solid #f65a8e", S.minHeight = "65px"), "PREVIEW_NEW" === i.id) return pe.createElement("div", null, N(i));
  var I = {
    position: "relative",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch"
  };
  return i.id !== E.blockId || w || s || (I.minHeight = "30px"), pe.createElement("div", {
    key: i.id,
    style: I
  }, i.id === E.blockId && !w && !s && pe.createElement(Te, {
    content: "Add new block before",
    appendTo: o.current
  }, pe.createElement("button", {
    onClick: p(i.id),
    className: "rb-action",
    tabIndex: -1,
    style: {
      top: -11,
      zIndex: 999,
      position: "absolute",
      left: "calc(50% - 12px)"
    }
  }, pe.createElement(Nt, null))), pe.createElement("div", {
    style: c({}, S),
    onClick: function onClick() {
      C({
        blockId: i.id,
        itemId: "",
        repeaterPropName: ""
      }), d("");
    },
    onFocus: function onFocus() {
      return setTimeout(function () {
        C({
          blockId: i.id,
          itemId: "",
          repeaterPropName: ""
        }), d("");
      }, 0);
    }
  }, N(i)), i.id === E.blockId && !w && !s && pe.createElement(pe.Fragment, null, pe.createElement(Te, {
    content: "Add new block after",
    appendTo: o.current
  }, pe.createElement("button", {
    onClick: m(i.id),
    className: "rb-action",
    tabIndex: -1,
    style: {
      bottom: -11,
      zIndex: 999,
      position: "absolute",
      left: "calc(50% - 12px)"
    }
  }, pe.createElement(Nt, null))), pe.createElement("div", {
    style: {
      zIndex: 999,
      position: "absolute",
      right: 6,
      top: 6
    }
  }, pe.createElement(Te, {
    content: "Remove block",
    appendTo: o.current
  }, pe.createElement("button", {
    className: "rb-action",
    onClick: b(i.id),
    tabIndex: -1
  }, pe.createElement(Gt, null)))), pe.createElement("div", {
    style: {
      zIndex: 999,
      position: "absolute",
      right: 6,
      bottom: 6
    }
  }, pe.createElement(Te, {
    content: "Duplicate block",
    appendTo: o.current
  }, pe.createElement("button", {
    className: "rb-action",
    onClick: v(i.id),
    tabIndex: -1
  }, pe.createElement(St, null)))), pe.createElement("div", {
    style: {
      zIndex: 999,
      position: "absolute",
      left: 6,
      top: 6,
      display: "flex",
      flexDirection: "column"
    }
  }, pe.createElement(Te, {
    content: "Move block up",
    appendTo: o.current
  }, pe.createElement("button", {
    disabled: 0 === l,
    onClick: h(i.id, f.SortDirection.Up),
    className: _e("rb-action", {
      disabled: 0 === l
    }),
    tabIndex: -1,
    style: {
      marginBottom: 4
    }
  }, pe.createElement(It, null))), pe.createElement(Te, {
    content: "Move block down",
    appendTo: o.current,
    placement: "bottom"
  }, pe.createElement("button", {
    disabled: l === r - 1,
    onClick: h(i.id, f.SortDirection.Down),
    className: _e("rb-action", {
      disabled: l === r - 1
    }),
    tabIndex: -1
  }, pe.createElement(dt, null))))));
},
    Br = function Br(e) {
  var t = e.previewNewBlock;
  return pe.createElement("div", {
    style: {
      border: "2px solid #f65a8e"
    }
  }, pe.createElement("div", {
    style: {
      color: "#b43179",
      letterSpacing: "0.05em",
      paddingTop: "1rem",
      paddingBottom: "1rem",
      textAlign: "center"
    }
  }, "NEW BLOCK HERE: SELECT ON THE RIGHT »"), t && pe.createElement(zr, {
    contentLength: 0,
    block: t,
    index: 1,
    locked: !0,
    setAddAfterBlockId: function setAddAfterBlockId() {},
    handleChange: function handleChange() {},
    handleAddBlockBefore: function handleAddBlockBefore() {},
    handleAddBlockAfter: function handleAddBlockAfter() {},
    handleRemoveBlock: function handleRemoveBlock() {},
    handleSort: function handleSort() {},
    handleDuplicate: function handleDuplicate() {}
  }));
},
    Pr = function Pr(e) {
  var t = e.pageTypeName,
      n = be(g),
      r = n.bricks,
      a = n.pageTypes;
  if (!t) return null;
  var o = a.find(function (e) {
    return e.name === t;
  });
  if (!o) return null;
  var i = Object.keys(r).filter(function (e) {
    return !r[e].schema.hideFromAddMenu && W(e, o.allowedBlockTypes, o.excludedBlockTypes);
  }).map(function (e) {
    return r[e].schema.label;
  }),
      l = Object.keys(r).filter(function (e) {
    return !r[e].schema.hideFromAddMenu && !W(e, o.allowedBlockTypes, o.excludedBlockTypes);
  }).map(function (e) {
    return r[e].schema.label;
  });
  return pe.createElement("div", {
    className: "p-3"
  }, pe.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Default status"), pe.createElement("div", {
    className: "flex flex-row mb-5"
  }, pe.createElement("div", {
    className: "flex-1 flex items-center py-1 px-3 bg-gray-500 text-white text-xs uppercase leading-none rounded mr-2 mb-1"
  }, o.defaultStatus), pe.createElement("div", {
    className: "flex-1 flex items-center py-1 px-3 bg-gray-500 text-white text-xs uppercase leading-none rounded mr-2 mb-1"
  }, o.defaultLocked ? "LOCKED" : "UNLOCKED")), i.length > 0 && pe.createElement(pe.Fragment, null, pe.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Allowed blocks"), pe.createElement("div", {
    className: "flex flex-row flex-wrap mb-5"
  }, i.map(function (e) {
    return pe.createElement("div", {
      key: e,
      className: "flex items-center py-1 px-3 bg-gray-500 text-white text-xs uppercase leading-none rounded mr-2 mb-1"
    }, e);
  }))), l.length > 0 && pe.createElement(pe.Fragment, null, pe.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Blocks excluded"), pe.createElement("div", {
    className: "flex flex-row flex-wrap"
  }, l.map(function (e) {
    return pe.createElement("div", {
      key: e,
      className: "flex items-center py-1 px-3 bg-gray-500 text-white text-xs uppercase leading-none rounded mr-2 mb-1"
    }, e);
  }))));
},
    Dr = function Dr(e) {
  var t = e.blockTypeName,
      n = be(g).pageTypes;
  if (!t) return null;
  var r = n.filter(function (e) {
    return W(t, e.allowedBlockTypes, e.excludedBlockTypes);
  }).map(function (e) {
    return e.name;
  }),
      a = n.filter(function (e) {
    return !W(t, e.allowedBlockTypes, e.excludedBlockTypes);
  }).map(function (e) {
    return e.name;
  });
  return pe.createElement("div", {
    className: "p-3"
  }, r.length > 0 && pe.createElement(pe.Fragment, null, pe.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Allowed in"), pe.createElement("div", {
    className: "flex flex-row flex-wrap mb-5"
  }, r.map(function (e) {
    return pe.createElement("div", {
      key: e,
      className: "flex items-center py-1 px-3 bg-gray-500 text-white text-xs uppercase leading-none rounded mr-2 mb-1"
    }, e);
  }))), a.length > 0 && pe.createElement(pe.Fragment, null, pe.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Excluded from"), pe.createElement("div", {
    className: "flex flex-row flex-wrap"
  }, a.map(function (e) {
    return pe.createElement("div", {
      key: e,
      className: "flex items-center py-1 px-3 bg-gray-500 text-white text-xs uppercase leading-none rounded mr-2 mb-1"
    }, e);
  }))));
},
    Tr = function Tr(t) {
  var n = t.name,
      r = t.defaultOpen,
      a = t.children,
      o = e(ye(!!r), 2),
      i = o[0],
      l = o[1];
  return pe.createElement("div", {
    className: "w-full border-t border-b border-gray-300 -mt-px"
  }, pe.createElement("div", {
    className: "flex justify-between items-center cursor-pointer p-3 text-gray-500 hover:bg-gray-200 hover:text-gray-700",
    onClick: function onClick() {
      l(!i);
    }
  }, pe.createElement("h3", {
    className: "text-xs leading-none font-semibold uppercase tracking-widest"
  }, n), i ? pe.createElement(It, {
    className: "text-sm mr-1"
  }) : pe.createElement(dt, {
    className: "text-sm mr-1"
  })), i && pe.createElement("div", {
    className: "px-3"
  }, a));
},
    Rr = function Rr(e) {
  return pe.createElement(dr, c({}, e, {
    source: e.source,
    onChange: e.onChange
  }));
},
    Mr = function Mr(e) {
  var t = e.options,
      n = e.value,
      r = e.onChange,
      a = e.isValid;
  return t[0] && t[0].value && !t[0].value.color ? (console.warn("DEPRECATED: Found color string instead of object with color prop", t), pe.createElement("div", {
    className: "flex flex-wrap"
  }, t.map(function (e) {
    return pe.createElement(Te, {
      key: e.value,
      content: e.label,
      delay: 400
    }, pe.createElement("div", {
      title: e.label,
      key: e.value,
      style: {
        width: 28,
        height: 28,
        border: "1px solid ".concat(n !== e.value || a ? "rgba(0,0,0,0.1)" : "#f56565"),
        backgroundColor: e.value,
        marginRight: 8
      },
      className: "flex justify-center items-center rounded-full cursor-pointer mb-2 hover:transform hover:scale-125",
      onClick: function onClick() {
        return r(e.value);
      }
    }, n && n === e.value && pe.createElement(mt, {
      className: _t(e.value).isLight() ? "text-black" : "text-white"
    })));
  }))) : pe.createElement("div", {
    className: "flex flex-wrap"
  }, t.map(function (e) {
    return e.value && e.value.color ? pe.createElement(Te, {
      key: e.value.color || e.value,
      content: e.label,
      delay: 400
    }, pe.createElement("div", {
      style: {
        width: 28,
        height: 28,
        border: "".concat((null == n ? void 0 : n.color) !== e.value.color || a ? "1px solid rgba(0,0,0,0.1)" : "2px solid #f56565"),
        backgroundColor: e.value.color,
        marginRight: 8
      },
      className: "flex justify-center items-center rounded-full cursor-pointer mb-2 transform hover:scale-125 transition-transform duration-150",
      onClick: function onClick() {
        return r(e.value);
      }
    }, (null == n ? void 0 : n.color) === e.value.color && pe.createElement(mt, {
      className: _t(e.value.color).isLight() ? "text-black" : "text-white"
    }))) : null;
  }));
},
    Or = function Or(e) {
  var t = e.options,
      n = e.value,
      r = e.onChange,
      a = e.isValid;
  return pe.createElement("div", null, t.map(function (e) {
    return pe.createElement("label", {
      className: _e("block text-sm text-gray-700 mb-0.5", {
        "text-red-600": n === e.value && !a
      }),
      htmlFor: e.value,
      key: e.value
    }, pe.createElement(Gn, {
      type: "radio",
      id: e.value,
      key: e.value,
      name: e.value,
      value: e.value,
      checked: n === e.value,
      onChange: function onChange(e) {
        return r(e.target.value);
      }
    }), e.label);
  }));
},
    Fr = ge.forwardRef(function (e, t) {
  return ge.createElement("select", c({
    ref: t,
    disabled: e.disabled
  }, e, {
    className: _e("block w-full rounded-md text-sm border-gray-300 focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50", {
      "cursor-not-allowed": !!e.disabled
    }, e.className),
    style: e.style || {}
  }));
}),
    Yr = function Yr(e) {
  var t = e.id,
      n = e.options,
      r = e.value,
      a = e.onChange,
      o = e.isValid;
  return pe.createElement(Fr, {
    id: t,
    className: _e({
      "border-red-500": !!r && !o
    }),
    value: r,
    onChange: function onChange(e) {
      return a(e.target.value);
    }
  }, n.map(function (e) {
    return pe.createElement("option", {
      key: e.value,
      value: e.value
    }, e.label);
  }));
},
    Wr = function Wr(t) {
  var n,
      r = t.id,
      a = t.blockId,
      o = t.value,
      i = t.selectOptions,
      l = t.onChange,
      c = t.isValid,
      s = e(ye((null == i ? void 0 : i.options) || []), 2),
      d = s[0],
      u = s[1];
  return he(function () {
    var e = !1;
    return function () {
      b(this, void 0, void 0, function () {
        var t;
        return E(this, function (n) {
          switch (n.label) {
            case 0:
              return (null == i ? void 0 : i.getOptions) ? [4, null == i ? void 0 : i.getOptions()] : [3, 2];

            case 1:
              return t = n.sent(), e || u(t), [3, 3];

            case 2:
              u((null == i ? void 0 : i.options) || []), n.label = 3;

            case 3:
              return [2];
          }
        });
      });
    }(), function () {
      e = !0;
    };
  }, [a]), (null === (n = null == i ? void 0 : i.options) || void 0 === n ? void 0 : n.length) || "function" == typeof (null == i ? void 0 : i.getOptions) ? i.display === f.OptionsDisplay.Select ? pe.createElement(Yr, {
    id: r,
    options: d,
    value: o,
    onChange: l,
    isValid: c
  }) : i.display === f.OptionsDisplay.Radio ? pe.createElement(Or, {
    options: d,
    value: o,
    onChange: l,
    isValid: c
  }) : i.display === f.OptionsDisplay.Color ? pe.createElement(Mr, {
    options: d,
    value: o,
    onChange: l,
    isValid: c
  }) : null : null;
},
    jr = function jr(e) {
  return ge.createElement("textarea", c({}, e, {
    className: _e("mt-1 block w-full text-sm rounded-md border-gray-300 focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50", e.classNames),
    rows: e.rows || 3
  }));
},
    Vr = function Vr(t) {
  var n,
      r = t.id,
      a = t.value,
      o = t.sideEditProp,
      i = t.isValid,
      l = t.onChange,
      s = e(ye(a), 2),
      d = s[0],
      u = s[1];

  if (he(function () {
    u(a);
  }, [a]), o.type === f.SideEditPropType.Textarea) {
    var m = {};
    return (null === (n = o.textareaOptions) || void 0 === n ? void 0 : n.height) && (m = {
      style: {
        height: o.textareaOptions.height
      }
    }), pe.createElement(jr, c({
      id: r,
      className: _e({
        "border-2 border-red-500": !i
      }),
      value: d || "",
      onChange: function onChange(e) {
        u(e.target.value), l(e.target.value);
      }
    }, m));
  }

  var p = "text",
      g = {};
  return o.type === f.SideEditPropType.Number && (p = "number", o.rangeOptions && (g = c({}, o.rangeOptions))), o.type === f.SideEditPropType.Date && (p = "date"), pe.createElement(Gn, c({
    id: r,
    textSize: "sm",
    className: _e({
      "border-2 border-red-500": !i
    }),
    type: p,
    value: d || ""
  }, g, {
    onChange: function onChange(e) {
      u(e.target.value), l(e.target.value);
    }
  }));
},
    Xr = function Xr(e) {
  var t = e.propName,
      n = e.label,
      r = e.checked,
      a = e.onChange,
      o = e.isValid;
  return ge.createElement("label", {
    htmlFor: t,
    className: "text-sm text-gray-700"
  }, ge.createElement(Gn, {
    id: t,
    className: _e({
      "text-red-600": !o
    }),
    type: "checkbox",
    checked: r,
    onChange: function onChange(e) {
      return a(e.target.checked);
    }
  }), n);
},
    Ur = function Ur(e) {
  var t = e.propName,
      n = e.value,
      r = e.rangeOptions,
      a = e.onChange;
  return ge.createElement("input", {
    id: t,
    type: "range",
    value: n,
    min: (null == r ? void 0 : r.min) || 0,
    max: (null == r ? void 0 : r.max) || 100,
    step: (null == r ? void 0 : r.step) || 1,
    onChange: function onChange(e) {
      return a(e.target.value);
    }
  });
},
    Hr = function Hr(e) {
  var t,
      n,
      r = e.prop,
      a = e.allProps,
      o = e.onChange,
      i = e.blockId,
      l = null,
      s = {
    isValid: !0
  };
  if ("function" == typeof r.show && !r.show(a)) return null;

  if ("function" == typeof r.validate) {
    var d = r.validate(a[r.name], a);
    "string" == typeof d ? (s.isValid = !1, s.errorMessage = d) : s.isValid = !!d;
  }

  if (r.type === f.SideEditPropType.Custom) {
    if (!r.component) return null;
    var u = r.component;
    l = pe.createElement(u, {
      id: r.name,
      value: a[r.name],
      onChange: o,
      isValid: s.isValid,
      errorMessage: s.errorMessage
    });
  }

  return r.type !== f.SideEditPropType.Text && r.type !== f.SideEditPropType.Number && r.type !== f.SideEditPropType.Date && r.type !== f.SideEditPropType.Textarea || (l = pe.createElement(Vr, {
    id: r.name,
    value: a[r.name],
    sideEditProp: c({}, r),
    isValid: s.isValid,
    onChange: o
  })), r.type === f.SideEditPropType.Boolean && (l = pe.createElement(Xr, {
    propName: r.name,
    label: r.label,
    checked: a[r.name] || !1,
    onChange: o,
    isValid: s.isValid
  })), r.type === f.SideEditPropType.Range && r.rangeOptions && (l = pe.createElement(Ur, {
    propName: r.name,
    value: a[r.name],
    rangeOptions: r.rangeOptions,
    onChange: o,
    isValid: s.isValid
  })), r.type === f.SideEditPropType.Image && (l = pe.createElement(Rr, {
    containerClassName: "w-full",
    imageClassName: "object-cover",
    source: a[r.name],
    propName: r.name,
    onChange: o,
    alt: r.name,
    maxWidth: null === (t = r.imageOptions) || void 0 === t ? void 0 : t.maxWidth,
    aspectRatio: null === (n = r.imageOptions) || void 0 === n ? void 0 : n.aspectRatio
  })), r.type === f.SideEditPropType.Select && r.selectOptions && (l = pe.createElement(Wr, {
    id: r.name,
    blockId: i,
    value: a[r.name],
    selectOptions: r.selectOptions,
    onChange: o,
    isValid: s.isValid
  })), pe.createElement("div", {
    className: "mb-6",
    key: r.name
  }, pe.createElement("label", {
    htmlFor: r.name,
    className: _e("block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1")
  }, r.label), l, s.errorMessage && pe.createElement("div", {
    className: "text-xs text-red-500 font-bold"
  }, s.errorMessage));
},
    Jr = function Jr(t) {
  var n,
      r,
      a = t.focusedBlock,
      o = t.onChange,
      i = a.block,
      l = a.Brick,
      s = (null === (n = null == l ? void 0 : l.schema) || void 0 === n ? void 0 : n.label) || "General",
      d = e(ye([]), 2),
      u = d[0],
      m = d[1];
  if (he(function () {
    var t,
        n = ((null === (t = null == l ? void 0 : l.schema) || void 0 === t ? void 0 : t.sideEditProps) || []).reduce(function (t, n) {
      var r;
      if (n.groupName) return i && "function" == typeof n.show && !n.show(i.props) ? t : A(A([], e(t), !1), [c(c({}, n), {
        isOpen: !!n.defaultOpen
      })], !1);
      var a = {
        groupName: s,
        props: [],
        defaultOpen: !0
      },
          o = t;
      return t && t[0] && t[0].groupName === s && (a = (r = e(t))[0], o = r.slice(1)), a.props = A(A([], e(a.props), !1), [n], !1), A([a], e(o), !1);
    }, []);
    m(n);
  }, [null === (r = null == l ? void 0 : l.schema) || void 0 === r ? void 0 : r.sideEditProps, i]), !l || !l.schema.sideEditProps || !i) return null;

  var p = function p(e) {
    return e.map(function (e) {
      return pe.createElement(Hr, {
        key: e.name,
        prop: e,
        allProps: i.props,
        onChange: function onChange(t) {
          o(e.name, t, e.shouldRefreshText);
        },
        blockId: i.id
      });
    });
  };

  return pe.createElement("div", {
    className: "knobs"
  }, u.map(function (e) {
    return pe.createElement(Tr, {
      key: e.groupName,
      name: e.groupName,
      defaultOpen: e.defaultOpen
    }, p(e.props));
  }));
},
    Kr = function Kr(t) {
  var n,
      r,
      o = t.content,
      i = t.pageType,
      l = t.type,
      c = t.addAfterBlockId,
      s = t.handleChange,
      d = t.handleAddBlock,
      u = t.handleAddItem,
      m = t.handleRemoveItem,
      p = t.handleSortItem,
      b = t.handlePreviewNewBlock,
      h = be(g),
      x = h.bricks,
      v = h.pageTypes,
      y = be(a),
      w = y.focused,
      k = y.setTriggerTextRefreshBlockId,
      E = e(ye(""), 2),
      C = E[0],
      N = E[1],
      S = ve(null),
      I = e(ye(function () {
    return {
      focusedBlock: null,
      FocusedBrick: null,
      focusedItem: null,
      focusedItemRepeaterItem: null,
      FocusedItemBrick: null,
      focusedItemTypeName: "",
      focusedBlockTypeName: ""
    };
  }), 2),
      L = I[0],
      z = I[1];
  he(function () {
    var e,
        t = w.blockId ? o.find(function (e) {
      return e.id === w.blockId;
    }) : null,
        n = t ? t.type : "",
        r = x[n],
        a = null,
        i = "",
        l = null,
        c = null;
    w.itemId && w.repeaterPropName && t && (a = t.props[w.repeaterPropName].find(function (e) {
      return e.id === w.itemId;
    })) && (i = a.type, l = x[i], c = null === (e = r.schema.repeaterItems) || void 0 === e ? void 0 : e.find(function (e) {
      return e.name === w.repeaterPropName;
    })), z({
      focusedBlock: t,
      FocusedBrick: r,
      focusedItem: a,
      focusedItemRepeaterItem: c,
      FocusedItemBrick: l,
      focusedBlockTypeName: n,
      focusedItemTypeName: i
    });
  }, [l, w, o]);

  var B,
      P,
      D = function D(e) {
    return function () {
      S.current = setTimeout(function () {
        return b(e);
      }, 700);
    };
  },
      T = function T() {
    b(null), clearTimeout(S.current);
  },
      R = function R(e, t, n) {
    var r = s(e, t, n);
    return function (t, n, a) {
      return void 0 === a && (a = !1), a && setTimeout(function () {
        k(e);
      }, 400), r(t, n);
    };
  };

  if ("rb-playground" !== i) {
    var M = v.find(function (e) {
      return e.name === i;
    });
    if (!M) return null;
    B = M.allowedBlockTypes, P = M.excludedBlockTypes;
  }

  var O = function O(e) {
    var t,
        n = e.brickToAdd;
    return pe.createElement("button", {
      className: "block w-full bg-white border border-gray-500 text-sm text-gray-600 hover:text-pink-600 hover:bg-pink-100 hover:border-pink-400 hover:shadow-lg font-semibold py-1 px-4 rounded mb-2",
      onClick: (t = n.name, function (e) {
        clearTimeout(S.current), d(t)(e), N("");
      }),
      onMouseOver: D(n.name),
      onMouseOut: T
    }, n.label);
  };

  return pe.createElement(pe.Fragment, null, !!L.FocusedBrick && L.FocusedBrick.schema.repeaterItems && pe.createElement(pe.Fragment, null, l === f.Tab.Block && pe.createElement("div", {
    className: "bg-white py-1 text-sm font-semibold text-black text-center border-b border-gray-300"
  }, L.FocusedBrick.schema.label), l === f.Tab.Item && pe.createElement("div", {
    className: "bg-white py-1 text-sm font-semibold text-black text-center border-b border-gray-300"
  }, null === (n = L.FocusedItemBrick) || void 0 === n ? void 0 : n.schema.label), l === f.Tab.Block && function (e, t) {
    var n = e.filter(function (e) {
      return !(L.focusedBlock && e.max && L.focusedBlock.props[e.name] && L.focusedBlock.props[e.name].length >= e.max);
    }).map(function (e) {
      var t = e.itemLabel;
      return e.itemLabel || (t = x[e.itemType].schema.label), pe.createElement("button", {
        key: e.itemType,
        className: "block w-full bg-white border border-gray-500 text-sm text-gray-600 hover:text-pink-600 hover:bg-pink-100 hover:border-pink-400 hover:shadow-lg font-semibold py-1 px-4 rounded mb-2",
        onClick: u(w.blockId, e.name, e.itemType)
      }, t);
    });
    if (0 === n.length) return null;
    var r = n.length < 5;
    return !1 !== t && !0 !== t || (r = t), pe.createElement(Tr, {
      name: "Add new...",
      defaultOpen: r
    }, n);
  }(L.FocusedBrick.schema.repeaterItems, L.FocusedBrick.schema.newItemMenuOpen), l === f.Tab.Item && !!L.FocusedBrick && L.focusedItem && L.focusedItemRepeaterItem && w.itemId && pe.createElement(pe.Fragment, null, pe.createElement("div", {
    className: "flex justify-between items-center p-3"
  }, pe.createElement("button", {
    className: "flex items-center leading-none p-2 border border-transparent hover:border-gray-300 rounded text-sm text-blue-600 hover:text-blue-700 hover:bg-white transition-colors duration-150 focus:outline-none",
    onClick: p(w.blockId, w.itemId, f.SortDirection.Up)
  }, "Move ", pe.createElement(Lt, null)), pe.createElement("button", {
    className: "flex items-center leading-none p-2 border border-transparent hover:border-gray-300 rounded text-sm text-blue-600 hover:text-blue-700 hover:bg-white transition-colors duration-150 focus:outline-none",
    onClick: p(w.blockId, w.itemId, f.SortDirection.Down)
  }, "Move ", pe.createElement(zt, null)), pe.createElement("button", {
    title: "Remove ".concat(L.focusedItemRepeaterItem.itemLabel || (null === (r = L.FocusedItemBrick) || void 0 === r ? void 0 : r.schema.label)),
    className: "flex items-center leading-none p-2 border border-transparent hover:border-gray-300 rounded text-sm text-red-700 hover:text-red-800 hover:bg-white transition-colors duration-150 focus:outline-none",
    onClick: m(w.blockId, w.itemId)
  }, "Remove")), pe.createElement(Jr, {
    focusedBlock: {
      block: L.focusedItem,
      Brick: L.FocusedItemBrick
    },
    onChange: R(w.itemId, w.blockId, L.focusedItemRepeaterItem.name)
  }))), l === f.Tab.Block && w.blockId && pe.createElement(pe.Fragment, null, pe.createElement(Jr, {
    focusedBlock: {
      block: L.focusedBlock,
      Brick: L.FocusedBrick
    },
    onChange: R(w.blockId)
  })), !w.blockId && !c && pe.createElement("h2", {
    className: "text-sm font-bold uppercase tracking-wider text-gray-600 mb-6"
  }, "Select a block to edit"), c && pe.createElement("div", {
    className: "p-3"
  }, pe.createElement("div", {
    className: "relative mb-3"
  }, pe.createElement(Gn, {
    value: C,
    onChange: function onChange(e) {
      N(e.target.value);
    },
    radiusSize: "full",
    className: "px-4 leading-none",
    placeholder: "Search block type...",
    autoFocus: !0
  }), pe.createElement(st, {
    className: "absolute text-gray-400",
    style: {
      top: 9,
      right: 11
    }
  })), function (t) {
    var n = function (e) {
      return Object.keys(e).map(function (t) {
        return {
          name: t,
          label: e[t].schema.label,
          hideFromAddMenu: e[t].schema.hideFromAddMenu,
          category: e[t].schema.category || "",
          tags: e[t].schema.tags || []
        };
      }).filter(function (e) {
        return !e.hideFromAddMenu && W(e.name, B, P) && (e.label.toLowerCase().indexOf(C.toLowerCase()) > -1 || e.category.toLowerCase().indexOf(C.toLowerCase()) > -1 || e.tags.join(" ").toLowerCase().indexOf(C.toLowerCase()) > -1);
      });
    }(t);

    if (n.some(function (e) {
      return e.category;
    })) {
      var r = function (t) {
        return t.reduce(function (t, n) {
          return n.category && -1 === t.indexOf(n.category) ? A(A([], e(t), !1), [n.category], !1) : t;
        }, []);
      }(n),
          a = n.filter(function (e) {
        return !e.category;
      });

      return pe.createElement(pe.Fragment, null, r.map(function (e) {
        return pe.createElement(Tr, {
          key: e,
          name: e,
          defaultOpen: !0
        }, n.filter(function (t) {
          return t.category === e;
        }).map(function (e) {
          return pe.createElement(O, {
            key: e.name,
            brickToAdd: e
          });
        }));
      }), a.length > 0 && pe.createElement(Tr, {
        name: "Other",
        defaultOpen: !0
      }, a.map(function (e) {
        return pe.createElement(O, {
          key: e.name,
          brickToAdd: e
        });
      })));
    }

    return n.map(function (e) {
      return pe.createElement(O, {
        key: e.name,
        brickToAdd: e
      });
    });
  }(x)));
},
    Qr = function Qr(e, t) {
  void 0 === t && (t = !1);
  var n = localStorage.getItem(j),
      r = V("t");
  return rt("session", function () {
    return b(void 0, void 0, void 0, function () {
      var n;
      return E(this, function (r) {
        switch (r.label) {
          case 0:
            return [4, at.get("/admin/session?refreshToken=".concat(t), {
              headers: {
                appid: e
              }
            })];

          case 1:
            return (n = r.sent().data).authToken && localStorage.setItem(j, n.authToken), [2, n];
        }
      });
    });
  }, {
    enabled: !(!r && !n || !e)
  });
},
    qr = ["aa", "ab", "ae", "af", "ak", "am", "an", "ar", "as", "av", "ay", "az", "ba", "be", "bg", "bh", "bi", "bm", "bn", "bo", "br", "bs", "ca", "ce", "ch", "co", "cr", "cs", "cu", "cv", "cy", "da", "de", "dv", "dz", "ee", "el", "en", "eo", "es", "et", "eu", "fa", "ff", "fi", "fj", "fo", "fr", "fy", "ga", "gd", "gl", "gn", "gu", "gv", "ha", "he", "hi", "ho", "hr", "ht", "hu", "hy", "hz", "ia", "id", "ie", "ig", "ii", "ik", "io", "is", "it", "iu", "ja", "jv", "ka", "kg", "ki", "kj", "kk", "kl", "km", "kn", "ko", "kr", "ks", "ku", "kv", "kw", "ky", "la", "lb", "lg", "li", "ln", "lo", "lt", "lu", "lv", "mg", "mh", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my", "na", "nb", "nd", "ne", "ng", "nl", "nn", "no", "nr", "nv", "ny", "oc", "oj", "om", "or", "os", "pa", "pi", "pl", "ps", "pt", "qu", "rm", "rn", "ro", "ru", "rw", "sa", "sc", "sd", "se", "sg", "si", "sk", "sl", "sm", "sn", "so", "sq", "sr", "ss", "st", "su", "sv", "sw", "ta", "te", "tg", "th", "ti", "tk", "tl", "tn", "to", "tr", "ts", "tt", "tw", "ty", "ug", "uk", "ur", "uz", "ve", "vi", "vo", "wa", "wo", "xh", "yi", "yo", "za", "zh", "zu"],
    Zr = function Zr(e) {
  var t,
      n = e.title,
      r = e.message,
      a = e.buttons,
      o = e.isOpen,
      i = e.setIsOpen,
      l = document.getElementById("rb-admin-frame");
  return null === (t = null == l ? void 0 : l.contentWindow) || void 0 === t || t.document.body, ge.createElement(et, {
    isOpen: o,
    onRequestClose: function onRequestClose() {
      return i(!1);
    },
    style: Zn,
    parentSelector: function parentSelector() {
      return lr();
    }
  }, ge.createElement("style", null, "\n.btn {\n  margin-right: 16px;\n  padding: 4px 20px; \n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: 500;\n  background-color: #fff;\n  line-height: 1.5;\n  cursor: pointer;\n}\n.btn:last-child {\n  margin-right: 0;\n}\n.danger {\n  border: 1px solid #f56565;\n  color: #e53e3e;\n}\n.danger:hover {\n  background-color: #f56565;\n  color: #fff\n}\n.confirm {\n  border: 1px solid #3182ce;\n  color: #4299e1;\n}\n.confirm:hover {\n  background-color: #3182ce;\n  color: #fff\n}\n.cancel {\n  border: 1px solid #edf2f7;\n  background-color: #edf2f7;\n  color: #718096;\n}\n.cancel:hover {\n  background-color: #e2e8f0;\n  color: #4a5568;\n}\n      "), ge.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
      fontSize: 16,
      lineHeight: 1.5,
      maxWidth: 448,
      padding: 32
    }
  }, ge.createElement("h2", {
    style: {
      fontSize: 20,
      fontWeight: "bold",
      marginTop: 0,
      marginBottom: 8
    }
  }, n), ge.createElement("p", {
    style: {
      color: "#4a5568",
      marginBottom: 20
    }
  }, r), ge.createElement("div", {
    style: {
      display: "flex"
    }
  }, a.map(function (e) {
    return ge.createElement("button", {
      key: e.label,
      type: "button",
      className: "btn ".concat(e.type),
      onClick: (t = e.onClick, function () {
        t(), i(!1);
      })
    }, e.label);
    var t;
  }))));
};

function Gr(e) {
  if (!e) return "";
  var t = e.slice(0, -1).split("T");
  return 2 === t.length ? t[0] : "";
}

function _r(e) {
  if (!e) return "00:00:00.000";
  var t = e.slice(0, -1).split("T");
  return 2 === t.length ? t[1] : "00:00:00.000";
}

function $r(e, t) {
  return e && t ? "".concat(e, "T").concat(t, "Z") : null;
}

var ea = function ea(e) {
  return !!e && ("pro" === e.toLowerCase() || "pro - yearly" === e.toLowerCase() || "enterprise" === e.toLowerCase());
},
    ta = function ta(t) {
  var n = t.url,
      r = t.onChange,
      a = e(ye(!1), 2),
      o = a[0],
      i = a[1],
      l = e(ye(""), 2),
      s = l[0],
      d = l[1],
      u = Qn(),
      m = $e({
    accept: "image/*",
    maxSize: 3145728,
    onDropAccepted: function onDropAccepted(e) {
      return b(void 0, void 0, void 0, function () {
        var t, n;
        return E(this, function (a) {
          switch (a.label) {
            case 0:
              return d(""), (t = new FormData()).append("file", e[0]), i(!0), [4, u.mutateAsync(t)];

            case 1:
              return n = a.sent(), r(n.src), i(!1), [2];
          }
        });
      });
    },
    onDropRejected: function onDropRejected(e) {
      var t = e[0].file.size <= 1048576 ? "".concat((e[0].file.size / 1024).toFixed(0), " KB") : "".concat((e[0].file.size / 1048576).toFixed(1), " MB");
      d("Image exceeds max file size of 3 MB (".concat(t, ")"));
    }
  }),
      p = m.getRootProps,
      g = m.getInputProps;
  return pe.createElement("div", {
    className: "mt-2 flex flex-col items-center"
  }, pe.createElement("div", {
    className: "relative w-40 h-40 flex justify-center items-center cursor-pointer overflow-hidden"
  }, n ? pe.createElement("img", {
    className: "w-full",
    src: n,
    alt: "Featured Image"
  }) : pe.createElement(cr, {
    className: "w-full"
  }), pe.createElement("div", c({
    className: "absolute top-0 left-0 z-10 opacity-0 w-full h-full flex justify-center items-center transition-opacity duration-300 hover:opacity-100 bg-pink-200 bg-opacity-75"
  }, p()), pe.createElement("div", {
    className: "p-4 rounded-full cursor-pointer border border-gray-200 shadow-md focus:outline-none",
    style: {
      backgroundColor: "rgba(255, 255, 255, 0.8)"
    }
  }, pe.createElement("svg", {
    style: {
      width: 40,
      fill: "#d9367f"
    },
    viewBox: "0 0 312.602 312.602"
  }, pe.createElement("path", {
    d: "M251.52,137.244c-3.966,0-7.889,0.38-11.738,1.134c-1.756-47.268-40.758-85.181-88.448-85.181c-43.856,0-80.964,32.449-87.474,75.106C28.501,129.167,0,158.201,0,193.764c0,36.106,29.374,65.48,65.48,65.48h54.782c4.143,0,7.5-3.357,7.5-7.5c0-4.143-3.357-7.5-7.5-7.5H65.48c-27.835,0-50.48-22.645-50.48-50.48c0-27.835,22.646-50.48,50.48-50.48c1.367,0,2.813,0.067,4.419,0.206l7.6,0.658l0.529-7.61c2.661-38.322,34.861-68.341,73.306-68.341c40.533,0,73.51,32.977,73.51,73.51c0,1.863-0.089,3.855-0.272,6.088l-0.983,11.968l11.186-4.367c5.356-2.091,10.99-3.151,16.747-3.151c25.409,0,46.081,20.672,46.081,46.081c0,25.408-20.672,46.08-46.081,46.08c-0.668,0-20.608-0.04-40.467-0.08c-19.714-0.04-39.347-0.08-39.999-0.08c-4.668,0-7.108-2.248-7.254-6.681v-80.959l8.139,9.667c2.667,3.17,7.399,3.576,10.567,0.907c3.169-2.667,3.575-7.398,0.907-10.567l-18.037-21.427c-2.272-2.699-5.537-4.247-8.958-4.247c-3.421,0-6.686,1.548-8.957,4.247l-18.037,21.427c-2.668,3.169-2.262,7.9,0.907,10.567c1.407,1.185,3.121,1.763,4.826,1.763c2.137,0,4.258-0.908,5.741-2.67l7.901-9.386v80.751c0,8.686,5.927,21.607,22.254,21.607c0.652,0,20.27,0.04,39.968,0.079c19.874,0.041,39.829,0.081,40.498,0.081c33.681,0,61.081-27.4,61.081-61.08C312.602,164.644,285.201,137.244,251.52,137.244z"
  })), pe.createElement("input", c({}, g())))), o && pe.createElement("div", {
    className: "absolute top-0 left-0 w-full h-full bg-white opacity-75 z-50 flex justify-center items-center"
  }, pe.createElement("div", {
    className: "loading w-24 text-pink-500"
  }, pe.createElement(Kn, null)))), !!s && pe.createElement("div", {
    className: "text-sm bg-pink-100 border-red-400 px-2 py-1 mt-6 text-red-600"
  }, s), pe.createElement("button", {
    className: "mt-6 text-sm text-red-700 hover:text-red-800 hover:underline transition-colors duration-150 focus:outline-none",
    onClick: function onClick() {
      r("");
    }
  }, "Remove featured image"));
},
    na = function na(t) {
  var n = t.pageId,
      r = t.pageCustomFields,
      a = t.customValues,
      o = t.onChange,
      i = "Custom Fields",
      l = e(ye([]), 2),
      s = l[0],
      d = l[1];
  if (he(function () {
    var t = (r || []).reduce(function (t, n) {
      var r;
      if (n.groupName) return a && "function" == typeof n.show && !n.show(a) ? t : A(A([], e(t), !1), [c(c({}, n), {
        isOpen: !!n.defaultOpen
      })], !1);
      var o = {
        groupName: i,
        props: [],
        defaultOpen: !0
      },
          l = t;
      return t && t[0] && t[0].groupName === i && (o = (r = e(t))[0], l = r.slice(1)), o.props = A(A([], e(o.props), !1), [n], !1), A([o], e(l), !1);
    }, []);
    d(t);
  }, [r, a]), !r) return null;

  var u = function u(e) {
    return e.map(function (e) {
      return pe.createElement(Hr, {
        key: e.name,
        prop: e,
        allProps: a || {},
        onChange: function onChange(t) {
          var n;
          o(((n = {})[e.name] = t, n));
        },
        blockId: n
      });
    });
  };

  return pe.createElement("div", {
    className: "knobs"
  }, s.map(function (e) {
    return pe.createElement(Tr, {
      key: e.groupName,
      name: e.groupName,
      defaultOpen: e.defaultOpen
    }, u(e.props));
  }));
},
    ra = [{
  value: "00:00:00.000",
  label: "0:00"
}, {
  value: "01:00:00.000",
  label: "1:00"
}, {
  value: "02:00:00.000",
  label: "2:00"
}, {
  value: "03:00:00.000",
  label: "3:00"
}, {
  value: "04:00:00.000",
  label: "4:00"
}, {
  value: "05:00:00.000",
  label: "5:00"
}, {
  value: "06:00:00.000",
  label: "6:00"
}, {
  value: "07:00:00.000",
  label: "7:00"
}, {
  value: "08:00:00.000",
  label: "8:00"
}, {
  value: "09:00:00.000",
  label: "9:00"
}, {
  value: "10:00:00.000",
  label: "10:00"
}, {
  value: "11:00:00.000",
  label: "11:00"
}, {
  value: "12:00:00.000",
  label: "12:00"
}, {
  value: "13:00:00.000",
  label: "13:00"
}, {
  value: "14:00:00.000",
  label: "14:00"
}, {
  value: "15:00:00.000",
  label: "15:00"
}, {
  value: "16:00:00.000",
  label: "16:00"
}, {
  value: "17:00:00.000",
  label: "17:00"
}, {
  value: "18:00:00.000",
  label: "18:00"
}, {
  value: "19:00:00.000",
  label: "19:00"
}, {
  value: "20:00:00.000",
  label: "20:00"
}, {
  value: "21:00:00.000",
  label: "21:00"
}, {
  value: "22:00:00.000",
  label: "22:00"
}, {
  value: "23:00:00.000",
  label: "23:00"
}],
    aa = require("react-tag-autocomplete"),
    oa = function oa(t) {
  var n,
      r,
      a = t.page,
      o = t.handleChangePageValue,
      i = be(ln).setCurrentPage,
      l = be(g),
      s = l.pageTypes,
      d = l.customFields,
      u = l.appId,
      m = d || [],
      p = s.find(function (e) {
    return e.name === a.type;
  }),
      h = (null == p ? void 0 : p.customFields) || [],
      x = A(A([], e(m), !1), e(h), !1),
      v = (n = localStorage.getItem(j), r = V("t"), rt(["authors"], function () {
    return b(void 0, void 0, void 0, function () {
      return E(this, function (e) {
        switch (e.label) {
          case 0:
            return [4, at.get("/admin/authors")];

          case 1:
            return [2, e.sent().data];
        }
      });
    });
  }, {
    enabled: !!r || !!n,
    staleTime: 3e5
  })).data,
      y = function () {
    var e = localStorage.getItem(j),
        t = V("t");
    return rt(["tags"], function () {
      return b(void 0, void 0, void 0, function () {
        return E(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, at.get("/admin/tags?pageSize=100")];

            case 1:
              return [2, e.sent().data];
          }
        });
      });
    }, {
      enabled: !!e || !!t,
      staleTime: 3e5
    });
  }().data,
      w = Qr(u).data,
      k = null == w ? void 0 : w.user,
      C = function () {
    var e = nt();
    return tt(function (e) {
      return b(void 0, void 0, void 0, function () {
        return E(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, at.post("/admin/pages/".concat(e, "/duplicate")).then(function (e) {
                return e.data;
              })];

            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, {
      onSuccess: function onSuccess() {
        e.invalidateQueries("pages"), ot.success("Page duplicated", {
          position: "bottom-right"
        });
      },
      onError: hr({
        topic: "page",
        getLimitExceededError: function getLimitExceededError(e, t) {
          return "The ".concat(e, " plan has a limit of ").concat(t, " pages.");
        },
        genericError: "An error occurred while duplicating this page"
      })
    });
  }(),
      N = function () {
    var e = nt();
    return tt(function (e) {
      return b(void 0, void 0, void 0, function () {
        return E(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, at.delete("/admin/pages/".concat(e)).then(function (e) {
                return e.data;
              })];

            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, {
      onSuccess: function onSuccess() {
        e.invalidateQueries("pages"), ot.success("Page deleted", {
          position: "bottom-right"
        });
      },
      onError: function onError() {
        ot.error("An error occurred while deleting the page");
      }
    });
  }(),
      S = function (e) {
    var t = e.pageId,
        n = e.language;
    return tt(function () {
      return b(void 0, void 0, void 0, function () {
        return E(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, at.delete("/admin/pages/".concat(t, "/translations/").concat(n)).then(function (e) {
                return e.data;
              })];

            case 1:
              return [2, e.sent()];
          }
        });
      });
    }, {
      onSuccess: function onSuccess() {
        ot.success("Translation deleted", {
          position: "bottom-right"
        });
      },
      onError: function onError() {
        ot.error("An error occurred while deleting the translation");
      }
    });
  }({
    pageId: a.id,
    language: a.language
  }),
      I = e(ye(!1), 2),
      L = I[0],
      z = I[1],
      B = e(ye(!1), 2),
      P = B[0],
      D = B[1],
      T = function T(e) {
    o({
      meta: c(c({}, a.meta), e)
    });
  },
      R = a.status === f.PageStatus.Published && a.scheduledForPublishingOn && lt(new Date(a.scheduledForPublishingOn), new Date()),
      M = a.status === f.PageStatus.Draft && a.scheduledForPublishingOn && it(new Date(a.scheduledForPublishingOn), new Date());

  return pe.createElement(pe.Fragment, null, pe.createElement(Tr, {
    name: "Status and Visibility",
    defaultOpen: !0
  }, pe.createElement("div", {
    className: "mb-3"
  }, pe.createElement("label", {
    htmlFor: "status",
    className: "block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Visibility"), pe.createElement(Fr, {
    id: "status",
    value: a.status,
    onChange: function onChange(e) {
      return o({
        status: e.target.value
      });
    }
  }, pe.createElement("option", {
    value: f.PageStatus.Published
  }, "Published"), pe.createElement("option", {
    value: f.PageStatus.Draft
  }, "Draft"))), pe.createElement("div", {
    className: "mb-3"
  }, pe.createElement("label", {
    htmlFor: "scheduledDate",
    className: "block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Schedule publish (GMT+0)", pe.createElement("span", {
    className: "ml-1 text-xs bg-blue-200 text-blue-800 py-px px-1 rounded uppercase"
  }, "PRO")), pe.createElement("div", {
    className: "flex"
  }, pe.createElement(Gn, {
    type: "date",
    className: "mr-2",
    id: "scheduledDate",
    value: Gr(a.scheduledForPublishingOn),
    onChange: function onChange(e) {
      return o({
        scheduledForPublishingOn: $r(e.target.value, _r(a.scheduledForPublishingOn))
      });
    },
    disabled: !ea(null == k ? void 0 : k.plan)
  }), pe.createElement(Fr, {
    id: "scheduledTime",
    value: _r(a.scheduledForPublishingOn),
    onChange: function onChange(e) {
      return o({
        scheduledForPublishingOn: $r(Gr(a.scheduledForPublishingOn), e.target.value)
      });
    },
    style: {
      width: 95,
      paddingRight: "1.5rem"
    },
    disabled: !ea(null == k ? void 0 : k.plan)
  }, ra.map(function (e) {
    return pe.createElement("option", {
      key: e.value,
      value: e.value
    }, e.label);
  }))), (R || M) && pe.createElement("div", {
    className: "text-sm text-red-500 mt-2 leading-tight"
  }, R && pe.createElement("div", null, "Please, set the status to Draft to enable the scheduled publishing."), M && pe.createElement("div", null, "The page will be published in a few minutes as it is scheduled for publishing in the past."))), pe.createElement("div", {
    className: "mb-3"
  }, pe.createElement("label", {
    htmlFor: "isLocked",
    className: "block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Page structure locked?"), pe.createElement(Fr, {
    id: "isLocked",
    value: a.isLocked ? 1 : 0,
    onChange: function onChange(e) {
      return o({
        isLocked: "0" !== e.target.value
      });
    }
  }, pe.createElement("option", {
    value: 0
  }, "Unlocked"), pe.createElement("option", {
    value: 1
  }, "Locked"))), pe.createElement("div", {
    className: "mb-3"
  }, pe.createElement("div", {
    className: "py-2"
  }, pe.createElement(Te, {
    content: "Create a new page with the same content"
  }, pe.createElement("button", {
    className: "text-sm text-blue-600 hover:text-blue-700 hover:underline transition-colors duration-150 focus:outline-none",
    onClick: function onClick() {
      C.mutate(a.id);
    }
  }, "Duplicate Page"))), pe.createElement("div", {
    className: "py-2"
  }, pe.createElement(Te, {
    content: "Delete the Page"
  }, pe.createElement("button", {
    className: "block text-sm text-red-700 hover:text-red-800 hover:underline transition-colors duration-150 focus:outline-none",
    onClick: function onClick() {
      z(!0);
    }
  }, "Delete Page")), k && k.languages.length > 1 && a.translations.length >= 2 && pe.createElement(Te, {
    content: "Delete this Translation"
  }, pe.createElement("button", {
    className: "text-sm text-red-700 hover:text-red-800 hover:underline transition-colors duration-150 focus:outline-none",
    onClick: function onClick() {
      D(!0);
    }
  }, "Delete Translation"))))), pe.createElement(Zr, {
    title: 'Confirm to delete "'.concat(a.name, '"?'),
    message: pe.createElement("span", null, "Are you sure you want to delete this page", " ", pe.createElement("b", {
      className: "text-gray-900"
    }, "and all its content in all languages"), "?"),
    buttons: [{
      label: "Yes, delete the page",
      onClick: function onClick() {
        return b(void 0, void 0, void 0, function () {
          return E(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, N.mutateAsync(a.id)];

              case 1:
                return e.sent(), i({
                  pageId: ""
                }), localStorage && (localStorage.removeItem("rb_p"), localStorage.removeItem("rb_l")), [2];
            }
          });
        });
      },
      type: "danger"
    }, {
      label: "Cancel",
      onClick: function onClick() {},
      type: "cancel"
    }],
    isOpen: L,
    setIsOpen: z
  }), pe.createElement(Zr, {
    title: "Confirm delete",
    message: "Are you sure you want to delete this translation?",
    buttons: [{
      label: "Yes, delete",
      onClick: function onClick() {
        return b(void 0, void 0, void 0, function () {
          var t, n, r;
          return E(this, function (o) {
            switch (o.label) {
              case 0:
                return t = A([], e(a.translations), !1), n = t.filter(function (e) {
                  return e.language !== a.language;
                }), r = n.some(function (e) {
                  return e.language === (null == k ? void 0 : k.defaultLanguage);
                }) ? null == k ? void 0 : k.defaultLanguage : n[0].language, [4, S.mutateAsync()];

              case 1:
                return o.sent(), i({
                  pageId: a.id,
                  language: r
                }), [2];
            }
          });
        });
      },
      type: "danger"
    }, {
      label: "Cancel",
      onClick: function onClick() {},
      type: "cancel"
    }],
    isOpen: P,
    setIsOpen: D
  }), pe.createElement(Tr, {
    name: "Page attributes"
  }, pe.createElement("div", {
    className: "mb-3"
  }, pe.createElement("label", {
    htmlFor: "slug",
    className: "block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Slug"), pe.createElement(Gn, {
    id: "slug",
    value: a.slug || "",
    onChange: function onChange(e) {
      var t = e.target.value;
      /^[A-Za-z0-9\-_]*$/.test(t) && o({
        slug: t
      });
    }
  })), pe.createElement("div", {
    className: "mb-3"
  }, pe.createElement("label", {
    htmlFor: "name",
    className: "block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Name"), pe.createElement(Gn, {
    id: "name",
    value: a.name || "",
    onChange: function onChange(e) {
      return o({
        name: e.target.value
      });
    }
  })), pe.createElement("div", {
    className: "mb-3"
  }, pe.createElement("label", {
    htmlFor: "authorId",
    className: "block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Author"), pe.createElement(Fr, {
    id: "authorId",
    value: a.authorId,
    onChange: function onChange(e) {
      return o({
        authorId: e.target.value
      });
    }
  }, v && v.map(function (e) {
    return pe.createElement("option", {
      key: e.id,
      value: e.id
    }, e.firstName, " ", e.lastName);
  }))), pe.createElement("div", {
    className: "mb-3"
  }, pe.createElement("label", {
    htmlFor: "publishedAt",
    className: "block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Publish Date"), pe.createElement(Gn, {
    type: "date",
    id: "publishedAt",
    value: a.publishedAt ? a.publishedAt.substr(0, 10) : "",
    onChange: function onChange(e) {
      return o({
        publishedAt: e.target.value
      });
    }
  })), pe.createElement("div", {
    className: "mb-3"
  }, pe.createElement("label", {
    htmlFor: "pageType",
    className: "block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Page Type"), pe.createElement(Fr, {
    id: "pageType",
    value: a.type,
    onChange: function onChange(e) {
      return o({
        type: e.target.value
      });
    }
  }, s.map(function (e) {
    return pe.createElement("option", {
      key: e.name,
      value: e.name
    }, e.name);
  })))), pe.createElement(Tr, {
    name: "Tags"
  }, pe.createElement(aa, {
    tags: a.tags.map(function (e) {
      return {
        id: e,
        name: e
      };
    }),
    allowNew: !0,
    onAddition: function onAddition(t) {
      if (-1 === a.tags.indexOf(t.name)) {
        var n = A(A([], e(a.tags), !1), [t.name.trim()], !1);
        o({
          tags: n
        });
      }
    },
    onDelete: function onDelete(e) {
      var t = a.tags.filter(function (t, n) {
        return n !== e;
      });
      o({
        tags: t
      });
    },
    onValidate: function onValidate(e) {
      return a.tags.every(function (t) {
        return t !== e.id;
      });
    },
    suggestions: null == y ? void 0 : y.map(function (e) {
      return {
        id: e,
        name: e
      };
    }),
    minQueryLength: 1
  })), pe.createElement(Tr, {
    name: "Featured Image"
  }, pe.createElement(ta, {
    url: a.meta.featuredImage,
    onChange: function onChange(e) {
      T({
        featuredImage: e
      });
    }
  })), pe.createElement(Tr, {
    name: "SEO Meta Tags"
  }, pe.createElement("div", {
    className: "mb-3"
  }, pe.createElement("label", {
    htmlFor: "meta_title",
    className: "block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Title"), pe.createElement(Gn, {
    id: "meta_title",
    value: a.meta.title || "",
    onChange: function onChange(e) {
      return T({
        title: e.target.value
      });
    }
  })), pe.createElement("div", {
    className: "mb-3"
  }, pe.createElement("label", {
    htmlFor: "meta_description",
    className: "block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Description"), pe.createElement(jr, {
    id: "meta_description",
    value: a.meta.description || "",
    rows: 3,
    onChange: function onChange(e) {
      return T({
        description: e.target.value
      });
    }
  })), pe.createElement("div", {
    className: "mb-3"
  }, pe.createElement("label", {
    htmlFor: "language",
    className: "block text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Language"), pe.createElement(Fr, {
    id: "language",
    value: a.meta.language || "en",
    onChange: function onChange(e) {
      return T({
        language: e.target.value
      });
    }
  }, qr.map(function (e) {
    return pe.createElement("option", {
      key: e,
      value: e
    }, e);
  })))), pe.createElement("div", {
    className: "border-t border-b border-gray-300"
  }), pe.createElement(na, {
    pageId: a.id,
    pageCustomFields: x,
    customValues: a.customValues,
    onChange: function onChange(e) {
      o({
        customValues: c(c({}, a.customValues), e)
      });
    }
  }));
},
    ia = function ia(t) {
  var n,
      r = t.isOpen,
      a = t.setIsOpen,
      o = t.focusedBlock,
      i = e(ye(""), 2),
      l = i[0],
      c = i[1],
      s = function (e) {
    var t = nt();
    return tt(function (t) {
      var n = t.name,
          r = t.props;
      return t.imageBlob, b(void 0, void 0, void 0, function () {
        var t;
        return E(this, function (a) {
          switch (a.label) {
            case 0:
              return (t = new FormData()).append("name", n), t.append("props", JSON.stringify(r)), [4, at.post("/admin/blocks/".concat(e, "/stories"), t, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }).then(function (e) {
                return e.data;
              })];

            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, {
      onSuccess: function onSuccess() {
        t.invalidateQueries(["storiesByBlock", {
          blockType: e
        }]), ot.success("New story created", {
          position: "bottom-right"
        });
      },
      onError: hr({
        topic: "story",
        getLimitExceededError: function getLimitExceededError(e, t) {
          return "The ".concat(e, " plan has a limit of ").concat(t, " stories.");
        },
        genericError: "An error occurred while adding the new story"
      })
    });
  }(null == o ? void 0 : o.type),
      d = document.getElementById("rb-admin-frame");

  return null === (n = null == d ? void 0 : d.contentWindow) || void 0 === n || n.document.body, ge.createElement(et, {
    isOpen: r,
    onRequestClose: function onRequestClose() {
      return a(!1);
    },
    style: Zn,
    parentSelector: function parentSelector() {
      return lr();
    }
  }, ge.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
      fontSize: 16,
      lineHeight: 1.5,
      maxWidth: 448,
      padding: 32
    }
  }, ge.createElement("h2", {
    style: {
      fontSize: 20,
      fontWeight: "bold",
      marginTop: 0,
      marginBottom: 8
    }
  }, "Give your story a name"), ge.createElement("form", {
    onSubmit: function onSubmit() {
      s.mutate({
        name: l,
        props: (null == o ? void 0 : o.props) || {}
      }), a(!1);
    }
  }, ge.createElement(Gn, {
    id: "name",
    value: l,
    onChange: function onChange(e) {
      return c(e.target.value);
    },
    name: "name",
    placeholder: "Write a name"
  }), ge.createElement("div", {
    className: "mb-3"
  }), ge.createElement("button", {
    type: "submit",
    className: "block px-5 py-1 bg-blue-500 hover:bg-blue-600 leading-6 text-white rounded disabled:opacity-75 disabled:cursor-not-allowed",
    disabled: !l
  }, "Save story"))));
},
    la = function la(t) {
  var n = t.content,
      r = t.handleSetStory,
      o = be(a).focused,
      i = be(g).appId,
      l = e(ye(""), 2),
      c = l[0],
      s = l[1],
      d = e(ye(), 2),
      u = d[0],
      m = d[1],
      p = e(ye(null), 2),
      f = p[0],
      h = p[1],
      x = e(ye(null), 2),
      v = x[0],
      y = x[1],
      w = e(ye(!1), 2),
      k = w[0],
      C = w[1],
      A = ve(null);
  he(function () {
    var e = o.blockId && n.find(function (e) {
      return e.id === o.blockId;
    }) || null;
    h(e);
  }, [n, o]);
  var N,
      S,
      I,
      L = (N = (null == f ? void 0 : f.type) || "", S = localStorage.getItem(j), I = V("t"), rt(["storiesByBlock", {
    blockType: N
  }], function () {
    return b(void 0, void 0, void 0, function () {
      return E(this, function (e) {
        switch (e.label) {
          case 0:
            return [4, at.get("/admin/blocks/".concat(N, "/stories"))];

          case 1:
            return [2, e.sent().data];
        }
      });
    });
  }, {
    enabled: !(!N || !S && !I),
    staleTime: 12e4
  })).data,
      z = Qr(i).data;
  null == z || z.user;

  var B = function (e) {
    var t = nt();
    return tt(function (t) {
      return b(void 0, void 0, void 0, function () {
        return E(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, at.delete("/admin/blocks/".concat(e, "/stories/").concat(t)).then(function (e) {
                return e.data;
              })];

            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, {
      onSuccess: function onSuccess() {
        ot.success("Story deleted", {
          position: "bottom-right"
        }), t.invalidateQueries(["storiesByBlock", {
          blockType: e
        }]);
      },
      onError: function onError() {
        ot.error("An error occurred while deleting the story");
      }
    });
  }(null == f ? void 0 : f.type),
      P = function P(e) {
    return function (t) {
      t.preventDefault(), clearTimeout(A.current), r(o.blockId, e.props), m(e.props), y(e.id), setTimeout(function () {
        return y(null);
      }, 1e3);
    };
  },
      D = function D(e) {
    return function () {
      m(null == f ? void 0 : f.props), A.current = setTimeout(function () {
        r(o.blockId, e.props);
      }, 400);
    };
  },
      T = function T() {
    r(o.blockId, u), clearTimeout(A.current);
  };

  return ea ? pe.createElement("div", {
    className: "p-3"
  }, pe.createElement("button", {
    className: "px-6 py-2 w-full bg-blue-500 hover:bg-blue-600 hover:shadow-lg text-sm leading-none text-white font-semibold rounded disabled:opacity-75 disabled:cursor-not-allowed mb-3",
    onClick: function onClick() {
      return C(!0);
    }
  }, "Save story as..."), !(L && L.length > 0) && pe.createElement("div", null, "No stories available yet for this block type."), L && L.length > 0 && pe.createElement("div", {
    className: "relative mb-3"
  }, pe.createElement(Gn, {
    value: c,
    onChange: function onChange(e) {
      s(e.target.value);
    },
    radiusSize: "full",
    className: "px-4 leading-none",
    placeholder: "Search stories..."
  }), pe.createElement(st, {
    className: "absolute text-gray-400",
    style: {
      top: 9,
      right: 11
    }
  })), L && L.length > 0 && L.filter(function (e) {
    return e.name.toLowerCase().indexOf(c.toLowerCase()) > -1;
  }).map(function (e) {
    return pe.createElement("div", {
      key: e.id,
      className: "flex items-center justify-between space-x-3 mb-2"
    }, pe.createElement("button", {
      className: _e("block w-full border border-gray-500 text-sm text-gray-600 hover:shadow-lg font-semibold py-1 px-4 rounded", e.id === v ? "bg-green-200 transition-colors duration-200" : "duration-1000 bg-white hover:text-pink-600 hover:bg-pink-100 hover:border-pink-400"),
      onClick: P(e),
      onMouseOver: D(e),
      onMouseOut: T
    }, e.name), pe.createElement("button", {
      className: "text-sm text-red-700 hover:text-red-800 transition-colors duration-150 focus:outline-none",
      onClick: function onClick() {
        return B.mutate(e.name);
      }
    }, pe.createElement(Bt, null)));
  }), pe.createElement(ia, {
    isOpen: k,
    setIsOpen: C,
    focusedBlock: f
  })) : pe.createElement("div", {
    className: "p-3"
  }, "This feature is allowed only for Pro or Enterprise plans.");
},
    ca = function ca(t) {
  var n = t.page,
      r = t.content,
      o = t.addAfterBlockId,
      i = t.handleChange,
      l = t.handleSetStory,
      s = t.handleAddBlock,
      d = t.handleAddItem,
      u = t.handleRemoveItem,
      m = t.handleSortItem,
      p = t.handlePreviewNewBlock,
      b = t.handleChangePageValue,
      h = t.playgroundSelectedItem,
      x = t.sidebarOpen,
      v = be(g).bricks,
      y = be(a).focused,
      w = be(ln).previewMode,
      k = e(ye({
    selectedTab: f.Tab.Document,
    block: ""
  }), 2),
      E = k[0],
      C = k[1];
  he(function () {
    var e,
        t = y.blockId ? r.find(function (e) {
      return e.id === y.blockId;
    }) : null,
        n = t ? t.type : "",
        a = v[n],
        o = null,
        i = "",
        l = null,
        c = null;
    a && y.itemId && y.repeaterPropName && t && (o = t.props[y.repeaterPropName].find(function (e) {
      return e.id === y.itemId;
    })) && (i = o.type, l = v[i], c = null === (e = a.schema.repeaterItems) || void 0 === e ? void 0 : e.find(function (e) {
      return e.name === y.repeaterPropName;
    }));
    var s = o ? f.Tab.Item : t || "ADD_BLOCK" === y.blockId ? f.Tab.Block : (null == h ? void 0 : h.type) === f.PlaygroundSelectedItemType.Page ? f.Tab.PageSettings : f.Tab.Document;
    C({
      selectedTab: s,
      block: (null == a ? void 0 : a.schema.label) || "",
      item: (null == c ? void 0 : c.itemLabel) || (null == l ? void 0 : l.schema.label) || ""
    });
  }, [n.id, y]);

  var A = function A(e, t, n) {
    return void 0 === n && (n = !1), t && pe.createElement("button", {
      className: "flex-1 py-3 text-center leading-none text-sm border-b-4 focus:outline-none hover:text-gray-800 ".concat(E.selectedTab === e || n ? "border-pink-500 text-gray-900 font-semibold" : "border-transparent text-gray-600"),
      style: {
        marginBottom: "-1px"
      },
      onClick: function onClick() {
        return function (e) {
          C(c(c({}, E), {
            selectedTab: e
          }));
        }(e);
      }
    }, t);
  };

  return pe.createElement("aside", {
    style: {
      transition: "width 300ms",
      width: w || !x ? 0 : 275
    }
  }, !w && pe.createElement("div", {
    className: "fixed top-0 h-full overflow-y-auto",
    style: {
      paddingTop: 85,
      width: 275
    }
  }, n.invalidBlocksTypes && n.invalidBlocksTypes.length > 0 && pe.createElement("div", {
    className: "p-3"
  }, pe.createElement("div", {
    className: "border border-pink-400 bg-pink-100 rounded px-2 py-1 mb-3 text-sm leading-tight"
  }, pe.createElement("b", null, "Warning:"), " found ", n.invalidBlocksTypes.length, " ", n.invalidBlocksTypes.length > 1 ? "blocks" : "block", " of unrecognized or not allowed type:", n.invalidBlocksTypes.map(function (e) {
    return pe.createElement("code", {
      key: e,
      className: "ml-1 text-xs px-1 py-px bg-pink-200 rounded"
    }, e);
  }), ". Saving will delete invalid blocks.")), pe.createElement("div", {
    className: "flex flex-row items-center justify-around border-b border-gray-300"
  }, !h && A(f.Tab.Document, "Page"), (null == h ? void 0 : h.type) !== f.PlaygroundSelectedItemType.Page && y.blockId && A(f.Tab.Block, "Block"), (null == h ? void 0 : h.type) !== f.PlaygroundSelectedItemType.Page && y.blockId && A(f.Tab.Stories, "Stories"), (null == h ? void 0 : h.type) !== f.PlaygroundSelectedItemType.Page && y.blockId && E.item && A(f.Tab.Item, "Item"), (null == h ? void 0 : h.type) === f.PlaygroundSelectedItemType.Page && A(f.Tab.PageSettings, "Page settings", !0)), (null == h ? void 0 : h.type) !== f.PlaygroundSelectedItemType.Page && (E.selectedTab === f.Tab.Block || E.selectedTab === f.Tab.Item) && pe.createElement(Kr, {
    content: r,
    pageType: n.type,
    type: E.selectedTab,
    addAfterBlockId: o,
    handleChange: i,
    handleAddBlock: s,
    handleAddItem: d,
    handleRemoveItem: u,
    handleSortItem: m,
    handlePreviewNewBlock: p
  }), (null == h ? void 0 : h.type) !== f.PlaygroundSelectedItemType.Page && E.selectedTab === f.Tab.Stories && pe.createElement(la, {
    content: r,
    handleSetStory: l
  }), !h && E.selectedTab === f.Tab.Document && pe.createElement(oa, {
    page: n,
    handleChangePageValue: b
  }), (null == h ? void 0 : h.type) === f.PlaygroundSelectedItemType.Block && pe.createElement(Dr, {
    blockTypeName: null == h ? void 0 : h.name
  }), (null == h ? void 0 : h.type) === f.PlaygroundSelectedItemType.Page && pe.createElement(Pr, {
    pageTypeName: null == h ? void 0 : h.name
  })));
},
    sa = function sa(t) {
  var n,
      r = t.page,
      o = t.content,
      l = t.sidebarOpen,
      s = t.devicePreview,
      u = t.onChange,
      m = t.handleChangePageValue,
      p = t.locked,
      h = void 0 !== p && p,
      x = t.playgroundSelectedItem,
      v = t.playgroundBlockId,
      y = t.isPlayground,
      w = be(g),
      k = w.bricks,
      C = w.contentClassName,
      N = w.isDarkColorMode,
      S = w.useCssInJs,
      I = w.appId,
      L = Qr(I).data,
      z = null == L ? void 0 : L.user,
      B = be(ln),
      P = B.currentPage,
      D = B.setCurrentPage,
      T = B.previewMode,
      R = B.getStyles,
      M = B.getStylesheets,
      O = pe.useRef(null),
      F = e(ye({
    blockId: "",
    itemId: "",
    repeaterPropName: ""
  }), 2),
      Y = F[0],
      W = F[1],
      j = e(ye(""), 2),
      V = j[0],
      X = j[1],
      U = e(ye(null), 2),
      H = U[0],
      J = U[1],
      K = e(ye([]), 2),
      Q = K[0],
      q = K[1],
      Z = e(ye([]), 2),
      G = Z[0],
      _ = Z[1],
      $ = e(ye(!1), 2),
      ee = $[0],
      te = $[1],
      ne = e(ye(""), 2),
      re = ne[0],
      ae = ne[1],
      oe = e(ye(!1), 2),
      ie = oe[0],
      le = oe[1],
      ce = e(ye(null), 2),
      se = ce[0],
      de = ce[1],
      ue = (n = r.id, tt(function (e) {
    return b(void 0, void 0, void 0, function () {
      return E(this, function (t) {
        switch (t.label) {
          case 0:
            return [4, at.post("/admin/pages/".concat(n, "/translations"), {
              language: e
            }).then(function (e) {
              return e.data;
            })];

          case 1:
            return [2, t.sent()];
        }
      });
    });
  }, {
    onSuccess: function onSuccess() {
      ot.success("New translation created", {
        position: "bottom-right"
      });
    },
    onError: hr({
      topic: "page",
      getLimitExceededError: function getLimitExceededError(e, t) {
        return "The ".concat(e, " plan has a limit of ").concat(t, " pages / translations.");
      },
      conflictError: "A translation for this language already exists",
      genericError: "An error occurred while adding the new translation"
    })
  }));
  he(function () {
    W(v ? {
      blockId: v,
      itemId: "",
      repeaterPropName: ""
    } : {
      blockId: "",
      itemId: "",
      repeaterPropName: ""
    }), X(""), S ? (te(!1), setTimeout(function () {
      q(R()), _(M()), setTimeout(function () {
        te(!0);
      }, 200);
    }, 800)) : (te(!1), q(R()), _(M()), te(!0));
  }, [P]), he(function () {
    S && (te(!1), setTimeout(function () {
      q(R()), _(M()), setTimeout(function () {
        te(!0);
      }, 200);
    }, 500));
  }, [N, o && o.length]), he(function () {
    y && S && (te(!1), setTimeout(function () {
      q(R()), _(M()), setTimeout(function () {
        te(!0);
      }, 200);
    }, 500));
  }, [Y]);

  var me = function me(e) {
    return function () {
      D({
        pageId: r.id,
        language: e
      });
    };
  },
      ge = function ge(e) {
    return function () {
      de(e);
    };
  },
      fe = function fe(e, t, n) {
    return void 0 === t && (t = ""), void 0 === n && (n = ""), function (r, a) {
      var i = o;
      i = t ? o.map(function (o) {
        var i;
        return o.id === t && o.props[n] ? c(c({}, o), {
          props: c(c({}, o.props), (i = {}, i[n] = o.props[n].map(function (t) {
            var n;
            return t.id === e ? c(c({}, t), {
              props: c(c({}, t.props), (n = {}, n[r] = a, n))
            }) : t;
          }), i))
        }) : o;
      }) : o.map(function (t) {
        var n;
        return t.id === e ? c(c({}, t), {
          props: c(c({}, t.props), (n = {}, n[r] = a, n))
        }) : t;
      }), u(i);
    };
  },
      xe = function xe(e) {
    return function (t) {
      t.preventDefault(), W({
        blockId: "ADD_BLOCK",
        itemId: "",
        repeaterPropName: ""
      }), X(e);
    };
  },
      ve = function ve(e) {
    return function (t) {
      t.preventDefault(), W({
        blockId: "ADD_BLOCK",
        itemId: "",
        repeaterPropName: ""
      });
      var n = ke(e);
      X(n);
    };
  },
      ke = function ke(e) {
    for (var t = "FIRST", n = 0; n < o.length; ++n) {
      if (o[n].id === e) return t;
      t = o[n].id;
    }

    return "";
  },
      Ee = function Ee(t) {
    return function (n) {
      n.preventDefault();
      var r = o.findIndex(function (e) {
        return e.id === t;
      }),
          a = o.find(function (e) {
        return e.id === t;
      });

      if (a) {
        var i = A(A(A([], e(o.slice(0, r)), !1), [a, c(c({}, a), {
          id: Ut()
        })], !1), e(o.slice(r + 1)), !1);
        u(i);
      }
    };
  },
      Ce = function Ce(t, n) {
    return function (r) {
      r.preventDefault();
      var a = A([], e(o), !1),
          i = a.findIndex(function (e) {
        return e.id === t;
      });

      if (-1 !== i) {
        if (n === f.SortDirection.Up && i > 0) {
          var l = a[i - 1];
          a[i - 1] = a[i], a[i] = l;
        }

        if (n === f.SortDirection.Down && i < a.length - 1) {
          l = a[i + 1];
          a[i + 1] = a[i], a[i] = l;
        }

        u(a);
      }
    };
  },
      Ae = function Ae(e) {
    return function (t) {
      t.preventDefault(), W({
        blockId: "",
        itemId: "",
        repeaterPropName: ""
      });
      var n = o.filter(function (t) {
        return t.id !== e;
      });
      u(n);
    };
  },
      Ne = function Ne(t, n, r) {
    return function () {
      var a = k[r];

      if (a) {
        var i = {
          id: Ut(),
          type: r,
          props: a.schema.getDefaultProps ? a.schema.getDefaultProps() : {}
        },
            l = o.map(function (r) {
          var a, o, l;
          if (r.id !== t) return r;
          var s = null === (l = null === (o = k[r.type].schema.repeaterItems) || void 0 === o ? void 0 : o.find(function (e) {
            return e.name === n;
          })) || void 0 === l ? void 0 : l.max;
          return s && r.props[n] && r.props[n].length >= s ? (console.error("Cannot add new blocks. Maximum number is: " + s), r) : c(c({}, r), {
            props: c(c({}, r.props), (a = {}, a[n] = A(A([], e(r.props[n] || []), !1), [i], !1), a))
          });
        });
        u(l);
      }
    };
  },
      Se = function Se() {
    le(!0), setTimeout(function () {
      le(!1);
    }, 3e3);
  },
      Ie = function Ie(e) {
    if (!e) return null;
    var t = Object.keys(e).reduce(function (t, n) {
      var r, a, o;
      return e[n] && e[n].document && "value" === e[n].object ? c(c({}, t), ((r = {})[n] = "**BEGIN-Plain.deserialize**".concat(i.serialize(e[n]), "**END-Plain.deserialize**"), r)) : e[n] && Array.isArray(e[n]) ? c(c({}, t), ((a = {})[n] = e[n].map(function (e) {
        return e.id && e.props && e.type ? Ie(e.props) : Ie(e);
      }), a)) : c(c({}, t), ((o = {})[n] = e[n], o));
    }, {});
    return t;
  },
      Le = !!x && x.type === f.PlaygroundSelectedItemType.Page,
      ze = !!x && x.type === f.PlaygroundSelectedItemType.Block,
      Be = function Be() {
    return null;
  };

  if (x && x.type === f.PlaygroundSelectedItemType.Block) {
    var Pe = k[x.name];
    Pe.schema.playgroundLinkUrl && Pe.schema.playgroundLinkLabel && (Be = function Be() {
      return pe.createElement("a", {
        href: Pe.schema.playgroundLinkUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          fontSize: 14,
          color: "#4299e1"
        }
      }, Pe.schema.playgroundLinkLabel, " »");
    });
  }

  r.content;
  var De,
      Te = d(r, ["content"]),
      Re = c({}, Te);
  return pe.createElement(a.Provider, {
    value: {
      focused: Y,
      setFocused: W,
      triggerTextRefreshBlockId: re,
      setTriggerTextRefreshBlockId: ae,
      setAddAfterBlockId: X,
      pageValues: Re,
      handleChangePageValue: m
    }
  }, pe.createElement("div", {
    className: "flex-1 flex"
  }, pe.createElement("div", {
    className: "flex-1 flex justify-center bg-gray-200 shadow-inner rounded-md",
    style: {
      marginTop: 44
    }
  }, pe.createElement("div", {
    className: "shadow-lg rounded-md bg-white transition-all duration-200",
    style: {
      width: s.width
    }
  }, !y && !T && z && z.languages.length > 1 && pe.createElement("div", {
    className: "flex justify-between text-sm border-b"
  }, pe.createElement("div", {
    className: "flex"
  }, z.languages.map(function (e) {
    return e.code === r.language ? pe.createElement("div", {
      key: e.code,
      className: "bg-white pt-3 pb-2 px-1 ml-4 border-b-4 border-pink-500 font-semibold text-black",
      onClick: me(e.code)
    }, e.name) : pe.createElement("div", {
      key: e.code,
      className: "cursor-pointer pt-3 pb-2 px-1 ml-4 text-gray-700 border-b-4 border-transparent flex items-center",
      onClick: r.translations.some(function (t) {
        return t.language === e.code;
      }) ? me(e.code) : ge(e)
    }, e.name, !r.translations.some(function (t) {
      return t.language === e.code;
    }) && pe.createElement(xt, {
      className: "ml-1 text-gray-400"
    }));
  })), pe.createElement("div", {
    className: "pt-2 px-4"
  }), pe.createElement(Zr, {
    title: "Create a new translation",
    message: "Create the ".concat(null == se ? void 0 : se.name, " translation?"),
    buttons: [{
      label: "Yes, create translation",
      onClick: function onClick() {
        return b(void 0, void 0, void 0, function () {
          return E(this, function (e) {
            switch (e.label) {
              case 0:
                if (!se) return [3, 4];
                e.label = 1;

              case 1:
                return e.trys.push([1, 3,, 4]), [4, ue.mutate(se.code)];

              case 2:
                return e.sent(), D({
                  pageId: r.id,
                  language: se.code
                }), de(null), [3, 4];

              case 3:
                return e.sent(), de(null), [3, 4];

              case 4:
                return [2];
            }
          });
        });
      },
      type: "confirm"
    }, {
      label: "Cancel",
      onClick: function onClick() {},
      type: "cancel"
    }],
    isOpen: !!se,
    setIsOpen: de
  })), pe.createElement(Lr, {
    id: "rb-content-frame",
    className: "overflow-hidden bg-white",
    style: {
      width: "100%",
      height: "calc(100vh - ".concat(!y && !T && z && z.languages.length > 1 ? 129 : 84, "px)")
    },
    styles: Q,
    stylesheets: G
  }, ee && pe.createElement("div", {
    style: {
      backgroundColor: "#fff",
      position: "relative",
      paddingTop: y ? 0 : 20,
      paddingBottom: 20
    }
  }, pe.createElement("style", null, "\nbutton.rb-action {\n  box-sizing: border-box;\n  width: unset;\n  font-family: inherit;\n  line-height: 1.15;\n  margin: 0;\n  overflow: visible;\n  -webkit-appearance: button;\n  cursor: pointer;\n  border: none;\n  background-color: #f65a8e;\n  padding: 4px;\n  border-radius: 4px;\n  font-size: 16px;\n  color: #fff;\n}\nbutton.rb-action:hover {\n  background-color: #d9367f;\n}\nbutton.rb-action:focus {\n  outline: none;\n}\nbutton.rb-action.disabled {\n  opacity: 50%;\n  cursor: not-allowed;\n}\nbutton.rb-action.disabled:hover {\n  background-color: #f65a8e;\n}"), pe.createElement("div", {
    ref: O,
    className: "react-bricks-content ".concat(C)
  }, !h && !Le && !T && 0 === o.length && pe.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: 10
    }
  }, pe.createElement("button", {
    className: "rb-action",
    onClick: xe("FIRST")
  }, "Add your first block")), "FIRST" === V && pe.createElement(Br, {
    previewNewBlock: H
  }), o.map(function (e, t) {
    return pe.createElement(we, {
      key: e.id
    }, pe.createElement(qt, {
      FallbackComponent: (n = e.type, function () {
        return pe.createElement("div", {
          style: {
            padding: 8,
            backgroundColor: "#fff5f5",
            border: "2px solid #e53e3e",
            color: "#e53e3e",
            fontWeight: 600,
            textAlign: "center"
          }
        }, 'Block "', n, '" threw an error');
      })
    }, pe.createElement(zr, {
      contentLength: o.length,
      contentRef: O,
      block: e,
      index: t,
      locked: h || Le,
      setAddAfterBlockId: X,
      handleChange: fe,
      handleAddBlockBefore: ve,
      handleAddBlockAfter: xe,
      handleRemoveBlock: Ae,
      handleSort: Ce,
      handleAddItem: Ne,
      handleDuplicate: Ee
    })), V === e.id && pe.createElement(Br, {
      previewNewBlock: H
    }));
    var n;
  })), Le && pe.createElement("div", {
    style: {
      marginTop: 24,
      paddingLeft: 24,
      paddingRight: 24,
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif'
    }
  }, pe.createElement("h3", {
    style: {
      fontSize: 12,
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: .8,
      marginBottom: 12,
      color: "#718096"
    }
  }, "Current content blocks"), pe.createElement("div", {
    style: {
      position: "relative",
      fontFamily: 'Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
      backgroundColor: "#edf2f7",
      fontSize: 12,
      color: "#4a5568",
      padding: 32,
      marginBottom: 12,
      borderRadius: 4,
      overflowX: "auto"
    }
  }, pe.createElement(Qt, {
    text: JSON.stringify(o.map(function (e) {
      return e.type;
    })).replace(/"/g, "'"),
    onCopy: Se
  }, pe.createElement("div", {
    style: {
      position: "absolute",
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
      top: 4,
      right: 4
    }
  }, pe.createElement("button", {
    className: "rb-action",
    style: {
      fontSize: 14,
      paddingLeft: 8,
      paddingRight: 8
    }
  }, ie ? "Copied" : "Copy"))), "[", o.map(function (e, t) {
    return pe.createElement("span", {
      key: e.type
    }, "'", pe.createElement("span", {
      style: {
        color: "#d53f8c",
        fontWeight: 700
      }
    }, e.type), "'", t < o.length - 1 && ", ");
  }), "]"), pe.createElement("p", null, "You may copy the array to set it as the pageType's defaultContent")), ze && pe.createElement("div", {
    style: {
      marginTop: 24,
      paddingLeft: 24,
      paddingRight: 24,
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif'
    }
  }, pe.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, pe.createElement("h3", {
    style: {
      fontSize: 12,
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: .8,
      marginBottom: 12,
      color: "#718096"
    }
  }, "Current props"), pe.createElement(Be, null)), pe.createElement("div", {
    style: {
      position: "relative",
      fontFamily: 'Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
      backgroundColor: "#edf2f7",
      fontSize: 12,
      color: "#4a5568",
      padding: 32,
      marginBottom: 12,
      borderRadius: 4,
      overflowX: "auto"
    }
  }, pe.createElement(Qt, {
    text: (De = o[0] && o[0].props, JSON.stringify(Ie(De), null, 2).replace(/\"\*\*BEGIN\-Plain\.deserialize\*\*/gi, '"').replace(/\*\*END\-Plain\.deserialize\*\*\"/gi, '"').replace(/  \"(\w*)\"\: /gi, "  $1: ")),
    onCopy: Se
  }, pe.createElement("div", {
    style: {
      position: "absolute",
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
      top: 4,
      right: 4
    }
  }, pe.createElement("button", {
    className: "rb-action",
    style: {
      fontSize: 14,
      paddingLeft: 8,
      paddingRight: 8
    }
  }, ie ? "Copied" : "Copy"))), pe.createElement("div", {
    className: "overflow-auto",
    dangerouslySetInnerHTML: {
      __html: function (e) {
        return JSON.stringify(Ie(e), null, 2).replace(/ /gi, "&nbsp;").replace(/\n/gi, "<br />").replace(/\"\*\*BEGIN\-Plain\.deserialize\*\*/gi, '"').replace(/\*\*END\-Plain\.deserialize\*\*\"/gi, '"').replace(/\&nbsp;\&nbsp;\"(\w*)\"\:&nbsp;/gi, '&nbsp;&nbsp;<span style="color: #d53f8c; font-weight: bold">$1:&nbsp;</span>');
      }(o[0] && o[0].props)
    }
  }))))))), pe.createElement(ca, {
    page: r,
    content: o,
    addAfterBlockId: V,
    handleChange: fe,
    handleSetStory: function handleSetStory(e, t) {
      var n = o.map(function (n) {
        return n.id === e ? c(c({}, n), {
          props: t
        }) : n;
      });
      u(n);
    },
    handleAddBlock: function handleAddBlock(t) {
      return function (n) {
        var r, a;
        n.preventDefault();
        var i = Ut(),
            l = k[t];

        if (l) {
          var s = l.schema.getDefaultProps ? l.schema.getDefaultProps() : {};

          if ((null === (r = l.schema.repeaterItems) || void 0 === r ? void 0 : r.length) && (s = Object.keys(s).reduce(function (e, t) {
            var n,
                r,
                a,
                o,
                i = s[t];
            if (!Array.isArray(i)) return c(c({}, e), ((n = {})[t] = i, n));
            var d = null === (o = l.schema.repeaterItems) || void 0 === o ? void 0 : o.find(function (e) {
              return e.name === t;
            });
            if (!d) return c(c({}, e), ((r = {})[t] = i, r));
            var u = i.map(function (e) {
              return {
                id: Ut(),
                type: d.itemType,
                props: c({}, e)
              };
            });
            return c(c({}, e), ((a = {})[t] = u, a));
          }, {})), null === (a = l.schema.sideEditProps) || void 0 === a ? void 0 : a.length) {
            var d = l.schema.sideEditProps.reduce(function (e, t) {
              return t.groupName || "BOOLEAN" !== t.type || (e[t.name] = !!s[t.name]), t.groupName && t.props.filter(function (e) {
                return "BOOLEAN" === e.type;
              }).forEach(function (t) {
                e[t.name] = !!s[t.name];
              }), e;
            }, {});
            s = c(c({}, s), d);
          }

          var m = {
            id: i,
            type: t,
            props: s
          },
              p = [];
          p = "FIRST" === V ? A([m], e(o), !1) : o.reduce(function (t, n) {
            return n.id === V ? A(A([], e(t), !1), [n, m], !1) : A(A([], e(t), !1), [n], !1);
          }, []), u(p), X(""), J(null), W({
            blockId: i,
            itemId: "",
            repeaterPropName: ""
          });
        }
      };
    },
    handleAddItem: Ne,
    handleRemoveItem: function handleRemoveItem(e, t) {
      return function () {
        var n = o.map(function (n) {
          var r;
          return n.id !== e ? n : c(c({}, n), {
            props: c(c({}, n.props), (r = {}, r[Y.repeaterPropName] = n.props[Y.repeaterPropName].filter(function (e) {
              return e.id !== t;
            }), r))
          });
        });
        W({
          blockId: Y.blockId,
          itemId: "",
          repeaterPropName: ""
        }), u(n);
      };
    },
    handleSortItem: function handleSortItem(t, n, r) {
      return function (a) {
        a.preventDefault();
        var i = A([], e(o), !1),
            l = i.find(function (e) {
          return e.id === t;
        });

        if (l) {
          var c = l.props[Y.repeaterPropName];

          if (c && Array.isArray(c)) {
            var s = c.findIndex(function (e) {
              return e.id === n;
            });

            if (-1 !== s) {
              if (r === f.SortDirection.Up && s > 0) {
                var d = c[s - 1];
                c[s - 1] = c[s], c[s] = d;
              }

              if (r === f.SortDirection.Down && s < c.length - 1) {
                d = c[s + 1];
                c[s + 1] = c[s], c[s] = d;
              }

              u(i);
            }
          }
        }
      };
    },
    handlePreviewNewBlock: function handlePreviewNewBlock(e) {
      var t;
      e || J(null);
      var n = k[e];

      if (n) {
        var r = n.schema.getDefaultProps ? n.schema.getDefaultProps() : {};
        (null === (t = n.schema.repeaterItems) || void 0 === t ? void 0 : t.length) && (r = Object.keys(r).reduce(function (e, t) {
          var a,
              o,
              i,
              l,
              s = r[t];
          if (!Array.isArray(s)) return c(c({}, e), ((a = {})[t] = s, a));
          var d = null === (l = n.schema.repeaterItems) || void 0 === l ? void 0 : l.find(function (e) {
            return e.name === t;
          });
          if (!d) return c(c({}, e), ((o = {})[t] = s, o));
          var u = s.map(function (e) {
            return {
              id: Ut(),
              type: d.itemType,
              props: c({}, e)
            };
          });
          return c(c({}, e), ((i = {})[t] = u, i));
        }, {})), J({
          id: "PREVIEW_NEW",
          type: e,
          props: r
        });
      }
    },
    handleChangePageValue: m,
    playgroundSelectedItem: x,
    sidebarOpen: l
  })));
},
    da = function da() {
  var t = be(g),
      n = t.bricks,
      r = t.pageTypes,
      a = t.responsiveBreakpoints,
      o = t.enableAutoSave,
      i = be(ln).currentPage,
      l = e(ye(X), 2),
      s = l[0],
      d = l[1],
      u = e(ye(!0), 2),
      m = u[0],
      p = u[1],
      f = e(ye(a[a.length - 1]), 2),
      h = f[0],
      x = f[1],
      v = e(function (t, n) {
    var r = e(ye(function () {
      var e = window.localStorage.getItem(n);
      return null !== e ? JSON.parse(e) : t;
    }), 2),
        a = r[0],
        o = r[1];
    return he(function () {
      window.localStorage.setItem(n, JSON.stringify(a));
    }, [n, a]), [a, o];
  }(!1, "rb_autosave"), 2),
      y = v[0],
      w = v[1],
      k = U(i.pageId, i.language).data,
      C = function (e, t) {
    var n = nt();
    return tt(function (n) {
      return b(void 0, void 0, void 0, function () {
        var r;
        return E(this, function (a) {
          switch (a.label) {
            case 0:
              return r = {
                type: n.type,
                name: n.name,
                slug: n.slug,
                content: JSON.stringify(n.content),
                meta: JSON.stringify(n.meta),
                customValues: JSON.stringify(n.customValues),
                tags: n.tags,
                authorId: n.authorId,
                status: n.status,
                isLocked: n.isLocked,
                publishedAt: n.publishedAt,
                scheduledForPublishingOn: n.scheduledForPublishingOn
              }, [4, at.put("/admin/pages/".concat(e, "/translations/").concat(t), r).then(function (e) {
                return e.data;
              })];

            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, {
      onSuccess: function onSuccess(e) {
        n.invalidateQueries("pages"), n.invalidateQueries("page"), n.invalidateQueries("tags"), ot.success("Page saved", {
          position: "bottom-right"
        });
      },
      onError: hr({
        topic: "page",
        getLimitExceededError: function getLimitExceededError(e, t) {
          return "The ".concat(e, " plan has a limit of ").concat(t, " pages. If you downgraded your plan, you may have pages set to draft. You need to upgrade again before publishing these pages.");
        },
        conflictError: "There is already a Page with the same Slug and Language",
        genericError: "An error occurred while saving the page"
      })
    });
  }(s.id, s.language),
      A = C.mutate,
      N = C.status,
      S = xe(Ht(A, 2e3), []);

  return he(function () {
    (null == k ? void 0 : k.id) ? d(q(k, r, n)) : d(X);
  }, [k]), he(function () {
    o && y && S(s);
  }, [s]), pe.createElement("div", {
    className: "flex-1"
  }, i.pageId && s && s.id ? pe.createElement("div", {
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      me("mod+s", e) && (e.preventDefault(), e.stopPropagation(), s.content.reduce(function (e, t) {
        var r = n[t.type],
            a = Cr(t, r) && Ar(t, r, n);
        return e && a;
      }, !0) ? A(s) : ot.error("Error in validation, cannot save the page", {
        position: "bottom-right"
      }));
    },
    className: "focus:outline-none"
  }, pe.createElement(Ir, {
    page: s,
    sidebarOpen: m,
    setSidebarOpen: p,
    devicePreview: h,
    setDevicePreview: x,
    handleSave: function handleSave() {
      A(s);
    },
    saveStatus: N,
    autoSave: y,
    setAutoSave: w
  }), pe.createElement(sa, {
    page: s,
    content: s.content,
    onChange: function onChange(e) {
      d(c(c({}, s), {
        content: e
      }));
    },
    handleChangePageValue: function handleChangePageValue(e) {
      d(c(c({}, s), e));
    },
    locked: s.isLocked,
    sidebarOpen: m,
    devicePreview: h
  })) : pe.createElement("div", {
    className: "bg-gray-200 shadow-inner",
    style: {
      height: "calc(100vh - 40px)"
    }
  }));
},
    ua = function ua() {
  return pe.createElement("div", {
    className: "w-full pt-10 mx-auto flex"
  }, pe.createElement(kr, null), pe.createElement(da, null));
},
    ma = pe.createContext({
  selectedItem: null,
  setSelectedItem: function setSelectedItem() {}
}),
    pa = function pa() {
  var t = be(g),
      n = t.pageTypes,
      r = t.bricks,
      a = be(ln),
      o = a.previewMode,
      i = a.sidebarCollapsed,
      l = be(ma),
      s = l.selectedItem,
      d = l.setSelectedItem,
      u = e(pe.useState(""), 2),
      m = u[0],
      p = u[1],
      b = function (e, t) {
    return Object.keys(e).map(function (t) {
      return e[t];
    }).filter(function (e) {
      return e.schema.label.toLowerCase().indexOf(t.toLowerCase()) > -1 || e.schema.category && e.schema.category.toLowerCase().indexOf(t.toLowerCase()) > -1 || e.schema.tags && e.schema.tags.join(" ").toLowerCase().indexOf(t.toLowerCase()) > -1;
    }).map(function (e) {
      var t;
      return (t = {})[e.schema.name] = e, t;
    }).reduce(function (e, t) {
      return c(c({}, e), t);
    }, {});
  }(r, m),
      h = function (t, n) {
    return t.reduce(function (t, r) {
      return n[r].schema.category && -1 === t.indexOf(n[r].schema.category) ? A(A([], e(t), !1), [n[r].schema.category], !1) : t;
    }, []);
  }(Object.keys(b), b),
      x = Object.keys(b).filter(function (e) {
    return !b[e].schema.category;
  });

  return pe.createElement("div", {
    style: {
      width: o || i ? 0 : 192,
      transition: "width 300ms"
    }
  }, !o && !i && pe.createElement("div", {
    className: "fixed top-0 pt-10 pb-12 w-48 h-full overflow-y-auto scrolling-touch"
  }, pe.createElement("nav", {
    className: "overflow-y-auto pb-24"
  }, pe.createElement("div", {
    className: "mt-4 mb-4"
  }, pe.createElement("div", {
    className: "flex flex-row justify-between items-center pb-1 mb-2"
  }, pe.createElement("h3", {
    className: "w-full px-2 text-xs leading-none font-bold uppercase tracking-wider text-gray-600"
  }, "Bricks")), pe.createElement("div", {
    className: "relative mb-3 ml-2 mr-2"
  }, pe.createElement(Gn, {
    value: m,
    onChange: function onChange(e) {
      p(e.target.value);
    },
    radiusSize: "full",
    className: "px-4 leading-none",
    placeholder: "Search bricks...",
    autoFocus: !0
  }), pe.createElement(st, {
    className: "absolute text-gray-400",
    style: {
      top: 9,
      right: 11
    }
  })), pe.createElement("ul", {
    className: "pb-4"
  }, pe.createElement(pe.Fragment, null, h.map(function (e) {
    return pe.createElement(Tr, {
      key: e,
      name: e,
      defaultOpen: !0
    }, Object.keys(b).filter(function (t) {
      return r[t].schema.category === e;
    }).map(function (e) {
      var t;
      return {
        name: e,
        label: r[e].schema.label,
        isRepeater: !!(null === (t = r[e].schema.repeaterItems) || void 0 === t ? void 0 : t.length)
      };
    }).map(function (e) {
      return pe.createElement("li", {
        key: e.name,
        onClick: function onClick() {
          return d({
            type: f.PlaygroundSelectedItemType.Block,
            name: e.name,
            label: e.label
          });
        },
        style: (null == s ? void 0 : s.type) === f.PlaygroundSelectedItemType.Block && (null == s ? void 0 : s.name) === e.name ? {
          boxShadow: "0 0 5px rgba(74,85,104,0.08)",
          marginLeft: "-0.75rem",
          marginRight: "-0.75rem"
        } : {
          marginLeft: "-0.75rem",
          marginRight: "-0.75rem"
        },
        className: _e("text-sm px-3 py-px mb-1 flex flex-row justify-between items-center text-gray-600 hover:text-gray-800 cursor-pointer", (null == s ? void 0 : s.type) === f.PlaygroundSelectedItemType.Block && (null == s ? void 0 : s.name) === e.name ? "bg-white border-t border-b border-gray-300 font-semibold text-black hover:text-black" : "hover:bg-white text-gray-700 hover:text-gray-900")
      }, pe.createElement("div", {
        className: "flex flex-row justify-start items-center flex-1"
      }, pe.createElement("div", {
        className: _e("mr-2", "text-gray-400", {
          "text-pink-300": (null == s ? void 0 : s.type) === f.PlaygroundSelectedItemType.Block && (null == s ? void 0 : s.name) === e.name
        })
      }, e.isRepeater ? pe.createElement(Pt, null) : pe.createElement(Dt, null)), pe.createElement("div", null, e.label)));
    }));
  }), x.length > 0 && pe.createElement(Tr, {
    name: "Uncategorized",
    defaultOpen: !0
  }, x.map(function (e) {
    return Object.keys(b).map(function (t) {
      var n;
      if (e === t) return {
        name: t,
        label: r[t].schema.label,
        isRepeater: !!(null === (n = r[t].schema.repeaterItems) || void 0 === n ? void 0 : n.length)
      };
    }).map(function (e) {
      return e && pe.createElement("li", {
        key: e.name,
        onClick: function onClick() {
          return d({
            type: f.PlaygroundSelectedItemType.Block,
            name: e.name,
            label: e.label
          });
        },
        style: (null == s ? void 0 : s.type) === f.PlaygroundSelectedItemType.Block && (null == s ? void 0 : s.name) === e.name ? {
          boxShadow: "0 0 5px rgba(74,85,104,0.08)",
          marginLeft: "-0.75rem",
          marginRight: "-0.75rem"
        } : {
          marginLeft: "-0.75rem",
          marginRight: "-0.75rem"
        },
        className: _e("text-sm px-2 py-px mb-1 flex flex-row justify-between items-center text-gray-600 hover:text-gray-800 cursor-pointer", (null == s ? void 0 : s.type) === f.PlaygroundSelectedItemType.Block && (null == s ? void 0 : s.name) === e.name ? "bg-white border-t border-b border-gray-300 font-semibold text-black hover:text-black" : "hover:bg-white text-gray-700 hover:text-gray-900")
      }, pe.createElement("div", {
        className: "flex flex-row justify-start items-center flex-1"
      }, pe.createElement("div", {
        className: _e("mr-2", "text-gray-400", {
          "text-pink-300": (null == s ? void 0 : s.type) === f.PlaygroundSelectedItemType.Block && (null == s ? void 0 : s.name) === e.name
        })
      }, e.isRepeater ? pe.createElement(Pt, null) : pe.createElement(Dt, null)), pe.createElement("div", null, e.label)));
    });
  })))), pe.createElement("div", {
    className: "flex flex-row justify-between items-center pb-1 mb-2"
  }, pe.createElement("h3", {
    className: "px-2 w-full text-xs leading-none font-bold uppercase tracking-wider text-gray-600"
  }, "Page Types")), pe.createElement("ul", null, n.map(function (e) {
    return pe.createElement("li", {
      key: e.name,
      onClick: function onClick() {
        return d({
          type: f.PlaygroundSelectedItemType.Page,
          name: e.name,
          label: e.name
        });
      },
      style: (null == s ? void 0 : s.type) === f.PlaygroundSelectedItemType.Page && (null == s ? void 0 : s.name) === e.name ? {
        boxShadow: "0 0 5px rgba(74,85,104,0.08)"
      } : {},
      className: _e("text-sm px-2 py-px mb-1 flex flex-row justify-between items-center text-gray-600 hover:text-gray-800 cursor-pointer", (null == s ? void 0 : s.type) === f.PlaygroundSelectedItemType.Page && (null == s ? void 0 : s.name) === e.name ? "bg-white border-t border-b border-gray-300 font-semibold text-black hover:text-black" : "hover:bg-white text-gray-700 hover:text-gray-900")
    }, pe.createElement("div", {
      className: "flex flex-row justify-start items-center flex-1"
    }, pe.createElement("div", {
      className: _e("mr-2", "text-gray-400", {
        "text-pink-300": (null == s ? void 0 : s.type) === f.PlaygroundSelectedItemType.Page && (null == s ? void 0 : s.name) === e.name
      })
    }, pe.createElement(Tt, null)), pe.createElement("div", null, (t = e.name).charAt(0).toUpperCase() + t.slice(1).toLowerCase())));
    var t;
  }))))));
},
    ga = function ga(e) {
  var t = e.className;
  return pe.createElement("svg", {
    className: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 462"
  }, pe.createElement("image", {
    width: "304",
    height: "319",
    transform: "translate(18 141)",
    opacity: "0.1",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAAE/CAYAAADBrZ8mAAAACXBIWXMAAAsSAAALEgHS3X78AAAgAElEQVR4Xu297XbiyhJsm2B37/v+L3vOWW2b+8OkHQSRWSUBNoKYY2iUJDDoo2oSWdBr7Q6HQxhjzBbZj55gjDH3igVmjNksr6MnmOuy2+12o+eYbXHwPMyvsfO1vw0WlbHYbo8FdkUmpTXzHLMthoPIMrsNFtiFDKS19jGzDbrBUz5mmV0PC2wljbh4/+zzZh8zP8saSfF++TyL7HIssBUIeXXbS55rtsFIULjdPtcSuwwLbCEDee2KdnYdsdh+n5mENVrnltctsQvwzygWQPKaEddu8Bhikd0PM+LC7U5WzCG+7+kh4rNfWWLrcAKbpJDXSFhqu/q7xMK6P2aS1UGsV4+p1klsBRbYBBPyqmRVLSHWEyUwS+3nUAOiEpgSllrUc/i1Plc8IBfhEnLAQnnlsh/s47/l10Qsr5+HJaKEo+T0QY/hPuYQn/cWW5eTC7HAGhp58fperFdttYRoed38DCiQTl6VrLDdxanYPuIcS2wlLiELJpMXi2tP62rfSGb4Pokl9nPwgBiJC2XF62of/50S5OeKB+cQJ7B5KnlV0noR+5TULLH7YY28uuU94iuB4Wt+xOe9/4B9uzh/fzPAAhMMfi6BSwoIZfUiWvX4jMSC1rt9Zh1KGrhvJnW903pu72Bf3tf3+JYX3sd8zy+RuZQcY4H1YBpS4kJ5sbByeRWPVYmMBcatuT2qpBulrndo3yPiLb6l9X58HbyH+RimsMRpbAEW2DJYYpiqlLS45WVGYkHratuspyobc72T17tY3uLzXmaLyQtfN+I0hVlYK7DAiOKfCqmF5cPCeo2IP7D+QutKYup9AlrEErucrnysSkclrzdoX46tun/4Wrmt7vHXcbmM7LHAaqrUk/LKllNVSusPrb/SslRiQevm+rC8Is7nu5S8csF7yfePxXU4Pi/Xd/B4iG0jsMB6VBLKRaUvTF5/IuIvrKPQlkgsRGuuz2zpWMnr33HJe4iMxLWDdf4b02CBzYPiQoHx3BfKKxeWWT4Py04uSS2wn+UgWpZXCgxLxhQXpy8EX4vFmDJz4lqBBQbA/Bd3wB0t2Umz06LAUk4osP/Fuci6JIbvEaJNLLTLYGEoeWWb3zSyvPAesrwqCeI9xhTGEttFxMHzYDUWWA1Li/fNlpD/oxZTmZKYKiMtsNuBYkCB8dwXl44z8mJxscQ+QvcvfA3TYIHNw0LpUhjOeaW8cqkkplJYvk+ElpgFdhmVvFRyYnn9iYj/4lxeXen5Eqe/AeM+ZWEtxAIbw+LAzsfzYJzCuIzEJR9fksIsr9ug5KXSV07Yp7x4zqv6m+qLmkxhAa9hkS3AApsDOxenMC4lO5GpJMalZL4OdnKUl0piZj0H0ar0lXNf/G3jSF6v8f2jVhYYfzBZXguxwObhjsZl3khi/O0kTuyrUnKUwiqBWWw9ShAprVxX5R/+1uslTu9F/g1K6yVO76eaGuAPRrMQC+xI8Q2k6lT8OEsMO+xIYjMprPu0Ttz516HS10ecSgyllMkLrzc/h++jWkb3bhffx7SL8DeRFRbYHNzJWChc7qlExkJjqXUpbEZiattousl7FFiWgi9x/s+DVOrie8epSy0hWjOJBbYM7HS4Dx9TEmORVekM97HAeCCEaHndnNPJS819vcf39U9QXHxfOTnzvQuxblZiga2n6pC5jfv3tD6T0PiTnF+nGwQeFJqRvLh0RPkEPPYa+ttFvjfqPvjeXBELbD088asGB8Odmz+lWWYzpaSSmAeJhu9RNfeV8srrm/ur+6HSsfkBLLBlsKi6x/mTHRcEBYQyQ6nxPhw0+LeJB5HmIFqVvnbxKbHcX32AKLr+kY9zPzErscDm4E7WyQkHAi68/wAtoxLamiSWPKvQ1LXt5IXXaYm48DW4D6j+of4eWzOJBXbkcDgcjj+lOMR3J8X1r6fSeiUsngjO5YPWuaMjVSobSSz/1nyj7hveP34Mr6/6u+6edx9aI5kF7T9EhP8PRQUW2DzY4bgjY0dFWeF/ueCN9qkFO3u+D8Iyw5SmEpgl9kknL77GldAqcXUfTnhPsa9Ui1mIBTZHJa6uM7+JBf8LBrnkb4jwb1/iu7MjKCmUF8+HYZs8m8yUmLLl+1iVhvj86j6rD6yZDyglLktsIRbYmEN8du5uAKiOzNL6L87lhd804lKJLI8l4lxiLiNP4dJvB+tKXnyt1IdVd5/VosTVpbCA1kxggS1DfRpz5+4SV/7nV2YW1ekjdAdXArPIvq8VfgAhs+Kq7i/e53/FY0tTmFmABVaDnar6xFSd+yW+/xPD11q4wysssGXwdRyJS304obh4W4lsJoVZaguwwIDim8iIsbz28XMS28e4gyuJ8WOPCl4XLBurFJao+zsjr3/xmax530wCUyJDDhHhbyAbLLB5uHPv4lRib1H/3EH9jiv38TIzsT/ToZ81gfEHT+6rrhleT/xg4nu7RF6cwpS4ltxLU2CB9fCnOcoLP6V38SmkkcQqaaG8XmkdOz9/WqvOX5WR+Pgjw/cs9+E6w9e0S1+VyFhcnMIwjeW97EpJM4EFVoOdHrdRYrmwyHawPpIZCutfnP68ApPYbNnR8ejyihiXigheP5QKpi8WWSWuroR8o9eduY+z5/DUWGAEzIN97RLrLLF3WH+LU3mxyFTiSnmlwP7E+Se26vRJbneCegZ5JSOJVddPSaaaA5tJYZy8RvfyTGSe/+qxwJbBHa2SGC9V+YgC+xOfnT/lNdvx1Sc3y+qZ5JUoialttXD66kpIXudF3cPqfc1CLLCelIHq+B/HdZRDJy8uGzF1qQHQiQvXFUpiz053rVheKoF1IlP7uw+gSmKJZTaJBSagMhJlcBAtikylMBQXznGhwHgwvEfd+bnD+9N7HeoafkCb8poV2ay8ug+hk/vo8nGMBTaPElnKK0KXkvnNZP6EAiWGpaLq9FXnzzbivPPjMRpNJY1OYqNlyT0cJTBLawEWWEGRwlTnwo6fcPpKia391O7k5Q6/HnUtlcQqmXXS6u4jSyv52nb6msMCa5iUGIorjs/Jzp4Cy86OP05d8omt5OVP7cvoriVebxbZO7Xd+tL7+LnT8ppmP3rCs0OdidfVUn1iq09w9fjo0/qsw5urMLqXlcTUeiUtdT8T39MVOIEtJzsaprHspLn/A1ru9EpU1b5qACSq0x/C82AV1fXi9ZHMOrnhcyp58Xt84fS1DCewCYpOxR2fO7vq+NWntHq+6uDc+XGfWU53Pfme8v0dSUrtq+7ZISIsrxVYYJMUpaTqmPwJrTqzkpcS10znT9z55xldQ77X1aLu35L76Ht2IRbYApr5MN7uOvuST2vV6RUeCMsZXcvR/Viy4OvKdaevdVhgCxEdreqw1WOjBf8WUa9rrsPMtR/dK3U/DqL1fbsiFthlVJ0RO2rVsdVAwMd4HR9X62YdM+Jiqvuj7qvv0Q2xwFbQxH3VoXF/1bErmeHj2JrbUd2fbPnx7t6NRPe54fJxNRbYdeAOWIkKH+fn4WOdzMzv0N1H3F5y/2aeYxossJXAp2YnqmSmY4868+hxcz1G11olqhlmn2cmscCuz2wnVQOg+kQ3v0OVkJew9PlmARbYbXHnNeaGWGDGmM1igRljNosFZozZLBaYMWazWGDGmM1igRljNosFZozZLBaYMWazWGDGmM1igRljNosFZozZLBaYMWazWGDGmM1igRljNosFZozZLBaYMWazWGDGmM1igRljNosFZozZLBaYMWazWGDGmM1igRljNosFZozZLBaYMWazWGDGmM1igRljNosFZozZLBaYMWazWGDGmM1igRljNosFZozZLBaYMWazWGDGmM1igRljNosFZozZLBbYfbM7LuZ38PW/cyyw+6IbLB5IP4fvw0awwH4PHAj+pN8WfL98734JC+y2rO3YldDWvp6Zp7rua6/92r8zE1hg16fqsLvQA2G0zfv8yX9dllzb0b2q7jE+bq6IBfYzVB0f20pu104E5pwl15nvFbf4PHNjLLDbs/TTuJNZhQfLcpZcz+qe4ONL9psrYYFdjvoEVh1+F+f7ed9o4CwZdKZm5jrO3JPuXqrn4z5szUossJXsdjvVIRVd5x0tCP9dhQdFzei6VWIZ3Sf1d9P3ifqSWYAFdl1GnZkltGQJaPk1zDrUNbzGPRq9prkSFthtUB0WO/aetmcXfG1zfdS9ml34noZYN1fGArs+o0GwL1p8vBMcvkfiwbGc6hp2903dq+5eju6buRALbAUwZ4Edkjtq19FxQPDSDZhucJjljK6rug8z943vNd4nvme7iPA82EossMtRHZI7K3ds9ck9GhBqICB8HEajrpO6X3ztq3vU3VfVFxLfrytggV2PrvOrQfBCbbVUrxXQMh4Y54yuVXX/untT3cOZvmCugAW2kEH5qJaZjv9Cy1KJ8bEYjbpnuM7CUfeN79Pog6jrG8kuIlxGrsACu4xKJkpe3PnVws+dlVjQuulRIuvkVd2fmXs5+uDxfbsAC2wBTfrKVomLP6VnFvVJPvNpbqFpRvdLSUwto/uG90/dx+H9cgpbhgU2iehY3QBQg4A7+SssuG9GZtUgUIwef2RG584ym5EW3y++h9V9G/WXLyyxeSyw5Zx9asZ858dOXw2CbjBwh+cBaOboriHey0pe1YePundKZnkvI07vm+/hQiywCUTp2H2Sqs7/KpY/x4X340DhDl99kpt1VPcP72PeSyWv7j6yzGaSWGTrFDaHBTZgUDrmtkpeo47Pg6Dq+N0n+Emnp33mnO6aqWusElh1z0YfROo+8jGc3DtLbIwFNk8lsj2tY2evEtgfWqoBwQNIfWrzgOR184m6PtX17MSF90rdR3X/cJ37y5m4xLYpsMAaJibu99By8sKOzx1dLSyx/PsqfeW9UwMg8UDor00+xvcRF7wXnbyqe8rywiTGEju7l05hPRZYgfjvfe1oHSU2ktesyLoExgLjzt6JzHxTXTcW2CiBzdzHWYnx/Tw5Rkus5nX0BFN2du7wSl7Ykf9Ci0s1ALiMmf7UNlOoe/kRWmB5T9W9+hsR/2j5GxFvx+U1It5h+YD3OcCC8jqIdSOwwASTpePMp7Xq7Cwt3qcSGL9fJy/LrIaFMHtf1T1FcfG+t+P2W5zKCwV2oCWO+/H+fR3rbrfbHQ4Hy4ywwIgVpSN29qrU4MQ1SmEssZG8LLIeJa6I7+RT3de8p+/xfT9TTjPpKwWGIvuIPoXxseW6JSawwGqUyLCTZzuaJ2FZ/Y+2O3FxCYnvjfIy60ix4X1Nsbwc10fJGiX2JpZOYCkulBneV5eSAywwYEHpuIvTCdlXaFXZyCJjiXUl5Jry0VI7B2Wl0hjf41EKw6T1T6xzGkN55WulvF6O6/v4xKXkJBbYkYWlI8qr+oRWwlLiqlIYpy8UWHb0SmRmDAtiDy3KKwWD9zallIL6R22VvtRcWCaxl/jEpeQCLLBzlMhQXigxlBenrmpBiVVzX528qpRlic2jUhiXkigxvM/vcSqxvN8oLiUyJS6XkhdigUVcUjpWyUslsFz+0jrKTJWPKDE+LhRaYpHVKHHhOt9vTmApoT+w/kbrnL44iWUJyd9IupRcwdML7MLSEcWlEhhLS5WRmL6yVQlsF6cSQyyt5SiZ5TXGkjIl9hGf9yYFhHNhLC+VvrokdoDWpeQCnl5gQPVpjOJQJQUKTJWJSmIqeakSUpWPvCAW2RglLl5nkaXEUmCZwDiJKXmxyD5E61JyJU8tsAWlI6cvLhtV6ahKRi4def7rhRanr9tSyQzlhQLDchLlpUpJJa9KZCwvTGERLiVLnlZgC0tH7MiYvlTpWElLlY5cQqr0hfKKOD02xCKbp0thmXqqUjJTGCcpLiUrqfHyIZYDLXi/XUoCTyswQIlsqby4dFST9ZXERqUjl4+IpXU5lcxQYl0pmQLjpSsjqxKyEphLyYKnFNjC0hHl9UpLVzp26UuVj10CUwtikS2nEhduo8Re4lQoKJxOXip9qVIy15W88jhdShJPJ7CVpWNKjOe9ZsTVzX2xuPZxKq9KYgGtuZyUGfeN/XE9JZIJLPtCyofnw5TQ1H6WVwos1zEB5vHlMR5o/Skl9nQCA5TIlLy6SXsuHTuZdelLTdzPlo4W2XpSXLye29miSDKJdfNhlcD4G0pVRh6gVQseV3XsT8NTCeyC0nGUvmakNZr3cun4O1Tiwm2UGAosJZYpjAWmflLRJbWZ+bAIl5JfPI3ArlQ68tzXbPmokhdLrCsZ+XjNbUiZqb6CEst+kVLp5sNUEhstLDGXkgVPIzCg6pwsrxlxKXn9f6HlpRJYlb5QZBUW2fVIcVWP7WEbU5gqJWdENisul5IDnkJgNy4dZ0vIbt5rtnS0tG6PSmG5H1OYKiVn5FXNhy0VWYRLyccX2MrSkeXVTd7PzHulwDjRjSbt+djVurkOVZJBobHEVCn5HpfPh31AiwJjkWFfOdD6U0js4QUGKJFdW16Xpi8WWcTpcattcz1QXLid13xpKTmTxC4RGB5bJeCH5qEFdsPS8RJ5scBcOt4nLC/cn30HJYaSuVRgKDKXkg0PK7Abl45LSkglLy4fK3FFs25uA6YXXs+2ktghzufCKpHxL/Vn/7mRSmLYZw60/tASe1iBAUpkl8hrJnV18lIlI4osYVlZXj8Hiou3s98kKZHsQ1hKqrkwFNYojc0KDKVVCfgheUiB/XLpmK0qHZXE+Njw09TS+n1SAlWfUiksJcOl5Ewaq0TmUlLwcAL75dLxf/A3M/NelcQCWl43P4NKMnxPMomlRHA+rCol/xe1wFxKLuThBAYokV0ir1HZiNszyYvFVWF5/R4oMfVYtpnCUmIoGC4lMYXN/rRiVmAoLSXgh+OhBPaLpaMqG0dzX3xsKDJL6/5ICVR9jCV2iNMUVpWPKolVi0tJ4qEEBrAMRhIbpa+RyNTkvUvHx0AlGb5Hs6XkSGZrSsmPOJXnsJR8JB5GYJC+uHOxvLJlca0tHbuycSZ9IZbXfaIkho9lOyol3+Ozj7C0Li0lc0GZ4XGdHPsjpbCHENiC0nEX3zK5dunYTdzPlo5mO1R9bqaUHJWTa0rJD3i/TIQPX0o+hMAATjAsMZaXKh9nS8dRAnPp+FicJZk4v2dLSklMVCysUSlZJbJ8zwhdSkacnsfm2bzAROnIUsiOhRJT6WuptHji3qXj46Mkho9lu6aUVMLqxMUixHKSS0mU7de+R0hhmxbYROmI8sL0NTP3NSohb1E6Wl73TyUu3FYSu6SU7FJYCgzlhaUkJ8WIByolNy0wQHUiFEeuc/pS815KXH9pfUZea0pHsy043eS+paUkC4ulNZIXLygvnA9j8W5WXMlmBdaUjrywuLh0RBGxvJS4eN7LpePzgYO/SmQqhXWl5EfoxKXSF25zGYlpLBfV/x6ilNyswIhOXriwvF7jVF6j8hHFhcusvGZEZrZBJS7cVhJTpWTK6G+cigplpX5ukcsfer2cA8P3Vv1uk9JCNimw4jdfuc3yUskrBVYlL0xfKnm5dDRIygzvafbBiHEpiUmKS8jRN5GzKQyP76yU3GoK25zAJibuWR6YvEZzXzPpS8lrJn0h3NHNNsEUViUylcK4lMwEVQlqJoWhyF7h9fG947gP+9zXMW9RYpsTGMASqCQ2mvvqxNUlL5eOJqIWF24riXWlpEphSmRdIqvSGPbDSr6bYVMCW/Cbr0pePHfF5eNfaqu5L5W8XDqaFAF/uM6Uku/xPaFfpTCVvnib5aXKST7Or31bS2GbEdhE6ZgdBSVWzX2tTV8ssRlxIdyxzWOACYbTDH5wYQrL/snzYZzGRimsSmJKYlhScv/bZCm5GYEBSgoojrWlo0pfLK5XaKvyUYm1E5l5DCpx4TZKLFNYLiguTGIqbY3mwlJgKLKUZrYB+xM+h7tnEwKbTF8oL5W+lpSOLLZu3muUwPAT2DwHKQK859k/I/pSsprQH8lLlZKcxDABqg/XzaWwTQgM4A6h5KWSV5e+qvmuSlwuHU0FJhhOM/hB1pWSKaBMYW/x2RdVKTmbxLq5sDyu6rjvmrsX2IqJ+1H6quRViYwl9kKLS0eDVOLCbZQYpjCeD1NCGqUxFhknMZRnSgzT4te+LaSwuxbYZOm4h7ab90p5qfKRS0eW1ystKn25dDQMyyH3cSmZfRdFhimsEte/OE9kf+lv1FxYvk/KjPvoZkrJuxYYoESG0uD0xcLh9MXi6krHmbmvmcRlkT0PmMKqRKZS2CFOEximMFVKjlIYpjGeC8v3TpluckL/bgU2mb6UvKoExumqkleXvkbzXjMiM89BJS7cRonxB/BsCuNEVgnsPb7n2h5mQv9uBQZwilHyGk3cq/Q1EleXvFJknbwsLZOkzKq+jCVklnevcVoCVinsH22z5LicfKgJ/bsU2AUT913Z2EmsKiFZXpy6cL3CInteOgFgHzrAevZlnNBXKaxLY//isx+/Ry2wh5jQv0uBESrh7KHlZMTJCyftuXzk/Sp5VfNeVQILaI1JWA65L+JUJDiZr0rJTGFKYJjG3mkd01wKEhMfihS5O2khdycwkb6+HopzeVXpq5v7Uj9eXZK+lLwQ1UHN85Li4vXczhYlximMS8mZ+TBVVqoklv35AG3E+XHeZQq7K4FNTNxX8pqduL/GvFeVvDqRmeemEhduo8QwhalSMsX0N06TF8+HVQLDFMal5P64D4/x69jvTWJ3JTCAUwxLrBIXl49KVpy+eJ5MlY6cvpTEAlpjKlJm3Mf3x/UqhalvJVFiVSnJIlMp7EAL9ukqPd4FdyOwBRP3SmIz8up+tDqa96rSF8Id0hgEBcAywH7epbCUz5/4lheXkpW8lMBQZHtoU2Io2q9995TC7kZgBKcbXJS8XuJbQFXyqsSFyStbfN0udY1EZgxSiQu3UWLZz1NkKompUrISWT4//zZfj0vJqm/fhbSQuxDYxMS9EhcnL577QpHNpC9OYPlenbiq4zZmRMoM+w73LVVG4lzYe8ylsPxZBYrsT5zKqyolI86lezcp7C4ERihJ8PxTJTFOVqP0peSlykaXjuZapLh4Pbexz6dIXqDNUhIT2CiFZZuy4yUlyRP6eJzJr0sL+XWBTaSvat6rmvtKeY1+KoHrKC9OX10JiVheZhYlLlzfH9dRYJjCWGJYSo6+kcQU1k3q47yYOt67SGG/KrCJn02gxCp5scRYVpXMVNmY0lqTvoxZQyUzlcI+4jSFjSb0VQrDBV+HBdbNh30d729L7FcFBvAnkJLXTPoalY2YvnDebLZ0tMjMtajEhdsosez/+K1kNaGvpFVN6lcpDOWJfb4qf3+FXxPYgp9NoLyynU1eKnVh+hrNfXXysrTMtUgZYJ9SH+JKYFhG/o1viXEK676VRIHhnBjOhfExfu37zRT2awIjWFx507JFean0NZO8uHRUyauTF8IdzZg1pBR4Pbd5PGApieUkJ7AZeSmBobxe4nQuTMorfplfEVgxcc83DD95uuRVlZDdv3NUc19cOi4VmTFrUOLC9f1xPZMQJjEuI1NMKLHqW0l8fldGorxw3J6I97dS2K8IjGA5sLgweV1SPqLEVNnYJTDE0jK3opIZJ7BMRjypj+Ukpy1MYqMJfUx5+b5cTiY/Li3kxwV2g59NzEhrafri1GWRmVvSpbDcRol1KUyVklxGLp3Q51Iy4vx4fyWF/bjACBaEkpcqH1Nif2NOYkpcnMA6cVXSNebapMywr6lxgikJ01OODZQYywuTGIoOXwcn9FOa2X7E6fH9qLSQHxXYRPpCeXECU2VjVz5y6mKJqbJxtnS0yMy1SXHxem7j+MhSTkkMU9hbfI8RlJf6hb5KYfn6OTawhFTH+OMp7McEtuBHqyixKnmN5r5GpWMnL5XEEMvL3AolBVzHFMSlJM+FpcBUKanmwlB81YR+Ji81Nr6O+ycl9mMCA/imKHFh8uL09Ro6fc38aFWVj5W8EEvL/DSVzFBeKLDX+C77qvmwai4MS8n8u9GEPo6TKjnenB8R2MofrbK8UmAspi51/YW/69IXy0t9woTYNubaVOLCbU5iXQpDMf2NU2nlks/5G+cpTE3oo8Rwvu5r30+lsB8RGMHiQnmkvLB8zHZp6YgiU+lrTwtLNbG0zG+BMkNZoMSwlKxSWAqKUxcnMlxSZPiaL8f3wzR2Jq/4QW4usAt+tKrKxyUS6+a+KnlVElPbxtwKFgEnHZYYjxtMYaqMrObDcO4s5ZXiypSX78Vl5JlsfyKF3VxghJIEy4TlVYlrVD52yYvLR7UEtMb8Fiyv3Mcf/KqMfI/vMYRlJAuMf06BKWw0F4blZHJTaSE3FdjEzyb2tF7NfakScsm/d+zmvlhaCXcYY36Ss0RDj7HEcC6s+lkFl5JqUv8PrOfYUXNh+Y1kvnfE+THePIXdVGCEuuj8CZJtJ64ZaXH6UvIalZCJ5WV+CyUuXN8f13kujJMYp7AcS1xCzvysAtMYvm8KLbmZtJCbCWwifVXy4nmv1+hLxpn0heWjpWW2SCUzHksYAlI4oxSm1vN5+bdcSr7EeQmpjvGmKexmAiNYFpXE8sKzxFJeLLGZfzKEySvbXWiJWWTm3qjEhdtZxnECq1JYyonLR54Py+e/QoulJCYvNYZuIi3kJgJbmL74U+MlzsvBUfpSz+fkVSWwiNPjtLTMvYIyy3UcT5mGVBmJKWw0oc/zYZjAMNnlWPq1FHZ1gS34J0MsLy4f8xMDJaXENZO+ZspHddzG3ANSCnHad1FimMRwQr9KYX9j/K1kjin1s4pDnCex5Ou4byGxqwsM4FTD8sq2k1eXvrCsrJIXy6uSaSUxY+4Nllfu4/HF5SSOK05hSmKcwrCE5J9V8A9b89g4LV6dqwps4T8ZeqGlE9dsCVnJq5IYwh3CmHsCJcBCYHlxGYljLMtJNRc2SmHvtKS8DrSwZL/2XTuFXVVgBIsrLy5KLOXyCpSmOH0AABJXSURBVC1LrCsdVfJCiSl5VSVkYnmZe0WJC9exhKzmwtTPKqoUlgmMU1i2PBfGSSziVGhX52oCu8E/GeoSl5JXl8BYoJaW2TqVzFAgWEbyj1tTXjjeqgl9XvJ1coyluFQZice5iyunsKsJjGCZsbiUvDh1jdJXlcBYXrjg8VhkZot0KQzFleUcSozLyGxRXjMpTP0uDNNXVU5eRVrIVQQ2kb44BaHAuPSbSWBKXJ28drQglpbZKpXMeKxV1Y4qJasUhm3+Lc6FZSmZ30amzCJumMKuIjCCRdFdzE5eS9PXC7R7aFmgFpnZOpW4cDsFUiUwlBdP6KsUlo/n37DAsJSsJvMjrpzCLhbYxI9WUSL8SYASG5WOSlxLE1jE6XFaWmbrnKWbOB17KRMs9VA+KLEuhVWl5Ft8jzn8VhJlFnEqrqulsIsFRozS10heo7KRJbZEXpXE1LYx945KYZh2WGIzSWyUwngyP/+e58Ly/W6ewi4S2Ir0hSJTpWMlMiwrqwTG8mJxjSRmzFZRkuA+r6ZvcDKfU9jshD6mOfxJxT5+IIVdJDBCXTCWFyevSl4z+1T6YlGytBK+0cZskRQXr+c2jsVMRZjEVArDMYfC4n2cxPjHrfle+b45uZ+slhayWmAT6Yvlhckr2z/QqlKxKiVnS0eVxBDLy2wdJS5cZ3mhwFSYyDKymgfjxzHBvcb5j1txQl8d60UpbLXACJaEkpia+5opHzl9ofhYXtmyvBBLyzwqlcxQYigvHI+cwDBxVWVk/k2OZfXj1kxeKkSskhaySmAr0teMvLrEhclLJTCUF4tLXbjcb8wjUIkr4jT9pMg4gfE3kigvJTFMX2ouLF9f/axCHevqFLZKYATbdVZiLC8lMXwME1hVPuL7WlrmGalkliLJ8YGSSflgEstvJSuJ5T7+ZjLHI5aRN0thiwV2pfSFaWqJvFBgLC+nL/PMVOKK0CmMy0kcm7PfSP6N8zT2oylsscAItupSeXEC431V+urk5fRlnp1KZiivaoxWpWT3jSQ+X30jmb8NY4kli6SF7EdPQCbTVy4oFyUxltfM/BcLrJJXxOmxIBaZeVS6cZnbOFaq8TmqjkbTOzw+X0I7AtlFnDhmiksSmDqgfZxfmFexzMqLxcUS4/eztIz5ZBc6heU4xSSW4zR/AlGN1epnFTixn3/HCSzf86opbFpgC9JXXpDO7LPyquyOF57FNbS8MQ9MJS7c5rH6Eaciy3GKc2EjieXz1DeS2R7ifEL/ormwaYERShRcyr3QgvJiiY32czStSkglL0vLPCspCBwDOF4zDaXE+KcVKSSUlxqrPBfG30jm6/P7csiYkhayHz0hIq6ZviqJdQmMy8aRvBC+ccY8A12/V6GDA0c1XkdjlccrjtmuYkJ2ETE9F7YmgfGb48VAic2kryUXYySu4UUx5onYRV1KqrHLImOJzZSSS1IYl5LJohQ2TGCT6QvlNWtztVxaOiKWljGfjMauGrc4drsxqpZR1YTOKMfuTAq7JIHhOssr2yVlI16YKobyRagWZHgRjHlQdrE8hVXhA8dxlcBUCnuN71/lv8A6JrCA9roJjKgugJJXdwFmFpRXtntaLC1j5lBjhMcvjmMce2vHLgcQdEQ1fheN3VZgRflYmXtJDFUpbPYCjBIYsuhiGPOAdOKqxvFMAJmdv2YfdCHkTGSjMnJJAsM3mLkAXfLq6uiRuLqTDrFtjPlkJLMqjMxUUTNfwo0CSND6kCUCS0biUukrT/w15uU1Sl8WmTFzzIirGstqTHYSw7E+k8K6MTykFFhTPmbbnbg64e7E8fGZ9IUnjiy+AMY8GZXM1FhWIlszlnFMj8bymW+6MrIUGKHeAE+cTxZPeu0J58lWxg5Yt8iM6anENRrPKpQsHdMzCSzi/FiGzAos2YlFnWyVwtSJV/KaKR2RqRM2xpQyUymMA0knMR7nakxzKFFOmUYKbEH5yCfMpuUUxifOj3Wmdvoy5jIqcVVjuxrXM2O5Sl8sry6Jfa1XZeRMAlMvjCfOJ5snzAYenfALtNXJWlrGXIdOZjiulbxmJYaLCiQ8roPa4bieEVii5MUnXJlaSYxPDuU1c5IWmTHL6cTF21USY4l1Y7sKJZVHAtohSwQWoaVVneRIZK/0eJe8lMSS6ZM1xpzQyQzHXpfEZsa3GtdVQFk0nmcFxmasJFbJC09SnXB1ckpeFpkxl9GJq5OYSmI8jnl9JDEez9y2nAlMTOB38lIS4xNUtlYn1UnM0jLmNoxkVo3tLqxUY380tlv3qIn8M4ERo5NTJ4gnqmy9Rlp8chaZMZdRjW1cH431SmIsLTXGRxJL2rE9ElhSndye1keGruQ1klhSrRtj1tONsU5ea8c7e4PHuhKZZFZgyezJVTLjfUpe1YlVJzR1osaYM7oxxeNbjfVuTCtp8aLG9qLxPCOwnWiXnFwltEpe6uT4vY0x10eNNR7bsxLrXKDcwe+NbcmMwCLGEutE1gmtE1dA260bYy5nNNZGIpsZ6524FssrggTW/PfvT54GLR9QJaVOXDMnVB3P1EkaY0q6saXGuhqzM+NcbauxXrGLiLNvIk8EJsAnqzdSJzRzErzOS9B60p2gMeZy1JhT4x3HfTe+Kw+o8Y7vkbRjvhNY9YeVaKoTG51AJ7F8fWyNMbdFjblqjPN6N+6rca7GPVKO/U5giHqB6gAuWRB+fdzP+4wx6xmNs2psXroErSNT43tGYHxSM9tLlqC2OiFjzO8xM2Znl2Rmu2VGYAp+4dEBj5aA1hhz3+CYvWRBVo3/tQKLWCae0YGr15p5XWPM7VHjUo3PbpwrljhEconAOkYi6k5y9uSNMT9HFz66sazWr8Y1BVad4CxLnmuM+T2WjNVKelfhmgI7HBfeN8uS5xpjfo8lY1U5Ycnft1xTYAgeoDrYAy3qMWPM/dCNVXysGvs3GdOXCEwdcEUnrHwcW143xvwealyOxvHM3yxxiGStwPiNWVBLF3wtY8x9s3TcV3/D+xczIzB8YXxjfnx0EqOFXwPhY+B9xpj1qDGlxmA1Vi9ZEN43HOMzAovQL8Qng/sOEfFxXEYnMDqZ4UkYY27CzNjE8Y4tOoA9oF6LmRr3ncCqF+ADGUnpo1m6v2Oq/caY6zEaf9X4PlDL41s9L9+nG/f5uGSUwPAP+Q1xnzr42aU6YV4U5YkZY6boxpZauvE7Gufd2GanJO0YPxHY4XDgF1PwG+UJzJ5Id3LqZJPpkzLGLKYbazzOed/SRb1WQKs4RJw4KiLGCSzhN6jkNTqp9+YxJS91gnyS3UkbY2rUWFJjnMc7jud3WlfLGolNjesZgXXyUieHB6xOpDtBvkBKYgluT52sMeaLbvx00lJhRI159Tc4ptX4XiyxGYEhlcTUyanlrXmML4Q6uepEed0YU6PGzWi8KXktGd88xvF11die4nX0hCNKGkpcncTeoK1OVL1O/uNPdXK5P/9xaD5+tX8saswDweNnJK8147uTmXodNa6nRTYSGMoht7uTVVJCYb0V+3l5iXOBpawiToXFEsv9jKVmnomRADiQ5Honr2pMq4XH+we0LC9ekqHIzgR2OBwOx/91EcsBT3j2RPmER8sr/I36HwHEcf8H7WPU/tENNebRYTlk241nNZaXjmt+jSqFKal+bfM3kBHjBJZUEvuAdiSuf9D+i/OTzOUlvgVWyYrn7jidKVk5gZlnovrAVgmnCyOjcV2N7Ww5sXESQ490EpPMCizi/GT5pPHgKjv/K5bX45ICq/53TAhKLAVbUUnNmEdG9XkWRCcvJS2WFQtLBZQqgbFLgtaHLBFYMnPCM9JSApuVV8LzY2o+zJhnhUVQyYvH82wVlct/sD6SmPIGSywZimxGYPkiKQdeZqKmOuE/x+W/0AKr5IXvvYPnBjwfjzn/xphnBfs/px0s43AcdyHkP2h5PbeVyGZSWCUziRSYmMgPsc4SwxKyOnkW15/4PIb/ok5fyOH4vHzffXwfFz6fW8YJzTwi1aA/iJbHr6qiVLX032DB51Zl5GwCi9ynJvAj5hIY0p04yivns/4d1/PEX+NbWpi6cunSF77vPrTslMR43ZhnAQf9jLw4gHTi+n/H5T9ol0qMjyWgnWJWYPmiqoxU5eMbLXwhKnkpEan36+bKLDFj5uTFAqvSF4oKl/9Eq0TWzYEdoFVCaykF1pSR2eYb508d+AJgAssykaW1Vl6c2EYpTMnLQjOPhBrwB9GO5MUC48SFy/+F9U5enMBmS8hDRJTlY8R8AmOqi8ASe4nPk1DSqiTUvcd71MltJDFeN+ZRwQHfyStbVT2hwFBYuLDEUmQz5WNVQgattywRGL5oJjMlmH2MBbaHVskrxGvjhcZvLF/iVGD7499XElPbxjwCMsHEqSC4bEuh8NSPSl8sMJbYaB4M3wuPQR3nFK3AijIy4lxeuzgV2FucyqmTVgoHUWJMcfH8mZIYp7Bo1o15FKoUw0lHyUulr5z/6gSmEhhKjNMXJzCWWHKIiLZ8jFiWwCLqi5IHtItzib3E58kogVXJq7rA+A2mKkNZYiFaXjfmUVAC43SD4ujKxxSQmvf6P9FLrEpfKK8qfbXCYpYI7BB1CssLUiWxKh0pkaiL+xbfvx9Lic1O5ltg5lmoBKbGqhpj73H+i4FRCVlN5I8m8FGmLK1DRAzTV8SEwKCM/NpF6x/H9ZTFe5zKgxMXSwbpPhU6gXEK6wRmeZlHpkpeSmBc2nH5qL6BnBHYKH2hvCJOj20RQ4ERKoVlmwkMJZYpTAkr10cXlgW25EewXQpT28ZsEZlgQstrNM5QYtVPKHjyHiWG8vpH76HKR3nsM+krYlJggxSW25XElDyUvNSFxYu5RGAq5TmBmWfgIFocX2sEVv0OrJu8V98+KnlVIptiSmDEIT4lkG+Y63iRcn9KLESrLjBeTLyoI4HhFwQpLfyCAEWW28Y8GigBlALKK9ff41RilcCy/X9xKjLep346wSVqJ7HIdjZ9RSwQGKWwlFiuR3yLK3k/tir5qAutanKVvmbmwFQpmVhk5tHg8YTrHC6y7ebAqhQ2Wjh5jdIXMi0tZFpgEWcSi9AHgQkMUbLAi6ki7Z+o0xf/mHVNCWmBmUdACQzbTmDZvtHCk/koM17n5DU793UmsiXpK2KhwIhMYdXF41JSPYcvrhIYJ68U1zUEllhkZouowX6JwHjaphJZtWDqmhEXH+tiFgtsUErmgXA5ifCFreLsKHkt+R1YV0Ya8yhwmKiWqurpkhjLDCXHJeNM+kq+1pemr4gVAos4k1jEt8jwAJTERhcTPw3+xPdFUslLyWvJzygsMfNIKCnMCExVPpXI1DY+F6U1kteJrNbIK2KlwAglr4Qlpi4sxlq+kCp1vcZ32VilL1wP0fK6MVunEli2ONZYYigeFBEnK7WNrRIXy6uU2BpWC6woJUcSUxc2T/IlThPYK7SqZFybvpS4LDOzRdR4q+TFi0phHCKUpHidxZUtC7OU19r0FXGBwCIWS+wQn5LJ5+Y2X9CU1PuxfYtTaSlxjSbvZ5KXJWa2RDXocT8LA8eakhinMZaZkpZKXJW4riqviAsFFrFIYhHfaYxPihOYSlqVuCp5uXw0zwbLi9tZialExbKqSsUfk1fEFQQWMSWx3IcyUSeYQsoLlNtVuTgjrxlxWWhmi1QC4LE3IzElsypdqYVfk98zoL2KvCIidld6nYiIoG8mVQLiZU/rLKdKWvx3a+RlaZlHggfyUomhwJTM1H71GriEaK8mr4grCyxikcQizuVTJSuVtJS4LC/zzKyVmBLZTIvP59cN0V5VXhE3EFhEKbFcVzKrlkpw1RJNi1hg5hFRg7mSiZKYkpnarpag9dz+XLmBbG4isIgziUX0gqlEpISmHguxnlhg5lnoBIbrSji4b1QSVvtV+7lxI9HcTGDJII1xW8mL91XPT0YC6/Ybs0WqgSzTUNSpaSQs9XxsT9ZvJa7k5gKLOJNYxFhk2Xbpqmp5XW0b8wzw4FaS6doZYVWCvLm8In5IYMlCkal915KWhWYekW4wXyqz6rm8/iPiSn5UYBFSYhG1fCpBWVzG1Fwqsmq9+9vPHT8slB8XWDIpMrWvk9dovzHPTDXYyzQltuW+nxZX8msCSwqRRSyX00hao8eNeSRGA3tGZsP9vyWu5NcFhjQy+3rKhY8bY9bL7fPBO5LGXQkMmZAZsuS5xphPpgf/PUkLuVuBKRZKzRizgnuVlWJTAquw2IxZzpZEVfEQAjPGPCf7MMaYjWKBGWM2y/8P1EmzCHs8igwAAAAASUVORK5CYII="
  }), pe.createElement("path", {
    d: "M292.77,379.28,291.05,376c-6.46-12.34-21.57-41.2-37.17-65.83-5.24-8.26-10.51-16-15.29-22.94-7.64-11.16-17.13-25-17.23-29.16.58-18.1.18-60.92,0-74.16h9.82V165.17H105.38v18.76h13.21c-.15,13.24-.53,56,0,74.13-.1,4.14-9.6,18-17.24,29.19-4.76,7-10,14.69-15.28,22.94C70.52,334.82,55.41,363.68,49,376l-1.72,3.26c-6.65,12.59-6.72,29.77-.21,41.77,4.94,9.1,12.88,14.12,22.32,14.12H270.66c9.43,0,17.37-5,22.32-14.12C299.49,409.05,299.42,391.87,292.77,379.28Z",
    fill: "#fff"
  }), pe.createElement("path", {
    d: "M270.71,381c-3.81-7.24-12.69-24.23-21.88-38.7-2.34-3.73-4.67-7.16-6.91-10.46,0,0-11.64,5.17-47.52,6.46s-41.94,11-62.13,9.07-34.59-15.53-34.59-15.53c-2.24,3.3-4.56,6.73-6.91,10.46C81.59,356.77,72.68,373.76,68.9,381l-1,1.93c-3.91,7.41-4,17.5-.12,24.57,2.92,5.35,7.57,8.29,13.12,8.29H258.72c5.55,0,10.21-2.94,13.13-8.29,3.81-7.07,3.78-17.16-.13-24.57Zm-165.15,2.58c-6.62,0-12-5.75-12-12.86s5.39-12.87,12-12.87,12,5.76,12,12.87S112.18,383.58,105.56,383.58Zm13.33,22.06a4.62,4.62,0,1,1,4.3-4.61A4.46,4.46,0,0,1,118.89,405.64Zm37.76-29.07a7.79,7.79,0,1,1,7.23-7.77A7.51,7.51,0,0,1,156.65,376.57Zm29.08,25.94a6.09,6.09,0,1,1,5.68-6.08A5.88,5.88,0,0,1,185.73,402.51Zm36.41-11.61c-7.13,0-12.91-6.21-12.91-13.88s5.78-13.87,12.91-13.87,13,6.22,13,13.87S229.31,390.9,222.14,390.9Zm13.35,14.74a4.62,4.62,0,1,1,4.3-4.61A4.46,4.46,0,0,1,235.49,405.64Z",
    fill: "#f65a8e"
  }), pe.createElement("image", {
    width: "98",
    height: "98",
    transform: "translate(145 78)",
    opacity: "0.1",
    xlinkHref: "data:image/png;base64,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"
  }), pe.createElement("rect", {
    x: "171.16",
    y: "104.17",
    width: "45",
    height: "45",
    rx: "11.25",
    ry: "11.25",
    transform: "translate(-22.1 43.03) rotate(-12)",
    fill: "#fff"
  }), pe.createElement("rect", {
    x: "179.16",
    y: "112.17",
    width: "29",
    height: "29",
    rx: "5.1",
    ry: "5.1",
    transform: "translate(-22.1 43.03) rotate(-12)",
    fill: "#f65a8e"
  }), pe.createElement("image", {
    width: "108",
    height: "109",
    transform: "translate(161 2)",
    opacity: "0.1",
    xlinkHref: "data:image/png;base64,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"
  }), pe.createElement("rect", {
    x: "187.35",
    y: "28.49",
    width: "55.89",
    height: "55.89",
    rx: "11.25",
    ry: "11.25",
    transform: "translate(136.67 264.66) rotate(-84)",
    fill: "#fff"
  }), pe.createElement("rect", {
    x: "197.29",
    y: "38.42",
    width: "36.02",
    height: "36.02",
    rx: "5.1",
    ry: "5.1",
    transform: "translate(7.08 -22.2) rotate(6)",
    fill: "#0ab6d4"
  }), pe.createElement("image", {
    width: "84",
    height: "84",
    transform: "translate(115 45)",
    opacity: "0.1",
    xlinkHref: "data:image/png;base64,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"
  }), pe.createElement("rect", {
    x: "140.96",
    y: "70.65",
    width: "32.13",
    height: "32.13",
    rx: "11.25",
    ry: "11.25",
    transform: "translate(19.8 202.23) rotate(-69)",
    fill: "#fff"
  }), pe.createElement("rect", {
    x: "146.68",
    y: "76.36",
    width: "20.7",
    height: "20.7",
    rx: "5.1",
    ry: "5.1",
    transform: "translate(41.5 -50.51) rotate(21)",
    fill: "#fcee21"
  }));
},
    fa = function fa() {
  var t = be(g),
      n = t.bricks,
      r = t.pageTypes,
      a = t.responsiveBreakpoints,
      o = be(ln).setCurrentPage,
      i = e(ye(null), 2),
      l = i[0],
      s = i[1],
      d = e(ye([]), 2),
      u = d[0],
      m = d[1],
      p = e(ye(c(c({}, X), {
    type: "rb-playground"
  })), 2),
      b = p[0],
      h = p[1],
      x = e(ye(null), 2),
      v = x[0],
      y = x[1],
      w = e(ye(!0), 2),
      k = w[0],
      E = w[1],
      C = e(ye(a[a.length - 1]), 2),
      A = C[0],
      N = C[1];
  return he(function () {
    var e;

    if (l) {
      var t = "playground_".concat(Ut());

      if (l.type === f.PlaygroundSelectedItemType.Block) {
        var a = n[l.name],
            i = Ut();

        if (y(i), a) {
          var s = a.schema.getDefaultProps ? a.schema.getDefaultProps() : {};
          (null === (e = a.schema.repeaterItems) || void 0 === e ? void 0 : e.length) && (s = Object.keys(s).reduce(function (e, t) {
            var n,
                r,
                o,
                i,
                l = s[t];
            if (!Array.isArray(l)) return c(c({}, e), ((n = {})[t] = l, n));
            var d = null === (i = a.schema.repeaterItems) || void 0 === i ? void 0 : i.find(function (e) {
              return e.name === t;
            });
            if (!d) return c(c({}, e), ((r = {})[t] = l, r));
            var u = l.map(function (e) {
              return {
                id: Ut(),
                type: d.itemType,
                props: c({}, e)
              };
            });
            return c(c({}, e), ((o = {})[t] = u, o));
          }, {}));
          var d = {
            id: i,
            type: l.name,
            props: s
          };
          m([d]), h(c(c({}, b), {
            id: "",
            name: l.label,
            slug: l.name
          })), o({
            pageId: ""
          });
        }
      } else {
        var u = r.find(function (e) {
          return e.name === l.name;
        });
        u && (m(u.getDefaultContent ? Z(n, vr(n, u), u.allowedBlockTypes, u.excludedBlockTypes).blocks : []), h(c(c({}, b), {
          id: t,
          name: l.label,
          slug: l.name
        })), o({
          pageId: t
        }));
      }
    }
  }, [l]), pe.createElement(ma.Provider, {
    value: {
      selectedItem: l,
      setSelectedItem: s
    }
  }, pe.createElement("div", {
    className: "w-full pt-10 mx-auto flex justify-between"
  }, pe.createElement(pa, null), l ? pe.createElement("div", {
    className: "flex-1"
  }, pe.createElement(Ir, {
    page: b,
    sidebarOpen: k,
    setSidebarOpen: E,
    devicePreview: A,
    setDevicePreview: N,
    isPlayground: !0
  }), pe.createElement(sa, {
    page: b,
    content: u,
    onChange: m,
    handleChangePageValue: function handleChangePageValue() {},
    locked: l.type === f.PlaygroundSelectedItemType.Block,
    playgroundSelectedItem: l,
    playgroundBlockId: v,
    sidebarOpen: k,
    devicePreview: A,
    isPlayground: !0
  })) : pe.createElement("div", {
    className: "flex-1 flex flex-col justify-center items-center pt-12"
  }, pe.createElement("div", {
    style: {
      width: 200,
      height: 200
    }
  }, pe.createElement(ga, {
    className: "w-full h-full"
  })), pe.createElement("p", {
    className: "mt-8 text-lg"
  }, "Here you can test your content Bricks and Page types."))));
},
    ba = function ba(e) {
  return void 0 === e && (e = f.DeployEnvironment.Staging), tt(function () {
    return b(void 0, void 0, void 0, function () {
      return E(this, function (t) {
        switch (t.label) {
          case 0:
            return [4, at.post("/admin/deploy", {
              env: e
            }).then(function (e) {
              return e.data;
            })];

          case 1:
            return [2, t.sent()];
        }
      });
    });
  }, {
    onSuccess: function onSuccess(t) {
      "OK" === t.result ? ot.success("Rebuild requested on ".concat(e, " environment"), {
        position: "bottom-right"
      }) : ot.warn("The webhook returned an error: ".concat(t.message), {
        position: "bottom-right"
      });
    },
    onError: function onError() {
      ot.error("An error occurred while requesting rebuild");
    }
  });
},
    ha = function ha() {
  var e = localStorage.getItem(j),
      t = V("t");
  return rt("getDashboardToken", function () {
    return b(void 0, void 0, void 0, function () {
      return E(this, function (e) {
        switch (e.label) {
          case 0:
            return [4, at.get("/admin/session/get_dashboard_token")];

          case 1:
            return [2, e.sent().data.authToken];
        }
      });
    });
  }, {
    enabled: !!t || !!e,
    staleTime: 18e5
  });
},
    xa = function xa() {
  var e = be(g).appId,
      t = Qr(e).data,
      n = null == t ? void 0 : t.user,
      r = ba(f.DeployEnvironment.Production),
      a = ba(f.DeployEnvironment.Staging),
      o = ha().data;
  return pe.createElement("div", {
    className: "mt-20 py-16 px-20 max-w-3xl bg-white mx-auto"
  }, pe.createElement("h2", {
    className: "text-lg font-semibold text-gray-700 mb-6 flex items-center"
  }, pe.createElement("div", {
    className: "mr-2"
  }, null == n ? void 0 : n.appName), n && pe.createElement("div", {
    className: "inline-block text-white text-xs font-bold uppercase tracking-wide py-px px-2 rounded-sm",
    style: {
      backgroundColor: "enterprise" === n.plan.toLowerCase() ? "#8a5df5" : "pro" === n.plan.toLowerCase() || "pro - yearly" === n.plan.toLowerCase() ? "#3c81f6" : "essential" === n.plan.toLowerCase() ? "#13b981" : "#84cc18"
    }
  }, n.plan)), pe.createElement("div", {
    className: "flex space-x-4"
  }, pe.createElement("button", {
    type: "button",
    disabled: !((null == n ? void 0 : n.deployHookStagingUrl) && (null == n ? void 0 : n.canDeployStaging)),
    onClick: function onClick() {
      a.mutate();
    },
    className: "flex-1 bg-blue-500 hover:bg-blue-600 hover:shadow-lg text-white font-semibold py-3 px-4 rounded disabled:opacity-75 disabled:cursor-not-allowed"
  }, "Deploy to Staging"), pe.createElement("button", {
    type: "button",
    disabled: !((null == n ? void 0 : n.deployHookUrl) && (null == n ? void 0 : n.canDeploy)),
    onClick: function onClick() {
      r.mutate();
    },
    className: "flex-1 bg-pink-500 hover:bg-pink-600 hover:shadow-lg text-white font-semibold py-2 px-4 rounded disabled:opacity-75 disabled:cursor-not-allowed"
  }, "Deploy to Production")), (null == n ? void 0 : n.isAdmin) && o && pe.createElement("div", {
    className: "py-6"
  }, pe.createElement("h2", {
    className: "mt-6 text-lg font-semibold text-gray-700 mb-4 flex items-center"
  }, "App Settings"), pe.createElement("p", {
    className: "mb-6 text-gray-500"
  }, "Shortcuts to reach the React Bricks Dashboard for this app."), pe.createElement("div", null, pe.createElement("div", {
    className: "flex space-x-4"
  }, pe.createElement("a", {
    href: "https://dashboard.reactbricks.com/apps/".concat(e, "/plan?t=").concat(o),
    target: "_blank",
    className: "flex-1 py-2 px-4 border rounded mb-4 hover:bg-pink-100 hover:border-pink-400 hover:shadow-lg transition-all"
  }, pe.createElement("h3", {
    className: "flex items-center"
  }, pe.createElement(Rt, {
    className: "text-lg text-pink-500 mr-2"
  }), pe.createElement("span", null, "Upgrade or change plan"))), pe.createElement("a", {
    href: "https://dashboard.reactbricks.com/apps/".concat(e, "/users?t=").concat(o),
    target: "_blank",
    className: "flex-1 py-2 px-4 border rounded mb-4 hover:bg-pink-100 hover:border-pink-400 hover:shadow-lg transition-all"
  }, pe.createElement("h3", {
    className: "flex items-center"
  }, pe.createElement(Mt, {
    className: "text-lg text-pink-500 mr-2"
  }), pe.createElement("span", null, "Users")))), pe.createElement("div", {
    className: "flex space-x-4"
  }, pe.createElement("a", {
    href: "https://dashboard.reactbricks.com/apps/".concat(e, "/web-hooks?t=").concat(o),
    target: "_blank",
    className: "flex-1 py-2 px-4 border rounded mb-4 hover:bg-pink-100 hover:border-pink-400 hover:shadow-lg transition-all"
  }, pe.createElement("h3", {
    className: "flex items-center"
  }, pe.createElement(Ot, {
    className: "text-lg text-pink-500 mr-2"
  }), pe.createElement("span", null, "Deploy hooks"))), pe.createElement("a", {
    href: "https://dashboard.reactbricks.com/apps/".concat(e, "/languages?t=").concat(o),
    target: "_blank",
    className: "flex-1 py-2 px-4 border rounded mb-4 hover:bg-pink-100 hover:border-pink-400 hover:shadow-lg transition-all"
  }, pe.createElement("h3", {
    className: "flex items-center"
  }, pe.createElement(Ft, {
    className: "text-lg text-pink-500 mr-2"
  }), pe.createElement("span", null, "Languages (i18n)")))), pe.createElement("div", {
    className: "flex space-x-4"
  }, pe.createElement("a", {
    href: "https://dashboard.reactbricks.com/apps/".concat(e, "/history?t=").concat(o),
    target: "_blank",
    className: "flex-1 py-2 px-4 border rounded mb-4 hover:bg-pink-100 hover:border-pink-400 hover:shadow-lg transition-all"
  }, pe.createElement("h3", {
    className: "flex items-center"
  }, pe.createElement(Yt, {
    className: "text-lg text-pink-500 mr-2"
  }), pe.createElement("span", null, "Change history"))), pe.createElement("a", {
    href: "https://dashboard.reactbricks.com/apps/".concat(e, "/backup-restore?t=").concat(o),
    target: "_blank",
    className: "flex-1 py-2 px-4 border rounded mb-4 hover:bg-pink-100 hover:border-pink-400 hover:shadow-lg transition-all"
  }, pe.createElement("h3", {
    className: "flex items-center"
  }, pe.createElement(Wt, {
    className: "text-lg text-pink-500 mr-2"
  }), pe.createElement("span", null, "Backup and restore")))))));
},
    va = function va(t) {
  var n = t.children;
  t.styles, t.stylesheets;
  var r = t.head,
      a = d(t, ["children", "styles", "stylesheets", "head"]),
      o = e(ye(null), 2),
      i = o[0],
      l = o[1],
      s = e(ye(null), 2),
      u = s[0],
      m = s[1],
      p = e(ye(!1), 2),
      g = p[0],
      f = p[1],
      b = ve(null);
  he(function () {
    if (g) {
      var e = b.current.contentDocument.head;

      if (l(e), !u) {
        var t = b.current.contentDocument.body;
        m(t);
      }
    }
  }, [g]);
  return ge.createElement("iframe", c({
    ref: b,
    srcDoc: "<!DOCTYPE html>",
    title: "content"
  }, a, {
    onLoad: function onLoad(e) {
      e.defaultPrevented || e.target.contentDocument && f(!0);
    }
  }), i && Zt.createPortal(r, i), u && Zt.createPortal(n, u));
},
    ya = {
  en: en
},
    wa = function wa(e) {
  var t = "#3174ad";
  if (!0 === e.alreadyPublished) t = "#10b981";
  return {
    style: {
      backgroundColor: t
    }
  };
},
    ka = function ka(e) {
  var t = e.event;
  return ge.createElement("span", null, t.title);
},
    Ea = function Ea(e) {
  var t = e.setCalendarModalOpen,
      n = B().data,
      r = be(g).navigate,
      a = be(ln).setCurrentPage,
      o = null == n ? void 0 : n.filter(function (e) {
    return !!e.scheduledForPublishingOn;
  }).map(function (e) {
    return {
      title: e.name,
      start: new Date(e.scheduledForPublishingOn || ""),
      end: new Date(e.scheduledForPublishingOn || ""),
      id: e.id,
      language: e.language,
      alreadyPublished: -1 === tn(new Date(e.scheduledForPublishingOn || ""), new Date())
    };
  }),
      i = an({
    format: ct,
    parse: nn,
    startOfWeek: rn,
    getDay: $t,
    locales: ya
  });
  return ge.createElement(ge.Fragment, null, ge.createElement("style", null, "\n.rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\n\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\n\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n.rbc-calendar {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  -webkit-box-sizing: inherit;\n  box-sizing: inherit;\n}\n\n.rbc-abs-full,\n.rbc-row-bg {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.rbc-ellipsis,\n.rbc-show-more,\n.rbc-row-segment .rbc-event-content,\n.rbc-event-label {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rbc-rtl {\n  direction: rtl;\n}\n\n.rbc-off-range {\n  color: #999999;\n}\n\n.rbc-off-range-bg {\n  background: #e6e6e6;\n}\n\n.rbc-header {\n  overflow: hidden;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: bold;\n  font-size: 90%;\n  min-height: 0;\n  border-bottom: 1px solid #ddd;\n}\n.rbc-header + .rbc-header {\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-header + .rbc-header {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n.rbc-header > a,\n.rbc-header > a:active,\n.rbc-header > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n\n.rbc-button-link {\n  color: inherit;\n  background: none;\n  margin: 0;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n\n.rbc-row-content {\n  position: relative;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  z-index: 4;\n}\n\n.rbc-row-content-scrollable {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 100%;\n}\n.rbc-row-content-scrollable .rbc-row-content-scroll-container {\n  height: 100%;\n  overflow-y: scroll;\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n}\n.rbc-row-content-scrollable\n  .rbc-row-content-scroll-container::-webkit-scrollbar {\n  display: none;\n}\n\n.rbc-today {\n  background-color: #eaf6ff;\n}\n\n.rbc-toolbar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n.rbc-toolbar .rbc-toolbar-label {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  padding: 0 10px;\n  text-align: center;\n}\n.rbc-toolbar button {\n  color: #373a3c;\n  display: inline-block;\n  margin: 0;\n  text-align: center;\n  vertical-align: middle;\n  background: none;\n  background-image: none;\n  border: 1px solid #ccc;\n  padding: 0.375rem 1rem;\n  border-radius: 4px;\n  line-height: normal;\n  white-space: nowrap;\n}\n.rbc-toolbar button:active,\n.rbc-toolbar button.rbc-active {\n  background-image: none;\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.rbc-toolbar button:active:hover,\n.rbc-toolbar button:active:focus,\n.rbc-toolbar button.rbc-active:hover,\n.rbc-toolbar button.rbc-active:focus {\n  color: #373a3c;\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n}\n.rbc-toolbar button:focus {\n  color: #373a3c;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.rbc-toolbar button:hover {\n  color: #373a3c;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap;\n}\n.rbc-btn-group > button:first-child:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {\n  border-radius: 4px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.rbc-btn-group button + button {\n  margin-left: -1px;\n}\n.rbc-rtl .rbc-btn-group button + button {\n  margin-left: 0;\n  margin-right: -1px;\n}\n.rbc-btn-group + .rbc-btn-group,\n.rbc-btn-group + button {\n  margin-left: 10px;\n}\n\n.rbc-event,\n.rbc-day-slot .rbc-background-event {\n  border: none;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  margin: 0;\n  padding: 2px 5px;\n  background-color: #3174ad;\n  border-radius: 5px;\n  color: #fff;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n}\n.rbc-slot-selecting .rbc-event,\n.rbc-slot-selecting .rbc-day-slot .rbc-background-event,\n.rbc-day-slot .rbc-slot-selecting .rbc-background-event {\n  cursor: inherit;\n  pointer-events: none;\n}\n.rbc-event.rbc-selected,\n.rbc-day-slot .rbc-selected.rbc-background-event {\n  background-color: #265985;\n}\n.rbc-event:focus,\n.rbc-day-slot .rbc-background-event:focus {\n  outline: 5px auto #3b99fc;\n}\n\n.rbc-event-label {\n  font-size: 80%;\n}\n\n.rbc-event-overlaps {\n  -webkit-box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbc-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.rbc-row-segment {\n  padding: 0 1px 1px 1px;\n}\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.rbc-show-more {\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  color: #3174ad;\n}\n.rbc-show-more:hover,\n.rbc-show-more:focus {\n  color: #265985;\n}\n\n.rbc-month-view {\n  position: relative;\n  border: 1px solid #ddd;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  height: 100%;\n}\n\n.rbc-month-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.rbc-month-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  -ms-flex-preferred-size: 0px;\n  flex-basis: 0px;\n  overflow: hidden;\n  height: 100%;\n}\n.rbc-month-row + .rbc-month-row {\n  border-top: 1px solid #ddd;\n}\n\n.rbc-date-cell {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  min-width: 0;\n  padding-right: 5px;\n  text-align: right;\n}\n.rbc-date-cell.rbc-now {\n  font-weight: bold;\n}\n.rbc-date-cell > a,\n.rbc-date-cell > a:active,\n.rbc-date-cell > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n\n.rbc-row-bg {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: hidden;\n}\n\n.rbc-day-bg {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n}\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n}\n.rbc-overlay > * + * {\n  margin-top: 1px;\n}\n\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n\n.rbc-agenda-view {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: auto;\n}\n.rbc-agenda-view table.rbc-agenda-table {\n  width: 100%;\n  border: 1px solid #ddd;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  padding: 5px 10px;\n  vertical-align: top;\n}\n.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {\n  padding-left: 15px;\n  padding-right: 15px;\n  text-transform: lowercase;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n  border-top: 1px solid #ddd;\n}\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  padding: 3px 5px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  text-align: right;\n}\n\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n}\n.rbc-agenda-time-cell .rbc-continues-after:after {\n  content: ' »';\n}\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n  content: '« ';\n}\n\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n\n.rbc-agenda-event-cell {\n  width: 100%;\n}\n\n.rbc-time-column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  min-height: 100%;\n}\n.rbc-time-column .rbc-timeslot-group {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.rbc-timeslot-group {\n  border-bottom: 1px solid #ddd;\n  min-height: 40px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-flow: column nowrap;\n  flex-flow: column nowrap;\n}\n\n.rbc-time-gutter,\n.rbc-header-gutter {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n  flex: none;\n}\n\n.rbc-label {\n  padding: 0 5px;\n}\n\n.rbc-day-slot {\n  position: relative;\n}\n.rbc-day-slot .rbc-events-container {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  margin-right: 10px;\n  top: 0;\n}\n.rbc-day-slot .rbc-events-container.rbc-rtl {\n  left: 10px;\n  right: 0;\n}\n.rbc-day-slot .rbc-event,\n.rbc-day-slot .rbc-background-event {\n  border: 1px solid #265985;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-height: 100%;\n  min-height: 20px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-flow: column wrap;\n  flex-flow: column wrap;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  overflow: hidden;\n  position: absolute;\n}\n.rbc-day-slot .rbc-background-event {\n  opacity: 0.75;\n}\n.rbc-day-slot .rbc-event-label {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n  flex: none;\n  padding-right: 5px;\n  width: auto;\n}\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  word-wrap: break-word;\n  line-height: 1;\n  height: 100%;\n  min-height: 1em;\n}\n.rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid #f7f7f7;\n}\n\n.rbc-time-view-resources .rbc-time-gutter,\n.rbc-time-view-resources .rbc-time-header-gutter {\n  position: sticky;\n  left: 0;\n  background-color: white;\n  border-right: 1px solid #ddd;\n  z-index: 10;\n  margin-right: -1px;\n}\n.rbc-time-view-resources .rbc-time-header {\n  overflow: hidden;\n}\n.rbc-time-view-resources .rbc-time-header-content {\n  min-width: auto;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  -ms-flex-preferred-size: 0px;\n  flex-basis: 0px;\n}\n.rbc-time-view-resources .rbc-time-header-cell-single-day {\n  display: none;\n}\n.rbc-time-view-resources .rbc-day-slot {\n  min-width: 140px;\n}\n.rbc-time-view-resources .rbc-header,\n.rbc-time-view-resources .rbc-day-bg {\n  width: 140px;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  -ms-flex-preferred-size: 0 px;\n  flex-basis: 0 px;\n}\n\n.rbc-time-header-content + .rbc-time-header-content {\n  margin-left: -1px;\n}\n\n.rbc-time-slot {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n}\n.rbc-time-slot.rbc-now {\n  font-weight: bold;\n}\n\n.rbc-day-header {\n  text-align: center;\n}\n\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 75%;\n  width: 100%;\n  padding: 3px;\n}\n\n.rbc-slot-selecting {\n  cursor: move;\n}\n\n.rbc-time-view {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n  border: 1px solid #ddd;\n  min-height: 0;\n}\n.rbc-time-view .rbc-time-gutter {\n  white-space: nowrap;\n  text-align: right;\n}\n.rbc-time-view .rbc-allday-cell {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.rbc-time-view .rbc-allday-cell + .rbc-allday-cell {\n  border-left: 1px solid #ddd;\n}\n.rbc-time-view .rbc-allday-events {\n  position: relative;\n  z-index: 4;\n}\n.rbc-time-view .rbc-row {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  min-height: 20px;\n}\n\n.rbc-time-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.rbc-time-header.rbc-overflowing {\n  border-right: 1px solid #ddd;\n}\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n  border-right-width: 0;\n  border-left: 1px solid #ddd;\n}\n.rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid #ddd;\n}\n.rbc-time-header > .rbc-row.rbc-row-resource {\n  border-bottom: 1px solid #ddd;\n}\n\n.rbc-time-header-cell-single-day {\n  display: none;\n}\n\n.rbc-time-header-content {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-width: 0;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-time-header-content {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n.rbc-time-header-content > .rbc-row.rbc-row-resource {\n  border-bottom: 1px solid #ddd;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n\n.rbc-time-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid #ddd;\n  overflow-y: auto;\n  position: relative;\n}\n.rbc-time-content > .rbc-time-gutter {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n  flex: none;\n}\n.rbc-time-content > * + * > * {\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-time-content > * + * > * {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n.rbc-time-content > .rbc-day-slot {\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 3;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #74ad31;\n  pointer-events: none;\n}\n\n/*# sourceMappingURL=react-big-calendar.css.map */\n"), ge.createElement("div", {
    className: "w-full pt-10 mx-auto",
    style: {
      minWidth: 800
    }
  }, ge.createElement(on, {
    components: {
      event: ka,
      agenda: {
        event: function event(e) {
          var t = e.title;
          return ge.createElement("span", {
            style: {
              cursor: "pointer"
            }
          }, t);
        }
      },
      eventWrapper: function eventWrapper(e) {
        return ge.createElement("div", {
          className: "wrapper"
        }, e.children);
      }
    },
    localizer: i,
    events: o,
    startAccessor: "start",
    endAccessor: "end",
    style: {
      height: 600
    },
    onSelectEvent: function onSelectEvent(e) {
      e && (a({
        pageId: e.id,
        language: e.language
      }), t(!1), r("/admin/editor"));
    },
    eventPropGetter: wa
  })));
},
    Ca = function Ca(e) {
  var t = e.CalendarModalOpen,
      n = e.setCalendarModalOpen;
  return ge.createElement(et, {
    isOpen: t,
    onRequestClose: function onRequestClose() {
      n(!1);
    },
    style: Zn,
    parentSelector: function parentSelector() {
      return lr();
    }
  }, ge.createElement("div", {
    className: "p-4 font-admin"
  }, ge.createElement(Ea, {
    setCalendarModalOpen: n
  })));
},
    Aa = function Aa(e) {
  var t = e.dismissPopup,
      n = ha().data;
  return pe.createElement("div", {
    className: "absolute bg-white border border-pink-400 shadow-lg",
    style: {
      top: 33,
      right: 0,
      width: 300,
      padding: "1rem 1.5rem 1rem"
    }
  }, pe.createElement("p", {
    className: "font-semibold mb-2 text-pink-700"
  }, "Email not verified"), pe.createElement("p", {
    className: "text-sm text-gray-500 mb-3"
  }, "Your email address hasn't been verified, yet. Some actions may be limited by this."), pe.createElement("div", {
    className: "flex space-x-4"
  }, pe.createElement("button", {
    type: "button",
    className: "px-6 py-2 bg-blue-500 hover:bg-blue-600 hover:shadow-lg text-sm leading-none text-white font-semibold rounded disabled:opacity-75 disabled:cursor-not-allowed",
    onClick: function onClick() {
      window.open("https://dashboard.reactbricks.com/verify-email?t=".concat(n));
    }
  }, "Verify now"), pe.createElement("button", {
    type: "button",
    className: "px-6 py-2 bg-gray-100 hover:bg-gray-200 text-gray-500 hover:text-gray-700 hover:shadow-lg text-sm leading-none font-semibold rounded disabled:opacity-75 disabled:cursor-not-allowed",
    onClick: t
  }, "Postpone")));
},
    Na = function Na() {
  var e = function () {
    var e = nt();
    return tt(function (e) {
      var t = e.appId,
          n = e.email,
          r = e.password,
          a = e.keepLoggedIn;
      return b(void 0, void 0, void 0, function () {
        return E(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, at.post("/admin/session", {
                appId: t,
                email: n,
                password: r,
                keepLoggedIn: a
              }).then(function (e) {
                return e.data;
              })];

            case 1:
              return [2, e.sent()];
          }
        });
      });
    }, {
      onSuccess: function onSuccess() {
        e.invalidateQueries("session");
      },
      onError: function onError() {}
    });
  }(),
      t = nt(),
      n = be(g),
      r = n.appId,
      a = n.navigate,
      o = n.editorPath,
      i = n.loginPath;

  return {
    loginUser: function loginUser(t, n, i) {
      return b(void 0, void 0, void 0, function () {
        var l, c;
        return E(this, function (s) {
          switch (s.label) {
            case 0:
              l = {
                appId: r,
                email: t,
                password: n,
                keepLoggedIn: i
              }, s.label = 1;

            case 1:
              return s.trys.push([1, 3,, 4]), [4, e.mutateAsync(l)];

            case 2:
              return (c = s.sent()) && c.authToken ? (localStorage.setItem(j, c.authToken), a(o), [2, c]) : [2, null];

            case 3:
              return s.sent(), [2, null];

            case 4:
              return [2];
          }
        });
      });
    },
    logoutUser: function logoutUser() {
      localStorage.removeItem(j), t.clear(), a(i);
    }
  };
},
    Sa = function Sa(t) {
  var n = t.renderMenu,
      r = t.designSystemTitle,
      a = e(ye(!1), 2),
      o = a[0],
      i = a[1],
      l = Na().logoutUser,
      c = be(g),
      s = c.appId,
      d = c.logo,
      u = Qr(s).data,
      m = null == u ? void 0 : u.user,
      p = e(ye(!1), 2),
      f = p[0],
      b = p[1];
  return pe.createElement(pe.Fragment, null, pe.createElement("div", {
    className: "fixed top-0 inset-x-0 flex bg-white shadow z-50 h-10"
  }, pe.createElement("div", {
    className: "w-full mx-auto px-4 flex justify-between items-center relative"
  }, d ? pe.createElement("img", {
    src: d,
    alt: "React Bricks",
    className: "h-6"
  }) : pe.createElement(xr, {
    className: "h-6"
  }), r ? pe.createElement("div", {
    className: "flex-1 flex justify-center"
  }, r) : null, m && m.email && n && n(), m && m.email && pe.createElement("div", {
    className: "flex flex-row items-center text-xs leading-none text-gray-600 uppercase"
  }, ea(m.plan) && pe.createElement(Nr, {
    onClick: function onClick() {
      return i(!0);
    },
    tooltip: "Open Editorial calendar",
    active: o,
    className: "mr-2"
  }, pe.createElement(ht, null)), m.avatarUrl && pe.createElement("img", {
    className: "w-8 h-8 border rounded-full mr-2",
    src: m.avatarUrl,
    alt: "".concat(m.firstName, " ").concat(m.lastName)
  }), pe.createElement("div", {
    className: "mr-2"
  }, m.firstName, " ", m.lastName), pe.createElement("button", {
    className: "hover:text-gray-900",
    onClick: function onClick() {
      return l();
    }
  }, pe.createElement(jt, null))), m && !m.isVerified && !f && pe.createElement(Aa, {
    dismissPopup: function dismissPopup() {
      return b(!0);
    }
  }))), o && pe.createElement(Ca, {
    setCalendarModalOpen: i,
    CalendarModalOpen: o
  }));
},
    Ia = function Ia(e) {
  var t = e.isPublicDesignSystem,
      n = void 0 !== t && t,
      r = e.designSystemTitle,
      a = be(g),
      o = a.renderLocalLink,
      i = a.editorPath,
      l = a.playgroundPath,
      c = a.appSettingsPath,
      s = a.appId;
  if (n) return ge.createElement(Sa, {
    designSystemTitle: r
  });
  var d = Qr(s).data,
      u = null == d ? void 0 : d.user;
  return ge.createElement(Sa, {
    renderMenu: function renderMenu() {
      var e = function e(_e2) {
        var t = _e2.href,
            n = _e2.children;
        return o({
          href: t,
          children: n,
          className: "px-4 py-2 border-b-4 uppercase text-sm tracking-wide border-transparent text-gray-700",
          activeClassName: "px-4 py-2 border-b-4 uppercase text-sm tracking-wide border-pink-500 text-gray-900 font-semibold",
          isAdmin: !0
        });
      };

      return ge.createElement("div", {
        className: "flex flex-row items-center"
      }, ge.createElement("div", {
        className: "hidden px-4 py-2 border-b-4 uppercase text-sm tracking-wide border-transparent  text-gray-900 font-semibold"
      }), ge.createElement(e, {
        href: i
      }, "Editor"), ge.createElement(e, {
        href: l
      }, "Playground"), ge.createElement(e, {
        href: c
      }, (null == u ? void 0 : u.isAdmin) ? "Settings" : "Deploy"));
    }
  });
},
    La = function La() {
  var e = be(g),
      t = e.navigate,
      n = e.loginPath;
  return he(function () {
    var e = function (e, t) {
      at.defaults.baseURL = _;
      var n = V("t") || "";
      n && n.length > 10 && localStorage.setItem(j, n);
      var r = localStorage.getItem(j) || "";
      return {
        requestInterceptor: at.interceptors.request.use(function (e) {
          var t = {},
              a = n || r;
          return a && (t = {
            Authorization: "Bearer ".concat(a)
          }), c(c({}, e), {
            headers: c(c({}, e.headers), t)
          });
        }, function (e) {
          return Promise.reject(e);
        }),
        responseInterceptor: at.interceptors.response.use(function (e) {
          return e;
        }, function (n) {
          return n.response ? (401 === n.response.status ? ($.clear(), localStorage.removeItem(j), "/admin/session" === n.response.config.url && "post" === n.response.config.method || (ot.warn("Session expired"), e(t))) : 423 === n.response.status && ot.warn("Operation not allowed on this demo"), Promise.reject(n.response)) : (ot.error("An error occurred while communicating with the server", {
            hideAfter: 5
          }), Promise.reject(n.response));
        })
      };
    }(t, n),
        r = e.requestInterceptor,
        a = e.responseInterceptor;

    return function () {
      at.interceptors.request.eject(r), at.interceptors.response.eject(a);
    };
  }, [t]), null;
},
    za = function za(e) {
  var t = e.isLogin,
      n = void 0 !== t && t,
      r = be(g),
      a = r.navigate,
      o = r.loginPath,
      i = r.editorPath,
      l = r.appId,
      c = Qr(l, !0),
      s = c.data,
      d = c.isError,
      u = null == s ? void 0 : s.user,
      m = be(ln).setCurrentPage;
  return he(function () {
    var e = localStorage.getItem(j),
        t = V("t");
    e || t || n || a(o);
  }, []), he(function () {
    if (d && (n || a(o)), u) {
      var e = V("p"),
          t = V("l"),
          r = localStorage && localStorage.getItem("rb_p"),
          l = localStorage && localStorage.getItem("rb_l");
      e ? (m({
        pageId: e,
        language: t || ""
      }), a(i)) : r && m({
        pageId: r,
        language: l || ""
      }), n && a(i);
    }
  }, [u, d]), null;
};

!function (e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;

  if (e && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
        a = document.createElement("style");
    a.type = "text/css", "top" === n && r.firstChild ? r.insertBefore(a, r.firstChild) : r.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e));
  }
}('.tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{background-color:#333;border-radius:4px;color:#fff;font-size:14px;line-height:1.4;outline:0;position:relative;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{border-top-color:initial;border-width:8px 8px 0;bottom:-7px;left:0;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:initial;border-width:0 8px 8px;left:0;top:-7px;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-left-color:initial;border-width:8px 0 8px 8px;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{border-right-color:initial;border-width:8px 8px 8px 0;left:-7px;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{color:#333;height:16px;width:16px}.tippy-arrow:before{border-color:transparent;border-style:solid;content:"";position:absolute}.tippy-content{padding:5px 9px;position:relative;z-index:1}');

var Ba = function Ba(t) {
  var n = t.isLogin,
      r = void 0 !== n && n,
      a = t.isPublicDesignSystem,
      o = void 0 !== a && a,
      i = t.designSystemTitle,
      l = void 0 === i ? "Bricks documentation" : i,
      c = t.children,
      s = e(ye({
    pageId: ""
  }), 2),
      d = s[0],
      u = s[1],
      m = e(ye(!1), 2),
      p = m[0],
      f = m[1],
      b = e(ye(!1), 2),
      h = b[0],
      x = b[1],
      v = e(ye(!1), 2),
      y = v[0],
      w = v[1],
      k = be(g).appRootElement;
  he(function () {
    w(!0), localStorage.removeItem("react-bricks-token"), k && et.setAppElement(k), k || console.error("You should provide the appRootElement prop on Reactbricks, with a string selector or HTML element corresponding to the root element of the React application.");
  }, []), he(function () {
    localStorage && (null == d ? void 0 : d.pageId) && !d.pageId.startsWith("playground") && (localStorage.setItem("rb_p", d.pageId), localStorage.setItem("rb_l", d.language || ""));
  }, [d]);
  return pe.createElement(va, {
    id: "rb-admin-frame",
    style: {
      width: "100%",
      height: "100vh",
      border: "none"
    },
    head: pe.createElement("style", {
      dangerouslySetInnerHTML: {
        __html: "@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n/*! tailwindcss v3.0.13 | MIT License | https://tailwindcss.com*/*,:after,:before{border:0 solid #e5e7eb;box-sizing:border-box}:after,:before{--tw-content:\"\"}html{-webkit-text-size-adjust:100%;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;line-height:1.5;-moz-tab-size:4;-o-tab-size:4;tab-size:4}body{line-height:inherit;margin:0}hr{border-top-width:1px;color:inherit;height:0}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,pre,samp{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{border-collapse:collapse;border-color:inherit;text-indent:0}button,input,optgroup,select,textarea{color:inherit;font-family:inherit;font-size:100%;line-height:inherit;margin:0;padding:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dd,dl,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset{margin:0}fieldset,legend{padding:0}menu,ol,ul{list-style:none;margin:0;padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{color:#9ca3af;opacity:1}input:-ms-input-placeholder,textarea:-ms-input-placeholder{color:#9ca3af;opacity:1}input::placeholder,textarea::placeholder{color:#9ca3af;opacity:1}[role=button],button{cursor:pointer}:disabled{cursor:default}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}img,video{height:auto;max-width:100%}[hidden]{display:none}[multiple],[type=date],[type=datetime-local],[type=email],[type=month],[type=number],[type=password],[type=search],[type=tel],[type=text],[type=time],[type=url],[type=week],select,textarea{--tw-shadow:0 0 #0000;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;border-color:#6b7280;border-radius:0;border-width:1px;font-size:1rem;line-height:1.5rem;padding:.5rem .75rem}[multiple]:focus,[type=date]:focus,[type=datetime-local]:focus,[type=email]:focus,[type=month]:focus,[type=number]:focus,[type=password]:focus,[type=search]:focus,[type=tel]:focus,[type=text]:focus,[type=time]:focus,[type=url]:focus,[type=week]:focus,select:focus,textarea:focus{--tw-ring-inset:var(--tw-empty,/*!*/ /*!*/);--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#2563eb;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);border-color:#2563eb;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow);outline:2px solid transparent;outline-offset:2px}input::-moz-placeholder,textarea::-moz-placeholder{color:#6b7280;opacity:1}input:-ms-input-placeholder,textarea:-ms-input-placeholder{color:#6b7280;opacity:1}input::placeholder,textarea::placeholder{color:#6b7280;opacity:1}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-date-and-time-value{min-height:1.5em}select{-webkit-print-color-adjust:exact;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3E%3C/svg%3E\");background-position:right .5rem center;background-repeat:no-repeat;background-size:1.5em 1.5em;color-adjust:exact;padding-right:2.5rem}[multiple]{-webkit-print-color-adjust:unset;background-image:none;background-position:0 0;background-repeat:unset;background-size:initial;color-adjust:unset;padding-right:.75rem}[type=checkbox],[type=radio]{-webkit-print-color-adjust:exact;--tw-shadow:0 0 #0000;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;background-origin:border-box;border-color:#6b7280;border-width:1px;color:#2563eb;color-adjust:exact;display:inline-block;flex-shrink:0;height:1rem;padding:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:middle;width:1rem}[type=checkbox]{border-radius:0}[type=radio]{border-radius:100%}[type=checkbox]:focus,[type=radio]:focus{--tw-ring-inset:var(--tw-empty,/*!*/ /*!*/);--tw-ring-offset-width:2px;--tw-ring-offset-color:#fff;--tw-ring-color:#2563eb;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow);outline:2px solid transparent;outline-offset:2px}[type=checkbox]:checked,[type=radio]:checked{background-color:currentColor;background-position:50%;background-repeat:no-repeat;background-size:100% 100%;border-color:transparent}[type=checkbox]:checked{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 16 16' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.207 4.793a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L6.5 9.086l4.293-4.293a1 1 0 0 1 1.414 0z'/%3E%3C/svg%3E\")}[type=radio]:checked{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 16 16' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='3'/%3E%3C/svg%3E\")}[type=checkbox]:checked:focus,[type=checkbox]:checked:hover,[type=radio]:checked:focus,[type=radio]:checked:hover{background-color:currentColor;border-color:transparent}[type=checkbox]:indeterminate{background-color:currentColor;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3E%3Cpath stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8h8'/%3E%3C/svg%3E\");background-position:50%;background-repeat:no-repeat;background-size:100% 100%;border-color:transparent}[type=checkbox]:indeterminate:focus,[type=checkbox]:indeterminate:hover{background-color:currentColor;border-color:transparent}[type=file]{background:unset;border-color:inherit;border-radius:0;border-width:0;font-size:unset;line-height:inherit;padding:0}[type=file]:focus{outline:1px auto -webkit-focus-ring-color}*,:after,:before{--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246/0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.container{width:100%}@media (min-width:640px){.container{max-width:640px}}@media (min-width:768px){.container{max-width:768px}}@media (min-width:1024px){.container{max-width:1024px}}@media (min-width:1280px){.container{max-width:1280px}}@media (min-width:1536px){.container{max-width:1536px}}.static{position:static}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.inset-x-0{left:0;right:0}.top-0{top:0}.bottom-0{bottom:0}.left-0{left:0}.z-50{z-index:50}.z-20{z-index:20}.z-10{z-index:10}.mx-auto{margin-left:auto;margin-right:auto}.mx-1{margin-left:.25rem;margin-right:.25rem}.my-3{margin-bottom:.75rem;margin-top:.75rem}.mb-2{margin-bottom:.5rem}.mb-3{margin-bottom:.75rem}.mr-2{margin-right:.5rem}.mb-8{margin-bottom:2rem}.mt-4{margin-top:1rem}.mt-8{margin-top:2rem}.mt-20{margin-top:5rem}.mb-6{margin-bottom:1.5rem}.mt-6{margin-top:1.5rem}.mb-4{margin-bottom:1rem}.-mt-px{margin-top:-1px}.mr-1{margin-right:.25rem}.ml-1{margin-left:.25rem}.ml-2{margin-left:.5rem}.mt-1{margin-top:.25rem}.ml-4{margin-left:1rem}.mb-1{margin-bottom:.25rem}.mb-5{margin-bottom:1.25rem}.mt-2{margin-top:.5rem}.mb-0\\.5{margin-bottom:.125rem}.mb-0{margin-bottom:0}.block{display:block}.\\!block{display:block!important}.inline-block{display:inline-block}.flex{display:flex}.hidden{display:none}.h-10{height:2.5rem}.h-6{height:1.5rem}.h-8{height:2rem}.h-screen{height:100vh}.h-full{height:100%}.h-4{height:1rem}.h-40{height:10rem}.h-24{height:6rem}.w-full{width:100%}.w-8{width:2rem}.w-3\\/4{width:75%}.w-48{width:12rem}.w-4{width:1rem}.w-24{width:6rem}.w-40{width:10rem}.w-0{width:0}.w-56{width:14rem}.min-w-0{min-width:0}.max-w-3xl{max-width:48rem}.max-w-xl{max-width:36rem}.flex-1{flex:1 1 0%}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.cursor-pointer{cursor:pointer}.cursor-not-allowed{cursor:not-allowed}.resize{resize:both}.list-decimal{list-style-type:decimal}.list-disc{list-style-type:disc}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.items-center{align-items:center}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.justify-around{justify-content:space-around}.space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(1rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(1rem*var(--tw-space-x-reverse))}.space-x-3>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(.75rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(.75rem*var(--tw-space-x-reverse))}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-y-auto{overflow-y:auto}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.rounded{border-radius:.25rem}.rounded-full{border-radius:9999px}.rounded-sm{border-radius:.125rem}.rounded-md{border-radius:.375rem}.rounded-r-lg{border-bottom-right-radius:.5rem;border-top-right-radius:.5rem}.border{border-width:1px}.border-2{border-width:2px}.border-b-4{border-bottom-width:4px}.border-t{border-top-width:1px}.border-b{border-bottom-width:1px}.border-transparent{border-color:transparent}.border-pink-500{--tw-border-opacity:1;border-color:rgb(246 90 142/var(--tw-border-opacity))}.border-pink-400{--tw-border-opacity:1;border-color:rgb(251 131 163/var(--tw-border-opacity))}.border-gray-300{--tw-border-opacity:1;border-color:rgb(209 213 219/var(--tw-border-opacity))}.border-gray-500{--tw-border-opacity:1;border-color:rgb(107 114 128/var(--tw-border-opacity))}.border-gray-200{--tw-border-opacity:1;border-color:rgb(229 231 235/var(--tw-border-opacity))}.border-red-400{--tw-border-opacity:1;border-color:rgb(248 113 113/var(--tw-border-opacity))}.border-red-500{--tw-border-opacity:1;border-color:rgb(239 68 68/var(--tw-border-opacity))}.bg-white{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.bg-blue-500{--tw-bg-opacity:1;background-color:rgb(59 130 246/var(--tw-bg-opacity))}.bg-gray-100{--tw-bg-opacity:1;background-color:rgb(243 244 246/var(--tw-bg-opacity))}.bg-pink-500{--tw-bg-opacity:1;background-color:rgb(246 90 142/var(--tw-bg-opacity))}.bg-gray-200{--tw-bg-opacity:1;background-color:rgb(229 231 235/var(--tw-bg-opacity))}.bg-green-200{--tw-bg-opacity:1;background-color:rgb(187 247 208/var(--tw-bg-opacity))}.bg-gray-300{--tw-bg-opacity:1;background-color:rgb(209 213 219/var(--tw-bg-opacity))}.bg-pink-200{--tw-bg-opacity:1;background-color:rgb(255 214 224/var(--tw-bg-opacity))}.bg-gray-500{--tw-bg-opacity:1;background-color:rgb(107 114 128/var(--tw-bg-opacity))}.bg-blue-200{--tw-bg-opacity:1;background-color:rgb(191 219 254/var(--tw-bg-opacity))}.bg-pink-100{--tw-bg-opacity:1;background-color:rgb(255 245 247/var(--tw-bg-opacity))}.bg-opacity-75{--tw-bg-opacity:0.75}.object-cover{-o-object-fit:cover;object-fit:cover}.p-4{padding:1rem}.p-3{padding:.75rem}.p-2{padding:.5rem}.px-4{padding-left:1rem;padding-right:1rem}.py-2{padding-bottom:.5rem;padding-top:.5rem}.px-6{padding-left:1.5rem;padding-right:1.5rem}.py-16{padding-bottom:4rem;padding-top:4rem}.px-20{padding-left:5rem;padding-right:5rem}.py-px{padding-bottom:1px;padding-top:1px}.px-2{padding-left:.5rem;padding-right:.5rem}.py-3{padding-bottom:.75rem;padding-top:.75rem}.py-6{padding-bottom:1.5rem;padding-top:1.5rem}.py-1{padding-bottom:.25rem;padding-top:.25rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-1{padding-left:.25rem;padding-right:.25rem}.px-5{padding-left:1.25rem;padding-right:1.25rem}.pt-10{padding-top:2.5rem}.pt-2{padding-top:.5rem}.pb-1{padding-bottom:.25rem}.pb-12{padding-bottom:3rem}.pr-5{padding-right:1.25rem}.pl-3{padding-left:.75rem}.pl-2{padding-left:.5rem}.pl-8{padding-left:2rem}.pt-12{padding-top:3rem}.pb-24{padding-bottom:6rem}.pb-4{padding-bottom:1rem}.pt-3{padding-top:.75rem}.pb-2{padding-bottom:.5rem}.text-center{text-align:center}.align-middle{vertical-align:middle}.font-admin{font-family:Inter,sans-serif}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xs{font-size:.75rem;line-height:1rem}.text-4xl{font-size:2.25rem;line-height:2.5rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-base{font-size:1rem;line-height:1.5rem}.font-semibold{font-weight:600}.font-thin{font-weight:100}.font-bold{font-weight:700}.uppercase{text-transform:uppercase}.capitalize{text-transform:capitalize}.italic{font-style:italic}.leading-none{line-height:1}.leading-6{line-height:1.5rem}.leading-tight{line-height:1.25}.tracking-wide{letter-spacing:.025em}.tracking-widest{letter-spacing:.1em}.tracking-wider{letter-spacing:.05em}.text-gray-700{--tw-text-opacity:1;color:rgb(55 65 81/var(--tw-text-opacity))}.text-gray-900{--tw-text-opacity:1;color:rgb(17 24 39/var(--tw-text-opacity))}.text-pink-700{--tw-text-opacity:1;color:rgb(180 49 121/var(--tw-text-opacity))}.text-gray-500{--tw-text-opacity:1;color:rgb(107 114 128/var(--tw-text-opacity))}.text-white{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.text-gray-600{--tw-text-opacity:1;color:rgb(75 85 99/var(--tw-text-opacity))}.text-red-500{--tw-text-opacity:1;color:rgb(239 68 68/var(--tw-text-opacity))}.text-pink-500{--tw-text-opacity:1;color:rgb(246 90 142/var(--tw-text-opacity))}.text-green-800{--tw-text-opacity:1;color:rgb(22 101 52/var(--tw-text-opacity))}.text-green-500{--tw-text-opacity:1;color:rgb(34 197 94/var(--tw-text-opacity))}.text-gray-400{--tw-text-opacity:1;color:rgb(156 163 175/var(--tw-text-opacity))}.text-black{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity))}.text-pink-400{--tw-text-opacity:1;color:rgb(251 131 163/var(--tw-text-opacity))}.text-blue-500{--tw-text-opacity:1;color:rgb(59 130 246/var(--tw-text-opacity))}.text-pink-300{--tw-text-opacity:1;color:rgb(253 180 198/var(--tw-text-opacity))}.text-blue-600{--tw-text-opacity:1;color:rgb(37 99 235/var(--tw-text-opacity))}.text-red-700{--tw-text-opacity:1;color:rgb(185 28 28/var(--tw-text-opacity))}.text-blue-800{--tw-text-opacity:1;color:rgb(30 64 175/var(--tw-text-opacity))}.text-red-600{--tw-text-opacity:1;color:rgb(220 38 38/var(--tw-text-opacity))}.no-underline{-webkit-text-decoration-line:none;text-decoration-line:none}.antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.opacity-0{opacity:0}.opacity-75{opacity:.75}.shadow-lg{--tw-shadow:0 10px 15px -3px rgb(0 0 0/0.1),0 4px 6px -4px rgb(0 0 0/0.1);--tw-shadow-colored:0 10px 15px -3px var(--tw-shadow-color),0 4px 6px -4px var(--tw-shadow-color)}.shadow,.shadow-lg{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.shadow{--tw-shadow:0 1px 3px 0 rgb(0 0 0/0.1),0 1px 2px -1px rgb(0 0 0/0.1);--tw-shadow-colored:0 1px 3px 0 var(--tw-shadow-color),0 1px 2px -1px var(--tw-shadow-color)}.shadow-inner{--tw-shadow:inset 0 2px 4px 0 rgb(0 0 0/0.05);--tw-shadow-colored:inset 0 2px 4px 0 var(--tw-shadow-color)}.shadow-inner,.shadow-md{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.shadow-md{--tw-shadow:0 4px 6px -1px rgb(0 0 0/0.1),0 2px 4px -2px rgb(0 0 0/0.1);--tw-shadow-colored:0 4px 6px -1px var(--tw-shadow-color),0 2px 4px -2px var(--tw-shadow-color)}.outline{outline-style:solid}.blur{--tw-blur:blur(8px)}.blur,.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition-all{transition-duration:.15s;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition{transition-duration:.15s;transition-property:color,background-color,border-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-text-decoration-color,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-text-decoration-color,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-colors{transition-duration:.15s;transition-property:color,background-color,border-color,fill,stroke,-webkit-text-decoration-color;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,-webkit-text-decoration-color;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-opacity{transition-duration:.15s;transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-transform{transition-property:transform;transition-timing-function:cubic-bezier(.4,0,.2,1)}.duration-150,.transition-transform{transition-duration:.15s}.duration-200{transition-duration:.2s}.duration-300{transition-duration:.3s}.duration-1000{transition-duration:1s}body{background-color:#f3f4f6}.hover\\:scale-125:hover{--tw-scale-x:1.25;--tw-scale-y:1.25}.hover\\:scale-125:hover,.hover\\:transform:hover{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.hover\\:border-pink-400:hover{--tw-border-opacity:1;border-color:rgb(251 131 163/var(--tw-border-opacity))}.hover\\:border-gray-300:hover{--tw-border-opacity:1;border-color:rgb(209 213 219/var(--tw-border-opacity))}.hover\\:border-pink-600:hover{--tw-border-opacity:1;border-color:rgb(217 54 127/var(--tw-border-opacity))}.hover\\:bg-blue-600:hover{--tw-bg-opacity:1;background-color:rgb(37 99 235/var(--tw-bg-opacity))}.hover\\:bg-gray-200:hover{--tw-bg-opacity:1;background-color:rgb(229 231 235/var(--tw-bg-opacity))}.hover\\:bg-pink-700:hover{--tw-bg-opacity:1;background-color:rgb(180 49 121/var(--tw-bg-opacity))}.hover\\:bg-pink-600:hover{--tw-bg-opacity:1;background-color:rgb(217 54 127/var(--tw-bg-opacity))}.hover\\:bg-pink-100:hover{--tw-bg-opacity:1;background-color:rgb(255 245 247/var(--tw-bg-opacity))}.hover\\:bg-white:hover{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.hover\\:text-gray-700:hover{--tw-text-opacity:1;color:rgb(55 65 81/var(--tw-text-opacity))}.hover\\:text-gray-900:hover{--tw-text-opacity:1;color:rgb(17 24 39/var(--tw-text-opacity))}.hover\\:text-black:hover{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity))}.hover\\:text-green-600:hover{--tw-text-opacity:1;color:rgb(22 163 74/var(--tw-text-opacity))}.hover\\:text-red-500:hover{--tw-text-opacity:1;color:rgb(239 68 68/var(--tw-text-opacity))}.hover\\:text-pink-600:hover{--tw-text-opacity:1;color:rgb(217 54 127/var(--tw-text-opacity))}.hover\\:text-gray-800:hover{--tw-text-opacity:1;color:rgb(31 41 55/var(--tw-text-opacity))}.hover\\:text-blue-700:hover{--tw-text-opacity:1;color:rgb(29 78 216/var(--tw-text-opacity))}.hover\\:text-red-800:hover{--tw-text-opacity:1;color:rgb(153 27 27/var(--tw-text-opacity))}.hover\\:underline:hover{-webkit-text-decoration-line:underline;text-decoration-line:underline}.hover\\:opacity-100:hover{opacity:1}.hover\\:shadow-lg:hover{--tw-shadow:0 10px 15px -3px rgb(0 0 0/0.1),0 4px 6px -4px rgb(0 0 0/0.1);--tw-shadow-colored:0 10px 15px -3px var(--tw-shadow-color),0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.focus\\:border-blue-300:focus{--tw-border-opacity:1;border-color:rgb(147 197 253/var(--tw-border-opacity))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:ring:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 #0000)}.focus\\:ring-blue-200:focus{--tw-ring-opacity:1;--tw-ring-color:rgb(191 219 254/var(--tw-ring-opacity))}.focus\\:ring-opacity-50:focus{--tw-ring-opacity:0.5}.focus\\:ring-offset-0:focus{--tw-ring-offset-width:0px}.disabled\\:cursor-not-allowed:disabled{cursor:not-allowed}.disabled\\:opacity-75:disabled{opacity:.75}@media (min-width:640px){.sm\\:mx-0{margin-left:0;margin-right:0}.sm\\:w-3\\/4{width:75%}.sm\\:px-0{padding-left:0;padding-right:0}}@media (min-width:768px){.md\\:block{display:block}.md\\:w-1\\/2{width:50%}}@media (min-width:1024px){.lg\\:w-1\\/2{width:50%}}\n\n.react-tags {\n  position: relative;\n  padding: 6px 0 0 6px;\n  border: 1px solid #d1d5db;\n  border-radius: .375rem;\n  background-color: #fff;\n\n  /* shared font styles */\n  font-size: 1em;\n  line-height: 1.2;\n\n  /* clicking anywhere will focus the input */\n  cursor: text;\n}\n\n.react-tags.is-focused {\n  border-color: #a0aec0;\n}\n\n.react-tags__selected {\n  display: inline;\n}\n\n.react-tags__selected-tag {\n  display: inline-block;\n  box-sizing: border-box;\n  margin: 0 6px 6px 0;\n  padding: 4px 8px;\n  border: 1px solid #e6e7eb;\n  border-radius: 4px;\n  background: #f9fafb;\n\n  /* match the font styles */\n  font-size: 14px;\n  line-height: inherit;\n}\n\n.react-tags__selected-tag:after {\n  font-size: 10px;\n  content: '\\2715';\n  color: #9ca3af;\n  margin-left: 8px;\n}\n\n.react-tags__selected-tag:hover,\n.react-tags__selected-tag:focus {\n  border-color: #a0aec0;\n}\n\n.react-tags__selected-tag:hover:after,\n.react-tags__selected-tag:focus:after {\n  color: #dc2627;\n}\n\n.react-tags__search {\n  display: inline-block;\n\n  /* match tag layout */\n  padding: 7px 2px;\n  margin-bottom: 6px;\n\n  /* prevent autoresize overflowing the container */\n  max-width: 100%;\n}\n\n@media screen and (min-width: 30em) {\n\n  .react-tags__search {\n    /* this will become the offsetParent for suggestions */\n    position: relative;\n  }\n\n}\n\n.react-tags__search-input {\n  /* prevent autoresize overflowing the container */\n  max-width: 100%;\n\n  /* remove styles and layout from this element */\n  margin: 0;\n  padding: 0;\n  border: 0;\n  outline: none;\n\n  /* match the font styles */\n  font-size: inherit;\n  line-height: inherit;\n}\n\n.react-tags__search-input::-ms-clear {\n  display: none;\n}\n\n.react-tags__suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n\n@media screen and (min-width: 30em) {\n\n  .react-tags__suggestions {\n    width: 240px;\n  }\n\n}\n\n.react-tags__suggestions ul {\n  margin: 4px -1px;\n  padding: 0;\n  list-style: none;\n  background: white;\n  border: 1px solid #D1D1D1;\n  border-radius: 2px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.react-tags__suggestions li {\n  border-bottom: 1px solid #ddd;\n  padding: 6px 8px;\n}\n\n.react-tags__suggestions li mark {\n  text-decoration: underline;\n  background: none;\n  font-weight: 600;\n}\n\n.react-tags__suggestions li:hover {\n  cursor: pointer;\n  background: #eee;\n}\n\n.react-tags__suggestions li.is-active {\n  background: #b7cfe0;\n}\n\n.react-tags__suggestions li.is-disabled {\n  opacity: 0.5;\n  cursor: auto;\n}\n\n.ct-toast {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif;\n}\n\n.rc-switch {\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  width: 44px;\n  height: 22px;\n  line-height: 20px;\n  padding: 0;\n  vertical-align: middle;\n  border-radius: 20px 20px;\n  border: 1px solid #ccc;\n  background-color: #ccc;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n}\n.rc-switch-inner {\n  color: #fff;\n  font-size: 12px;\n  position: absolute;\n  left: 24px;\n  top: 0;\n}\n.rc-switch:after {\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  left: 2px;\n  top: 1px;\n  border-radius: 50% 50%;\n  background-color: #fff;\n  content: \" \";\n  cursor: pointer;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);\n  transform: scale(1);\n  transition: left 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  animation-timing-function: cubic-bezier(0.35, 0, 0.25, 1);\n  animation-duration: 0.3s;\n  animation-name: rcSwitchOff;\n}\n.rc-switch:hover:after {\n  transform: scale(1.1);\n  animation-name: rcSwitchOn;\n}\n.rc-switch:focus {\n  box-shadow: 0 0 0 2px #d5f1fd;\n  outline: none;\n}\n.rc-switch-checked {\n  border: 1px solid #87d068;\n  background-color: #87d068;\n}\n.rc-switch-checked .rc-switch-inner {\n  left: 6px;\n}\n.rc-switch-checked:after {\n  left: 22px;\n}\n.rc-switch-disabled {\n  cursor: no-drop;\n  background: #ccc;\n  border-color: #ccc;\n}\n.rc-switch-disabled:after {\n  background: #9e9e9e;\n  animation-name: none;\n  cursor: no-drop;\n}\n.rc-switch-disabled:hover:after {\n  transform: scale(1);\n  animation-name: none;\n}\n.rc-switch-label {\n  display: inline-block;\n  line-height: 20px;\n  font-size: 14px;\n  padding-left: 10px;\n  vertical-align: middle;\n  white-space: normal;\n  pointer-events: none;\n  user-select: text;\n}\n@keyframes rcSwitchOn {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.25);\n  }\n  100% {\n    transform: scale(1.1);\n  }\n}\n@keyframes rcSwitchOff {\n  0% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.ReactCrop{position:relative;display:inline-block;cursor:crosshair;overflow:hidden;max-width:100%}.ReactCrop:focus{outline:none}.ReactCrop--disabled,.ReactCrop--locked{cursor:inherit}.ReactCrop__image{display:block;max-width:100%;touch-action:none}.ReactCrop__crop-selection{position:absolute;top:0;left:0;transform:translate3d(0, 0, 0);box-sizing:border-box;cursor:move;box-shadow:0 0 0 9999em rgba(0,0,0,.5);touch-action:none;border:1px solid;border-image-source:url(data:image/gif;base64,R0lGODlhCgAKAJECAAAAAP///////wAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEI5RDc5MTFDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEI5RDc5MTBDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBQoAAgAsAAAAAAoACgAAAhWEERkn7W3ei7KlagMWF/dKgYeyGAUAIfkEBQoAAgAsAAAAAAoACgAAAg+UYwLJ7RnQm7QmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYgLJHdiinNSAVfOEKoUCACH5BAUKAAIALAAAAAAKAAoAAAIRVISAdusPo3RAzYtjaMIaUQAAIfkEBQoAAgAsAAAAAAoACgAAAg+MDiem7Q8bSLFaG5il6xQAIfkEBQoAAgAsAAAAAAoACgAAAg+UYRLJ7QnQm7SmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYBLJDdiinNSEVfOEKoECACH5BAUKAAIALAAAAAAKAAoAAAIRFISBdusPo3RBzYsjaMIaUQAAOw==);border-image-slice:1;border-image-repeat:repeat}.ReactCrop--disabled .ReactCrop__crop-selection{cursor:inherit}.ReactCrop--circular-crop .ReactCrop__crop-selection{border-radius:50%;box-shadow:0px 0px 1px 1px #fff,0 0 0 9999em rgba(0,0,0,.5)}.ReactCrop--invisible-crop .ReactCrop__crop-selection{display:none}.ReactCrop__rule-of-thirds-vt::before,.ReactCrop__rule-of-thirds-vt::after,.ReactCrop__rule-of-thirds-hz::before,.ReactCrop__rule-of-thirds-hz::after{content:\"\";display:block;position:absolute;background-color:rgba(255,255,255,.4)}.ReactCrop__rule-of-thirds-vt::before,.ReactCrop__rule-of-thirds-vt::after{width:1px;height:100%}.ReactCrop__rule-of-thirds-vt::before{left:33.3333%;left:calc(100% / 3)}.ReactCrop__rule-of-thirds-vt::after{left:66.6666%;left:calc(100% / 3 * 2)}.ReactCrop__rule-of-thirds-hz::before,.ReactCrop__rule-of-thirds-hz::after{width:100%;height:1px}.ReactCrop__rule-of-thirds-hz::before{top:33.3333%;top:calc(100% / 3)}.ReactCrop__rule-of-thirds-hz::after{top:66.6666%;top:calc(100% / 3 * 2)}.ReactCrop__drag-handle{position:absolute}.ReactCrop__drag-handle::after{position:absolute;content:\"\";display:block;width:10px;height:10px;background-color:rgba(0,0,0,.2);border:1px solid rgba(255,255,255,.7);box-sizing:border-box;outline:1px solid transparent}.ReactCrop .ord-nw{top:0;left:0;margin-top:-5px;margin-left:-5px;cursor:nw-resize}.ReactCrop .ord-nw::after{top:0;left:0}.ReactCrop .ord-n{top:0;left:50%;margin-top:-5px;margin-left:-5px;cursor:n-resize}.ReactCrop .ord-n::after{top:0}.ReactCrop .ord-ne{top:0;right:0;margin-top:-5px;margin-right:-5px;cursor:ne-resize}.ReactCrop .ord-ne::after{top:0;right:0}.ReactCrop .ord-e{top:50%;right:0;margin-top:-5px;margin-right:-5px;cursor:e-resize}.ReactCrop .ord-e::after{right:0}.ReactCrop .ord-se{bottom:0;right:0;margin-bottom:-5px;margin-right:-5px;cursor:se-resize}.ReactCrop .ord-se::after{bottom:0;right:0}.ReactCrop .ord-s{bottom:0;left:50%;margin-bottom:-5px;margin-left:-5px;cursor:s-resize}.ReactCrop .ord-s::after{bottom:0}.ReactCrop .ord-sw{bottom:0;left:0;margin-bottom:-5px;margin-left:-5px;cursor:sw-resize}.ReactCrop .ord-sw::after{bottom:0;left:0}.ReactCrop .ord-w{top:50%;left:0;margin-top:-5px;margin-left:-5px;cursor:w-resize}.ReactCrop .ord-w::after{left:0}.ReactCrop__disabled .ReactCrop__drag-handle{cursor:inherit}.ReactCrop__drag-bar{position:absolute}.ReactCrop__drag-bar.ord-n{top:0;left:0;width:100%;height:6px;margin-top:-3px}.ReactCrop__drag-bar.ord-e{right:0;top:0;width:6px;height:100%;margin-right:-3px}.ReactCrop__drag-bar.ord-s{bottom:0;left:0;width:100%;height:6px;margin-bottom:-3px}.ReactCrop__drag-bar.ord-w{top:0;left:0;width:6px;height:100%;margin-left:-3px}.ReactCrop--new-crop .ReactCrop__drag-bar,.ReactCrop--new-crop .ReactCrop__drag-handle,.ReactCrop--fixed-aspect .ReactCrop__drag-bar{display:none}.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n,.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e,.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s,.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w{display:none}@media(pointer: coarse){.ReactCrop .ord-n,.ReactCrop .ord-e,.ReactCrop .ord-s,.ReactCrop .ord-w{display:none}.ReactCrop__drag-handle{width:24px;height:24px}}\n\n</style>"
      }
    }),
    key: y ? "client" : "server"
  }, pe.createElement(La, null), pe.createElement(ln.Provider, {
    value: {
      isAdmin: !0,
      currentPage: d,
      setCurrentPage: u,
      previewMode: p,
      setPreviewMode: f,
      sidebarCollapsed: h,
      setSidebarCollapsed: x,
      getStyles: function getStyles() {
        return document.querySelectorAll("style");
      },
      getStylesheets: function getStylesheets() {
        return document.querySelectorAll("link[rel=stylesheet]");
      }
    }
  }, pe.createElement("div", {
    className: "font-admin antialiased"
  }, !o && pe.createElement(za, {
    isLogin: r
  }), !r && pe.createElement(Ia, {
    isPublicDesignSystem: o,
    designSystemTitle: l
  }), c)));
},
    Pa = function Pa() {
  var t = e(ye(""), 2),
      n = t[0],
      r = t[1],
      a = e(ye(""), 2),
      o = a[0],
      i = a[1],
      l = e(ye(!1), 2),
      c = l[0],
      s = l[1],
      d = e(ye(!1), 2),
      u = d[0],
      m = d[1],
      p = Na().loginUser;
  return pe.createElement("div", {
    className: "flex flex-col h-screen justify-center items-center px-4 sm:px-0"
  }, pe.createElement("div", {
    className: "flex bg-white rounded shadow-lg w-full sm:w-3/4 lg:w-1/2 sm:mx-0",
    style: {
      height: 500
    }
  }, pe.createElement("div", {
    className: "flex flex-col w-full md:w-1/2 p-4"
  }, pe.createElement("div", {
    className: "flex flex-col flex-1 justify-center mb-8"
  }, pe.createElement("h1", {
    className: "text-4xl text-center font-thin"
  }, "Welcome"), pe.createElement("div", {
    className: "w-full mt-4"
  }, pe.createElement("form", {
    onSubmit: function onSubmit(e) {
      return b(void 0, void 0, void 0, function () {
        return E(this, function (t) {
          switch (t.label) {
            case 0:
              return e.preventDefault(), [4, p(n, o, c)];

            case 1:
              return t.sent() || m(!0), [2];
          }
        });
      });
    },
    className: "form-horizontal w-3/4 mx-auto"
  }, pe.createElement("div", {
    className: "mt-4"
  }, pe.createElement(Gn, {
    id: "email",
    name: "email",
    type: "email",
    value: n,
    onChange: function onChange(e) {
      return r(e.target.value);
    },
    placeholder: "Email"
  })), pe.createElement("div", {
    className: "mt-4"
  }, pe.createElement(Gn, {
    id: "password",
    name: "password",
    type: "password",
    value: o,
    onChange: function onChange(e) {
      return i(e.target.value);
    },
    required: !0,
    placeholder: "Password"
  })), pe.createElement("div", {
    className: "mt-4 flex items-center"
  }, pe.createElement(Gn, {
    id: "keepLoggedIn",
    name: "keepLoggedIn",
    type: "checkbox",
    checked: c,
    onChange: function onChange(e) {
      return s(e.target.checked);
    }
  }), pe.createElement("label", {
    htmlFor: "keepLoggedIn",
    className: "text-sm text-gray-700 flex items-center"
  }, pe.createElement("span", {
    className: "mr-2"
  }, "Keep me logged in"), pe.createElement(Te, {
    content: "If you access the admin regularly you will be kept logged in. After 15 days without any access, you will be logged out."
  }, pe.createElement("span", null, pe.createElement(Vt, {
    className: "text-gray-400"
  }))))), pe.createElement("div", {
    className: "mt-8"
  }, pe.createElement("button", {
    type: "submit",
    className: "block w-full bg-pink-500 hover:bg-pink-700 transition-colors text-white text-sm font-semibold py-2 px-4 rounded"
  }, "Login"), u && pe.createElement("div", {
    className: "text-red-500 mt-4 text-center"
  }, "Wrong username or password"))), pe.createElement("div", {
    className: "text-center mt-4"
  }, pe.createElement("a", {
    className: "no-underline hover:underline text-blue-dark text-xs",
    href: "https://dashboard.reactbricks.com/forgot-password",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Forgot Your Password?"))))), pe.createElement("div", {
    className: "hidden md:block md:w-1/2 rounded-r-lg",
    style: {
      backgroundImage: "url(https://images.unsplash.com/photo-1461418559055-6f020c5a91e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=1601&q=80)",
      backgroundSize: "cover",
      backgroundPosition: "center center"
    }
  })));
};

re.prototype.renderAdmin = function (e) {
  var t = e.renderBlock,
      r = e.placeholder,
      o = e.renderPlaceholder,
      l = e.propName,
      s = e.multiline,
      u = void 0 !== s && s,
      m = e.softLineBreak,
      p = void 0 !== m && m,
      g = Ie(Le(Ce()));
  u || (g = cn(g));
  var f = fe(function () {
    return g;
  }, []),
      b = be(ln),
      h = b.isAdmin,
      x = b.previewMode,
      v = be(n),
      y = v.values,
      w = v.onChange,
      k = be(a),
      E = k.triggerTextRefreshBlockId,
      C = k.setTriggerTextRefreshBlockId,
      A = x || !h,
      N = y[l];
  he(function () {
    setTimeout(function () {
      return C("");
    }, 1);
  }, [E]);
  var S = xe(function (e) {
    var n = e.children,
        r = e.element,
        a = e.attributes;
    return pe.cloneElement(t({
      children: n,
      element: r,
      attributes: a
    }), a);
  }, [y]),
      I = xe(function (e) {
    var t = e.children,
        n = e.attributes;
    if (!o) return null;
    n.style;
    var r = d(n, ["style"]);
    return pe.cloneElement(o({
      children: t
    }), r);
  }, [y]);

  if (A) {
    var L = N;
    return N ? ("string" == typeof N && (L = i.deserialize(N)), pe.createElement(pe.Fragment, null, L.map(function (e, n) {
      return pe.createElement(pe.Fragment, {
        key: n
      }, sn(e, [], t));
    }))) : null;
  }

  var z = N || mn;
  "string" == typeof z && (z = i.deserialize(z));
  var B = {};
  return o && (B = {
    renderPlaceholder: I
  }), pe.createElement(ze, {
    editor: f,
    value: z,
    onChange: function onChange(e) {
      y[l] !== e && w(l, e);
    }
  }, pe.createElement(Be, c({
    renderElement: S,
    placeholder: r,
    onKeyDown: function onKeyDown(e) {
      p && me("shift+enter", e) && (e.preventDefault(), f.insertText("\n"));
    }
  }, B)));
}, ae.prototype.renderAdmin = function (e) {
  var t = [];
  return e.allowedFeatures && e.allowedFeatures.length > 0 && (t = e.allowedFeatures.map(function (t) {
    var n = Jn[t],
        r = n.newPlugin,
        a = n.renderLeaf,
        o = n.renderElement,
        i = n.renderItemElement,
        l = n.renderLink,
        s = {},
        d = e[a],
        u = e[o],
        m = e[i],
        p = e[l];
    return a && d && (s.renderLeaf = d), o && u && (s.renderElement = u), i && m && (s.renderItemElement = m), l && p && (s.renderElement = function (e) {
      var t = e.attributes,
          n = e.children,
          r = e.element;
      return p({
        attributes: t,
        children: n,
        element: r,
        href: r.url
      });
    }), c(c({}, r), s);
  })), ge.createElement(fn, {
    renderBlock: e.renderBlock,
    placeholder: e.placeholder,
    propName: e.propName,
    plugins: t,
    multiline: e.multiline
  });
}, oe.prototype.renderAdmin = fn, ie.prototype.renderAdmin = function (e) {
  var t = be(ln),
      r = t.isAdmin,
      a = t.previewMode,
      o = be(n),
      i = o.values,
      l = o.onChange,
      s = a || !r,
      d = i[e.propName];
  return s ? pe.createElement(pr, c({}, e, {
    source: d
  })) : pe.createElement(dr, c({}, e, {
    source: d,
    onChange: function onChange(t) {
      l(e.propName, t);
    }
  }));
}, le.prototype.renderAdmin = function (e) {
  var t = e.propName,
      r = e.itemProps,
      o = void 0 === r ? {} : r,
      i = e.renderWrapper,
      l = e.renderItemWrapper,
      s = be(g).bricks,
      d = be(n),
      u = d.values,
      m = d.parentId,
      p = d.parentType,
      f = d.handleChange,
      b = d.handleAddItem,
      h = d.contentRef,
      x = be(a),
      v = x.focused,
      y = x.setFocused,
      w = x.setAddAfterBlockId,
      k = be(ln).previewMode,
      E = u[t];
  if (he(function () {
    var e,
        n,
        r = null === (n = null === (e = s[p].schema) || void 0 === e ? void 0 : e.repeaterItems) || void 0 === n ? void 0 : n.find(function (e) {
      return e.name === t;
    });
    r && r.min && (!E || E.length < r.min) && b && b(m, t, r.itemType)();
  }, [m, t, E]), !E || 0 === E.length) return null;
  var C = pe.createElement(pe.Fragment, null, E.map(function (e, r) {
    var a = s[e.type];

    if (a) {
      var i = a.schema.sideEditProps ? a.schema.sideEditProps.reduce(function (t, n) {
        var r, a;
        return n.groupName ? a = n.props.map(function (t) {
          var n;
          return (n = {})[t.name] = e.props[t.name], n;
        }).reduce(function (e, t) {
          return c(c({}, e), t);
        }, {}) : ((r = {})[n.name] = e.props[n.name], a = r), c(c({}, t), a);
      }, {}) : {},
          d = c(c(c({}, i), o), {
        key: e.id,
        index: r,
        style: {
          outline: e.id !== v.itemId || k ? "none" : "2px solid #fb83a3"
        },
        onClick: function onClick(n) {
          n.stopPropagation(), y({
            blockId: m,
            itemId: e.id,
            repeaterPropName: t
          }), w("");
        },
        onFocus: function onFocus(n) {
          n.stopPropagation(), setTimeout(function () {
            y({
              blockId: m,
              itemId: e.id,
              repeaterPropName: t
            }), w("");
          }, 0);
        },
        onChange: function onChange() {}
      }),
          u = pe.createElement(n.Provider, {
        key: e.id,
        value: {
          onChange: f(e.id, m, t),
          values: e.props,
          blockId: e.id,
          parentId: m,
          contentRef: h,
          parentType: p,
          handleChange: f
        }
      }, pe.createElement(a, c({}, d)));
      return l ? l(u, r, E.length) : u;
    }
  }));
  return i ? i(C) : C;
}, ce.prototype.renderAdmin = In, se.prototype.renderAdmin = function (t) {
  var r = t.allowedExtensions,
      a = void 0 === r ? [] : r,
      o = t.propName,
      i = t.renderBlock,
      l = be(n),
      c = l.values,
      s = l.onChange,
      d = be(ln),
      u = d.isAdmin,
      m = d.previewMode,
      p = e(ye(!1), 2),
      g = p[0],
      f = p[1],
      b = c[o],
      h = xe(function (e) {
    var t = ge.Children.toArray(i(e).props.children);
    return t.push(ge.createElement("div", {
      key: "click interceptor",
      style: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      },
      onClick: function onClick(e) {
        e.preventDefault(), e.stopPropagation(), f(!0);
      }
    })), ge.cloneElement(i(e), {
      style: {
        position: "relative",
        cursor: "pointer"
      },
      children: t
    });
  }, [c]);
  return m || !u ? i(b) : ge.createElement(ge.Fragment, null, h(b), g && ge.createElement(gr, {
    setModalOpen: f,
    modalOpen: g,
    onChange: function onChange(e) {
      s(o, e);
    },
    allowedExtensions: a,
    file: b
  }));
}, de.prototype.useAdmin = function () {
  var e = be(ln);
  return {
    isAdmin: e.isAdmin,
    previewMode: e.previewMode,
    currentPage: e.currentPage
  };
}, ue.prototype.useAdmin = function (e) {
  var t = be(ln),
      r = t.isAdmin,
      a = t.previewMode,
      o = be(n),
      i = o.values,
      l = o.onChange,
      c = a || !r;
  return [i[e], function (t) {
    return l(e, t);
  }, c];
}, ee.prototype.adminConstructor = Rn, te.prototype.adminConstructor = hn, Object.keys(ne).forEach(function (e) {
  Hn[e] && Object.assign(ne[e], Hn[e]);
}), console.log("Loading the Admin bundle...");
export { Ba as Admin, ln as AdminContext, xa as AppSettings, ua as Editor, Sa as Header, Pa as Login, fa as Playground, Na as useAuth };